const provinces = () => {
	return [{
			"name": "北京市",
			"id": "110000",
			"child": [{
				"name": "市辖区",
				"id": "110100",
				"child": [{
					"name": "朝阳区",
					"id": "110105",
					"child": []
				}, {
					"name": "怀柔区",
					"id": "110116",
					"child": []
				}, {
					"name": "丰台区",
					"id": "110106",
					"child": []
				}, {
					"name": "平谷区",
					"id": "110117",
					"child": []
				}, {
					"name": "昌平区",
					"id": "110114",
					"child": []
				}, {
					"name": "大兴区",
					"id": "110115",
					"child": []
				}, {
					"name": "东城区",
					"id": "110101",
					"child": []
				}, {
					"name": "通州区",
					"id": "110112",
					"child": []
				}, {
					"name": "西城区",
					"id": "110102",
					"child": []
				}, {
					"name": "顺义区",
					"id": "110113",
					"child": []
				}, {
					"name": "房山区",
					"id": "110111",
					"child": []
				}, {
					"name": "门头沟区",
					"id": "110109",
					"child": []
				}, {
					"name": "石景山区",
					"id": "110107",
					"child": []
				}, {
					"name": "密云区",
					"id": "110118",
					"child": []
				}, {
					"name": "海淀区",
					"id": "110108",
					"child": []
				}, {
					"name": "延庆区",
					"id": "110119",
					"child": []
				}]
			}]
		},
		{
			"name": "江苏省",
			"id": "320000",
			"child": [{
				"name": "扬州市",
				"id": "321000",
				"child": [{
					"name": "市辖区",
					"id": "321001",
					"child": []
				}, {
					"name": "江都区",
					"id": "321012",
					"child": []
				}, {
					"name": "宝应县",
					"id": "321023",
					"child": []
				}, {
					"name": "高邮市",
					"id": "321084",
					"child": []
				}, {
					"name": "仪征市",
					"id": "321081",
					"child": []
				}, {
					"name": "广陵区",
					"id": "321002",
					"child": []
				}, {
					"name": "邗江区",
					"id": "321003",
					"child": []
				}]
			}, {
				"name": "镇江市",
				"id": "321100",
				"child": [{
					"name": "润州区",
					"id": "321111",
					"child": []
				}, {
					"name": "句容市",
					"id": "321183",
					"child": []
				}, {
					"name": "丹阳市",
					"id": "321181",
					"child": []
				}, {
					"name": "扬中市",
					"id": "321182",
					"child": []
				}, {
					"name": "市辖区",
					"id": "321101",
					"child": []
				}, {
					"name": "丹徒区",
					"id": "321112",
					"child": []
				}, {
					"name": "京口区",
					"id": "321102",
					"child": []
				}]
			}, {
				"name": "盐城市",
				"id": "320900",
				"child": [{
					"name": "大丰区",
					"id": "320904",
					"child": []
				}, {
					"name": "亭湖区",
					"id": "320902",
					"child": []
				}, {
					"name": "射阳县",
					"id": "320924",
					"child": []
				}, {
					"name": "盐都区",
					"id": "320903",
					"child": []
				}, {
					"name": "建湖县",
					"id": "320925",
					"child": []
				}, {
					"name": "滨海县",
					"id": "320922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320901",
					"child": []
				}, {
					"name": "阜宁县",
					"id": "320923",
					"child": []
				}, {
					"name": "响水县",
					"id": "320921",
					"child": []
				}, {
					"name": "东台市",
					"id": "320981",
					"child": []
				}]
			}, {
				"name": "连云港市",
				"id": "320700",
				"child": [{
					"name": "海州区",
					"id": "320706",
					"child": []
				}, {
					"name": "赣榆区",
					"id": "320707",
					"child": []
				}, {
					"name": "灌南县",
					"id": "320724",
					"child": []
				}, {
					"name": "连云区",
					"id": "320703",
					"child": []
				}, {
					"name": "东海县",
					"id": "320722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320701",
					"child": []
				}, {
					"name": "灌云县",
					"id": "320723",
					"child": []
				}]
			}, {
				"name": "淮安市",
				"id": "320800",
				"child": [{
					"name": "淮安区",
					"id": "320803",
					"child": []
				}, {
					"name": "淮阴区",
					"id": "320804",
					"child": []
				}, {
					"name": "涟水县",
					"id": "320826",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320801",
					"child": []
				}, {
					"name": "清江浦区",
					"id": "320812",
					"child": []
				}, {
					"name": "洪泽区",
					"id": "320813",
					"child": []
				}, {
					"name": "盱眙县",
					"id": "320830",
					"child": []
				}, {
					"name": "金湖县",
					"id": "320831",
					"child": []
				}]
			}, {
				"name": "苏州市",
				"id": "320500",
				"child": [{
					"name": "张家港市",
					"id": "320582",
					"child": []
				}, {
					"name": "昆山市",
					"id": "320583",
					"child": []
				}, {
					"name": "姑苏区",
					"id": "320508",
					"child": []
				}, {
					"name": "吴江区",
					"id": "320509",
					"child": []
				}, {
					"name": "常熟市",
					"id": "320581",
					"child": []
				}, {
					"name": "吴中区",
					"id": "320506",
					"child": []
				}, {
					"name": "相城区",
					"id": "320507",
					"child": []
				}, {
					"name": "虎丘区",
					"id": "320505",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320501",
					"child": []
				}, {
					"name": "太仓市",
					"id": "320585",
					"child": []
				}]
			}, {
				"name": "南通市",
				"id": "320600",
				"child": [{
					"name": "启东市",
					"id": "320681",
					"child": []
				}, {
					"name": "如皋市",
					"id": "320682",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320601",
					"child": []
				}, {
					"name": "通州区",
					"id": "320612",
					"child": []
				}, {
					"name": "如东县",
					"id": "320623",
					"child": []
				}, {
					"name": "崇川区",
					"id": "320602",
					"child": []
				}, {
					"name": "海安县",
					"id": "320621",
					"child": []
				}, {
					"name": "港闸区",
					"id": "320611",
					"child": []
				}, {
					"name": "海门市",
					"id": "320684",
					"child": []
				}]
			}, {
				"name": "徐州市",
				"id": "320300",
				"child": [{
					"name": "邳州市",
					"id": "320382",
					"child": []
				}, {
					"name": "新沂市",
					"id": "320381",
					"child": []
				}, {
					"name": "贾汪区",
					"id": "320305",
					"child": []
				}, {
					"name": "鼓楼区",
					"id": "320302",
					"child": []
				}, {
					"name": "睢宁县",
					"id": "320324",
					"child": []
				}, {
					"name": "云龙区",
					"id": "320303",
					"child": []
				}, {
					"name": "泉山区",
					"id": "320311",
					"child": []
				}, {
					"name": "沛县",
					"id": "320322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320301",
					"child": []
				}, {
					"name": "铜山区",
					"id": "320312",
					"child": []
				}, {
					"name": "丰县",
					"id": "320321",
					"child": []
				}]
			}, {
				"name": "常州市",
				"id": "320400",
				"child": [{
					"name": "溧阳市",
					"id": "320481",
					"child": []
				}, {
					"name": "钟楼区",
					"id": "320404",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320401",
					"child": []
				}, {
					"name": "武进区",
					"id": "320412",
					"child": []
				}, {
					"name": "天宁区",
					"id": "320402",
					"child": []
				}, {
					"name": "金坛区",
					"id": "320413",
					"child": []
				}, {
					"name": "新北区",
					"id": "320411",
					"child": []
				}]
			}, {
				"name": "南京市",
				"id": "320100",
				"child": [{
					"name": "鼓楼区",
					"id": "320106",
					"child": []
				}, {
					"name": "溧水区",
					"id": "320117",
					"child": []
				}, {
					"name": "高淳区",
					"id": "320118",
					"child": []
				}, {
					"name": "秦淮区",
					"id": "320104",
					"child": []
				}, {
					"name": "江宁区",
					"id": "320115",
					"child": []
				}, {
					"name": "建邺区",
					"id": "320105",
					"child": []
				}, {
					"name": "六合区",
					"id": "320116",
					"child": []
				}, {
					"name": "玄武区",
					"id": "320102",
					"child": []
				}, {
					"name": "栖霞区",
					"id": "320113",
					"child": []
				}, {
					"name": "雨花台区",
					"id": "320114",
					"child": []
				}, {
					"name": "浦口区",
					"id": "320111",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320101",
					"child": []
				}]
			}, {
				"name": "泰州市",
				"id": "321200",
				"child": [{
					"name": "靖江市",
					"id": "321282",
					"child": []
				}, {
					"name": "泰兴市",
					"id": "321283",
					"child": []
				}, {
					"name": "兴化市",
					"id": "321281",
					"child": []
				}, {
					"name": "姜堰区",
					"id": "321204",
					"child": []
				}, {
					"name": "海陵区",
					"id": "321202",
					"child": []
				}, {
					"name": "高港区",
					"id": "321203",
					"child": []
				}, {
					"name": "市辖区",
					"id": "321201",
					"child": []
				}]
			}, {
				"name": "无锡市",
				"id": "320200",
				"child": [{
					"name": "江阴市",
					"id": "320281",
					"child": []
				}, {
					"name": "宜兴市",
					"id": "320282",
					"child": []
				}, {
					"name": "锡山区",
					"id": "320205",
					"child": []
				}, {
					"name": "惠山区",
					"id": "320206",
					"child": []
				}, {
					"name": "新吴区",
					"id": "320214",
					"child": []
				}, {
					"name": "市辖区",
					"id": "320201",
					"child": []
				}, {
					"name": "梁溪区",
					"id": "320213",
					"child": []
				}, {
					"name": "滨湖区",
					"id": "320211",
					"child": []
				}]
			}, {
				"name": "宿迁市",
				"id": "321300",
				"child": [{
					"name": "市辖区",
					"id": "321301",
					"child": []
				}, {
					"name": "泗阳县",
					"id": "321323",
					"child": []
				}, {
					"name": "宿城区",
					"id": "321302",
					"child": []
				}, {
					"name": "泗洪县",
					"id": "321324",
					"child": []
				}, {
					"name": "宿豫区",
					"id": "321311",
					"child": []
				}, {
					"name": "沭阳县",
					"id": "321322",
					"child": []
				}]
			}]
		}, {
			"name": "山东省",
			"id": "370000",
			"child": [{
				"name": "莱芜市",
				"id": "371200",
				"child": [{
					"name": "莱城区",
					"id": "371202",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371201",
					"child": []
				}, {
					"name": "钢城区",
					"id": "371203",
					"child": []
				}]
			}, {
				"name": "济南市",
				"id": "370100",
				"child": [{
					"name": "市辖区",
					"id": "370101",
					"child": []
				}, {
					"name": "历城区",
					"id": "370112",
					"child": []
				}, {
					"name": "历下区",
					"id": "370102",
					"child": []
				}, {
					"name": "长清区",
					"id": "370113",
					"child": []
				}, {
					"name": "平阴县",
					"id": "370124",
					"child": []
				}, {
					"name": "章丘市",
					"id": "370181",
					"child": []
				}, {
					"name": "市中区",
					"id": "370103",
					"child": []
				}, {
					"name": "济阳县",
					"id": "370125",
					"child": []
				}, {
					"name": "槐荫区",
					"id": "370104",
					"child": []
				}, {
					"name": "商河县",
					"id": "370126",
					"child": []
				}, {
					"name": "天桥区",
					"id": "370105",
					"child": []
				}]
			}, {
				"name": "日照市",
				"id": "371100",
				"child": [{
					"name": "市辖区",
					"id": "371101",
					"child": []
				}, {
					"name": "莒县",
					"id": "371122",
					"child": []
				}, {
					"name": "岚山区",
					"id": "371103",
					"child": []
				}, {
					"name": "东港区",
					"id": "371102",
					"child": []
				}, {
					"name": "五莲县",
					"id": "371121",
					"child": []
				}]
			}, {
				"name": "青岛市",
				"id": "370200",
				"child": [{
					"name": "黄岛区",
					"id": "370211",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370201",
					"child": []
				}, {
					"name": "崂山区",
					"id": "370212",
					"child": []
				}, {
					"name": "即墨市",
					"id": "370282",
					"child": []
				}, {
					"name": "平度市",
					"id": "370283",
					"child": []
				}, {
					"name": "莱西市",
					"id": "370285",
					"child": []
				}, {
					"name": "胶州市",
					"id": "370281",
					"child": []
				}, {
					"name": "市南区",
					"id": "370202",
					"child": []
				}, {
					"name": "李沧区",
					"id": "370213",
					"child": []
				}, {
					"name": "市北区",
					"id": "370203",
					"child": []
				}, {
					"name": "城阳区",
					"id": "370214",
					"child": []
				}]
			}, {
				"name": "德州市",
				"id": "371400",
				"child": [{
					"name": "宁津县",
					"id": "371422",
					"child": []
				}, {
					"name": "禹城市",
					"id": "371482",
					"child": []
				}, {
					"name": "乐陵市",
					"id": "371481",
					"child": []
				}, {
					"name": "武城县",
					"id": "371428",
					"child": []
				}, {
					"name": "夏津县",
					"id": "371427",
					"child": []
				}, {
					"name": "德城区",
					"id": "371402",
					"child": []
				}, {
					"name": "临邑县",
					"id": "371424",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371401",
					"child": []
				}, {
					"name": "庆云县",
					"id": "371423",
					"child": []
				}, {
					"name": "平原县",
					"id": "371426",
					"child": []
				}, {
					"name": "陵城区",
					"id": "371403",
					"child": []
				}, {
					"name": "齐河县",
					"id": "371425",
					"child": []
				}]
			}, {
				"name": "淄博市",
				"id": "370300",
				"child": [{
					"name": "桓台县",
					"id": "370321",
					"child": []
				}, {
					"name": "高青县",
					"id": "370322",
					"child": []
				}, {
					"name": "临淄区",
					"id": "370305",
					"child": []
				}, {
					"name": "周村区",
					"id": "370306",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370301",
					"child": []
				}, {
					"name": "沂源县",
					"id": "370323",
					"child": []
				}, {
					"name": "淄川区",
					"id": "370302",
					"child": []
				}, {
					"name": "张店区",
					"id": "370303",
					"child": []
				}, {
					"name": "博山区",
					"id": "370304",
					"child": []
				}]
			}, {
				"name": "临沂市",
				"id": "371300",
				"child": [{
					"name": "沂南县",
					"id": "371321",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371301",
					"child": []
				}, {
					"name": "河东区",
					"id": "371312",
					"child": []
				}, {
					"name": "沂水县",
					"id": "371323",
					"child": []
				}, {
					"name": "罗庄区",
					"id": "371311",
					"child": []
				}, {
					"name": "郯城县",
					"id": "371322",
					"child": []
				}, {
					"name": "临沭县",
					"id": "371329",
					"child": []
				}, {
					"name": "蒙阴县",
					"id": "371328",
					"child": []
				}, {
					"name": "费县",
					"id": "371325",
					"child": []
				}, {
					"name": "兰山区",
					"id": "371302",
					"child": []
				}, {
					"name": "兰陵县",
					"id": "371324",
					"child": []
				}, {
					"name": "莒南县",
					"id": "371327",
					"child": []
				}, {
					"name": "平邑县",
					"id": "371326",
					"child": []
				}]
			}, {
				"name": "威海市",
				"id": "371000",
				"child": [{
					"name": "环翠区",
					"id": "371002",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371001",
					"child": []
				}, {
					"name": "文登区",
					"id": "371003",
					"child": []
				}, {
					"name": "荣成市",
					"id": "371082",
					"child": []
				}, {
					"name": "乳山市",
					"id": "371083",
					"child": []
				}]
			}, {
				"name": "济宁市",
				"id": "370800",
				"child": [{
					"name": "曲阜市",
					"id": "370881",
					"child": []
				}, {
					"name": "邹城市",
					"id": "370883",
					"child": []
				}, {
					"name": "微山县",
					"id": "370826",
					"child": []
				}, {
					"name": "鱼台县",
					"id": "370827",
					"child": []
				}, {
					"name": "金乡县",
					"id": "370828",
					"child": []
				}, {
					"name": "嘉祥县",
					"id": "370829",
					"child": []
				}, {
					"name": "任城区",
					"id": "370811",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370801",
					"child": []
				}, {
					"name": "兖州区",
					"id": "370812",
					"child": []
				}, {
					"name": "汶上县",
					"id": "370830",
					"child": []
				}, {
					"name": "泗水县",
					"id": "370831",
					"child": []
				}, {
					"name": "梁山县",
					"id": "370832",
					"child": []
				}]
			}, {
				"name": "泰安市",
				"id": "370900",
				"child": [{
					"name": "新泰市",
					"id": "370982",
					"child": []
				}, {
					"name": "宁阳县",
					"id": "370921",
					"child": []
				}, {
					"name": "岱岳区",
					"id": "370911",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370901",
					"child": []
				}, {
					"name": "东平县",
					"id": "370923",
					"child": []
				}, {
					"name": "泰山区",
					"id": "370902",
					"child": []
				}, {
					"name": "肥城市",
					"id": "370983",
					"child": []
				}]
			}, {
				"name": "枣庄市",
				"id": "370400",
				"child": [{
					"name": "滕州市",
					"id": "370481",
					"child": []
				}, {
					"name": "峄城区",
					"id": "370404",
					"child": []
				}, {
					"name": "台儿庄区",
					"id": "370405",
					"child": []
				}, {
					"name": "山亭区",
					"id": "370406",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370401",
					"child": []
				}, {
					"name": "市中区",
					"id": "370402",
					"child": []
				}, {
					"name": "薛城区",
					"id": "370403",
					"child": []
				}]
			}, {
				"name": "滨州市",
				"id": "371600",
				"child": [{
					"name": "邹平县",
					"id": "371626",
					"child": []
				}, {
					"name": "沾化区",
					"id": "371603",
					"child": []
				}, {
					"name": "博兴县",
					"id": "371625",
					"child": []
				}, {
					"name": "阳信县",
					"id": "371622",
					"child": []
				}, {
					"name": "惠民县",
					"id": "371621",
					"child": []
				}, {
					"name": "滨城区",
					"id": "371602",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371601",
					"child": []
				}, {
					"name": "无棣县",
					"id": "371623",
					"child": []
				}]
			}, {
				"name": "东营市",
				"id": "370500",
				"child": [{
					"name": "河口区",
					"id": "370503",
					"child": []
				}, {
					"name": "垦利区",
					"id": "370505",
					"child": []
				}, {
					"name": "利津县",
					"id": "370522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370501",
					"child": []
				}, {
					"name": "广饶县",
					"id": "370523",
					"child": []
				}, {
					"name": "东营区",
					"id": "370502",
					"child": []
				}]
			}, {
				"name": "聊城市",
				"id": "371500",
				"child": [{
					"name": "阳谷县",
					"id": "371521",
					"child": []
				}, {
					"name": "临清市",
					"id": "371581",
					"child": []
				}, {
					"name": "高唐县",
					"id": "371526",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371501",
					"child": []
				}, {
					"name": "茌平县",
					"id": "371523",
					"child": []
				}, {
					"name": "莘县",
					"id": "371522",
					"child": []
				}, {
					"name": "冠县",
					"id": "371525",
					"child": []
				}, {
					"name": "东昌府区",
					"id": "371502",
					"child": []
				}, {
					"name": "东阿县",
					"id": "371524",
					"child": []
				}]
			}, {
				"name": "烟台市",
				"id": "370600",
				"child": [{
					"name": "莱阳市",
					"id": "370682",
					"child": []
				}, {
					"name": "莱州市",
					"id": "370683",
					"child": []
				}, {
					"name": "蓬莱市",
					"id": "370684",
					"child": []
				}, {
					"name": "招远市",
					"id": "370685",
					"child": []
				}, {
					"name": "龙口市",
					"id": "370681",
					"child": []
				}, {
					"name": "芝罘区",
					"id": "370602",
					"child": []
				}, {
					"name": "莱山区",
					"id": "370613",
					"child": []
				}, {
					"name": "栖霞市",
					"id": "370686",
					"child": []
				}, {
					"name": "海阳市",
					"id": "370687",
					"child": []
				}, {
					"name": "福山区",
					"id": "370611",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370601",
					"child": []
				}, {
					"name": "牟平区",
					"id": "370612",
					"child": []
				}, {
					"name": "长岛县",
					"id": "370634",
					"child": []
				}]
			}, {
				"name": "潍坊市",
				"id": "370700",
				"child": [{
					"name": "青州市",
					"id": "370781",
					"child": []
				}, {
					"name": "诸城市",
					"id": "370782",
					"child": []
				}, {
					"name": "寿光市",
					"id": "370783",
					"child": []
				}, {
					"name": "安丘市",
					"id": "370784",
					"child": []
				}, {
					"name": "市辖区",
					"id": "370701",
					"child": []
				}, {
					"name": "潍城区",
					"id": "370702",
					"child": []
				}, {
					"name": "临朐县",
					"id": "370724",
					"child": []
				}, {
					"name": "寒亭区",
					"id": "370703",
					"child": []
				}, {
					"name": "昌乐县",
					"id": "370725",
					"child": []
				}, {
					"name": "坊子区",
					"id": "370704",
					"child": []
				}, {
					"name": "高密市",
					"id": "370785",
					"child": []
				}, {
					"name": "昌邑市",
					"id": "370786",
					"child": []
				}, {
					"name": "奎文区",
					"id": "370705",
					"child": []
				}]
			}, {
				"name": "菏泽市",
				"id": "371700",
				"child": [{
					"name": "东明县",
					"id": "371728",
					"child": []
				}, {
					"name": "定陶区",
					"id": "371703",
					"child": []
				}, {
					"name": "郓城县",
					"id": "371725",
					"child": []
				}, {
					"name": "牡丹区",
					"id": "371702",
					"child": []
				}, {
					"name": "巨野县",
					"id": "371724",
					"child": []
				}, {
					"name": "鄄城县",
					"id": "371726",
					"child": []
				}, {
					"name": "曹县",
					"id": "371721",
					"child": []
				}, {
					"name": "市辖区",
					"id": "371701",
					"child": []
				}, {
					"name": "成武县",
					"id": "371723",
					"child": []
				}, {
					"name": "单县",
					"id": "371722",
					"child": []
				}]
			}]
		},
		{
			"name": "甘肃省",
			"id": "620000",
			"child": [{
				"name": "陇南市",
				"id": "621200",
				"child": [{
					"name": "文县",
					"id": "621222",
					"child": []
				}, {
					"name": "成县",
					"id": "621221",
					"child": []
				}, {
					"name": "武都区",
					"id": "621202",
					"child": []
				}, {
					"name": "康县",
					"id": "621224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "621201",
					"child": []
				}, {
					"name": "宕昌县",
					"id": "621223",
					"child": []
				}, {
					"name": "礼县",
					"id": "621226",
					"child": []
				}, {
					"name": "西和县",
					"id": "621225",
					"child": []
				}, {
					"name": "两当县",
					"id": "621228",
					"child": []
				}, {
					"name": "徽县",
					"id": "621227",
					"child": []
				}]
			}, {
				"name": "兰州市",
				"id": "620100",
				"child": [{
					"name": "永登县",
					"id": "620121",
					"child": []
				}, {
					"name": "红古区",
					"id": "620111",
					"child": []
				}, {
					"name": "皋兰县",
					"id": "620122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620101",
					"child": []
				}, {
					"name": "榆中县",
					"id": "620123",
					"child": []
				}, {
					"name": "城关区",
					"id": "620102",
					"child": []
				}, {
					"name": "七里河区",
					"id": "620103",
					"child": []
				}, {
					"name": "西固区",
					"id": "620104",
					"child": []
				}, {
					"name": "安宁区",
					"id": "620105",
					"child": []
				}]
			}, {
				"name": "定西市",
				"id": "621100",
				"child": [{
					"name": "市辖区",
					"id": "621101",
					"child": []
				}, {
					"name": "渭源县",
					"id": "621123",
					"child": []
				}, {
					"name": "陇西县",
					"id": "621122",
					"child": []
				}, {
					"name": "漳县",
					"id": "621125",
					"child": []
				}, {
					"name": "安定区",
					"id": "621102",
					"child": []
				}, {
					"name": "临洮县",
					"id": "621124",
					"child": []
				}, {
					"name": "通渭县",
					"id": "621121",
					"child": []
				}, {
					"name": "岷县",
					"id": "621126",
					"child": []
				}]
			}, {
				"name": "嘉峪关市",
				"id": "620200",
				"child": [{
					"name": "市辖区",
					"id": "620201",
					"child": []
				}]
			}, {
				"name": "金昌市",
				"id": "620300",
				"child": [{
					"name": "永昌县",
					"id": "620321",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620301",
					"child": []
				}, {
					"name": "金川区",
					"id": "620302",
					"child": []
				}]
			}, {
				"name": "庆阳市",
				"id": "621000",
				"child": [{
					"name": "西峰区",
					"id": "621002",
					"child": []
				}, {
					"name": "合水县",
					"id": "621024",
					"child": []
				}, {
					"name": "市辖区",
					"id": "621001",
					"child": []
				}, {
					"name": "华池县",
					"id": "621023",
					"child": []
				}, {
					"name": "宁县",
					"id": "621026",
					"child": []
				}, {
					"name": "正宁县",
					"id": "621025",
					"child": []
				}, {
					"name": "环县",
					"id": "621022",
					"child": []
				}, {
					"name": "庆城县",
					"id": "621021",
					"child": []
				}, {
					"name": "镇原县",
					"id": "621027",
					"child": []
				}]
			}, {
				"name": "甘南藏族自治州",
				"id": "623000",
				"child": [{
					"name": "夏河县",
					"id": "623027",
					"child": []
				}, {
					"name": "玛曲县",
					"id": "623025",
					"child": []
				}, {
					"name": "碌曲县",
					"id": "623026",
					"child": []
				}, {
					"name": "合作市",
					"id": "623001",
					"child": []
				}, {
					"name": "舟曲县",
					"id": "623023",
					"child": []
				}, {
					"name": "迭部县",
					"id": "623024",
					"child": []
				}, {
					"name": "临潭县",
					"id": "623021",
					"child": []
				}, {
					"name": "卓尼县",
					"id": "623022",
					"child": []
				}]
			}, {
				"name": "平凉市",
				"id": "620800",
				"child": [{
					"name": "静宁县",
					"id": "620826",
					"child": []
				}, {
					"name": "灵台县",
					"id": "620822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620801",
					"child": []
				}, {
					"name": "崇信县",
					"id": "620823",
					"child": []
				}, {
					"name": "崆峒区",
					"id": "620802",
					"child": []
				}, {
					"name": "华亭县",
					"id": "620824",
					"child": []
				}, {
					"name": "庄浪县",
					"id": "620825",
					"child": []
				}, {
					"name": "泾川县",
					"id": "620821",
					"child": []
				}]
			}, {
				"name": "酒泉市",
				"id": "620900",
				"child": [{
					"name": "玉门市",
					"id": "620981",
					"child": []
				}, {
					"name": "敦煌市",
					"id": "620982",
					"child": []
				}, {
					"name": "金塔县",
					"id": "620921",
					"child": []
				}, {
					"name": "瓜州县",
					"id": "620922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620901",
					"child": []
				}, {
					"name": "肃北蒙古族自治县",
					"id": "620923",
					"child": []
				}, {
					"name": "肃州区",
					"id": "620902",
					"child": []
				}, {
					"name": "阿克塞哈萨克族自治县",
					"id": "620924",
					"child": []
				}]
			}, {
				"name": "白银市",
				"id": "620400",
				"child": [{
					"name": "靖远县",
					"id": "620421",
					"child": []
				}, {
					"name": "会宁县",
					"id": "620422",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620401",
					"child": []
				}, {
					"name": "景泰县",
					"id": "620423",
					"child": []
				}, {
					"name": "白银区",
					"id": "620402",
					"child": []
				}, {
					"name": "平川区",
					"id": "620403",
					"child": []
				}]
			}, {
				"name": "天水市",
				"id": "620500",
				"child": [{
					"name": "麦积区",
					"id": "620503",
					"child": []
				}, {
					"name": "张家川回族自治县",
					"id": "620525",
					"child": []
				}, {
					"name": "清水县",
					"id": "620521",
					"child": []
				}, {
					"name": "秦安县",
					"id": "620522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620501",
					"child": []
				}, {
					"name": "甘谷县",
					"id": "620523",
					"child": []
				}, {
					"name": "秦州区",
					"id": "620502",
					"child": []
				}, {
					"name": "武山县",
					"id": "620524",
					"child": []
				}]
			}, {
				"name": "武威市",
				"id": "620600",
				"child": [{
					"name": "凉州区",
					"id": "620602",
					"child": []
				}, {
					"name": "民勤县",
					"id": "620621",
					"child": []
				}, {
					"name": "古浪县",
					"id": "620622",
					"child": []
				}, {
					"name": "市辖区",
					"id": "620601",
					"child": []
				}, {
					"name": "天祝藏族自治县",
					"id": "620623",
					"child": []
				}]
			}, {
				"name": "临夏回族自治州",
				"id": "622900",
				"child": [{
					"name": "积石山保安族东乡族撒拉族自治县",
					"id": "622927",
					"child": []
				}, {
					"name": "广河县",
					"id": "622924",
					"child": []
				}, {
					"name": "临夏市",
					"id": "622901",
					"child": []
				}, {
					"name": "永靖县",
					"id": "622923",
					"child": []
				}, {
					"name": "东乡族自治县",
					"id": "622926",
					"child": []
				}, {
					"name": "和政县",
					"id": "622925",
					"child": []
				}, {
					"name": "康乐县",
					"id": "622922",
					"child": []
				}, {
					"name": "临夏县",
					"id": "622921",
					"child": []
				}]
			}, {
				"name": "张掖市",
				"id": "620700",
				"child": [{
					"name": "市辖区",
					"id": "620701",
					"child": []
				}, {
					"name": "临泽县",
					"id": "620723",
					"child": []
				}, {
					"name": "甘州区",
					"id": "620702",
					"child": []
				}, {
					"name": "高台县",
					"id": "620724",
					"child": []
				}, {
					"name": "山丹县",
					"id": "620725",
					"child": []
				}, {
					"name": "肃南裕固族自治县",
					"id": "620721",
					"child": []
				}, {
					"name": "民乐县",
					"id": "620722",
					"child": []
				}]
			}]
		},
		{
			"name": "云南省",
			"id": "530000",
			"child": [{
				"name": "楚雄彝族自治州",
				"id": "532300",
				"child": [{
					"name": "武定县",
					"id": "532329",
					"child": []
				}, {
					"name": "元谋县",
					"id": "532328",
					"child": []
				}, {
					"name": "永仁县",
					"id": "532327",
					"child": []
				}, {
					"name": "大姚县",
					"id": "532326",
					"child": []
				}, {
					"name": "姚安县",
					"id": "532325",
					"child": []
				}, {
					"name": "南华县",
					"id": "532324",
					"child": []
				}, {
					"name": "楚雄市",
					"id": "532301",
					"child": []
				}, {
					"name": "牟定县",
					"id": "532323",
					"child": []
				}, {
					"name": "双柏县",
					"id": "532322",
					"child": []
				}, {
					"name": "禄丰县",
					"id": "532331",
					"child": []
				}]
			}, {
				"name": "迪庆藏族自治州",
				"id": "533400",
				"child": [{
					"name": "香格里拉市",
					"id": "533401",
					"child": []
				}, {
					"name": "维西傈僳族自治县",
					"id": "533423",
					"child": []
				}, {
					"name": "德钦县",
					"id": "533422",
					"child": []
				}]
			}, {
				"name": "昆明市",
				"id": "530100",
				"child": [{
					"name": "官渡区",
					"id": "530111",
					"child": []
				}, {
					"name": "晋宁县",
					"id": "530122",
					"child": []
				}, {
					"name": "安宁市",
					"id": "530181",
					"child": []
				}, {
					"name": "寻甸回族彝族自治县",
					"id": "530129",
					"child": []
				}, {
					"name": "嵩明县",
					"id": "530127",
					"child": []
				}, {
					"name": "禄劝彝族苗族自治县",
					"id": "530128",
					"child": []
				}, {
					"name": "盘龙区",
					"id": "530103",
					"child": []
				}, {
					"name": "呈贡区",
					"id": "530114",
					"child": []
				}, {
					"name": "宜良县",
					"id": "530125",
					"child": []
				}, {
					"name": "石林彝族自治县",
					"id": "530126",
					"child": []
				}, {
					"name": "市辖区",
					"id": "530101",
					"child": []
				}, {
					"name": "西山区",
					"id": "530112",
					"child": []
				}, {
					"name": "五华区",
					"id": "530102",
					"child": []
				}, {
					"name": "东川区",
					"id": "530113",
					"child": []
				}, {
					"name": "富民县",
					"id": "530124",
					"child": []
				}]
			}, {
				"name": "怒江傈僳族自治州",
				"id": "533300",
				"child": [{
					"name": "兰坪白族普米族自治县",
					"id": "533325",
					"child": []
				}, {
					"name": "贡山独龙族怒族自治县",
					"id": "533324",
					"child": []
				}, {
					"name": "泸水市",
					"id": "533301",
					"child": []
				}, {
					"name": "福贡县",
					"id": "533323",
					"child": []
				}]
			}, {
				"name": "德宏傣族景颇族自治州",
				"id": "533100",
				"child": [{
					"name": "芒市",
					"id": "533103",
					"child": []
				}, {
					"name": "瑞丽市",
					"id": "533102",
					"child": []
				}, {
					"name": "陇川县",
					"id": "533124",
					"child": []
				}, {
					"name": "盈江县",
					"id": "533123",
					"child": []
				}, {
					"name": "梁河县",
					"id": "533122",
					"child": []
				}]
			}, {
				"name": "普洱市",
				"id": "530800",
				"child": [{
					"name": "墨江哈尼族自治县",
					"id": "530822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "530801",
					"child": []
				}, {
					"name": "景东彝族自治县",
					"id": "530823",
					"child": []
				}, {
					"name": "宁洱哈尼族彝族自治县",
					"id": "530821",
					"child": []
				}, {
					"name": "澜沧拉祜族自治县",
					"id": "530828",
					"child": []
				}, {
					"name": "西盟佤族自治县",
					"id": "530829",
					"child": []
				}, {
					"name": "江城哈尼族彝族自治县",
					"id": "530826",
					"child": []
				}, {
					"name": "孟连傣族拉祜族佤族自治县",
					"id": "530827",
					"child": []
				}, {
					"name": "思茅区",
					"id": "530802",
					"child": []
				}, {
					"name": "景谷傣族彝族自治县",
					"id": "530824",
					"child": []
				}, {
					"name": "镇沅彝族哈尼族拉祜族自治县",
					"id": "530825",
					"child": []
				}]
			}, {
				"name": "临沧市",
				"id": "530900",
				"child": [{
					"name": "凤庆县",
					"id": "530921",
					"child": []
				}, {
					"name": "云县",
					"id": "530922",
					"child": []
				}, {
					"name": "沧源佤族自治县",
					"id": "530927",
					"child": []
				}, {
					"name": "双江拉祜族佤族布朗族傣族自治县",
					"id": "530925",
					"child": []
				}, {
					"name": "耿马傣族佤族自治县",
					"id": "530926",
					"child": []
				}, {
					"name": "市辖区",
					"id": "530901",
					"child": []
				}, {
					"name": "永德县",
					"id": "530923",
					"child": []
				}, {
					"name": "临翔区",
					"id": "530902",
					"child": []
				}, {
					"name": "镇康县",
					"id": "530924",
					"child": []
				}]
			}, {
				"name": "昭通市",
				"id": "530600",
				"child": [{
					"name": "昭阳区",
					"id": "530602",
					"child": []
				}, {
					"name": "大关县",
					"id": "530624",
					"child": []
				}, {
					"name": "永善县",
					"id": "530625",
					"child": []
				}, {
					"name": "巧家县",
					"id": "530622",
					"child": []
				}, {
					"name": "市辖区",
					"id": "530601",
					"child": []
				}, {
					"name": "盐津县",
					"id": "530623",
					"child": []
				}, {
					"name": "鲁甸县",
					"id": "530621",
					"child": []
				}, {
					"name": "水富县",
					"id": "530630",
					"child": []
				}, {
					"name": "彝良县",
					"id": "530628",
					"child": []
				}, {
					"name": "威信县",
					"id": "530629",
					"child": []
				}, {
					"name": "绥江县",
					"id": "530626",
					"child": []
				}, {
					"name": "镇雄县",
					"id": "530627",
					"child": []
				}]
			}, {
				"name": "大理白族自治州",
				"id": "532900",
				"child": [{
					"name": "宾川县",
					"id": "532924",
					"child": []
				}, {
					"name": "大理市",
					"id": "532901",
					"child": []
				}, {
					"name": "祥云县",
					"id": "532923",
					"child": []
				}, {
					"name": "漾濞彝族自治县",
					"id": "532922",
					"child": []
				}, {
					"name": "鹤庆县",
					"id": "532932",
					"child": []
				}, {
					"name": "剑川县",
					"id": "532931",
					"child": []
				}, {
					"name": "洱源县",
					"id": "532930",
					"child": []
				}, {
					"name": "云龙县",
					"id": "532929",
					"child": []
				}, {
					"name": "永平县",
					"id": "532928",
					"child": []
				}, {
					"name": "巍山彝族回族自治县",
					"id": "532927",
					"child": []
				}, {
					"name": "南涧彝族自治县",
					"id": "532926",
					"child": []
				}, {
					"name": "弥渡县",
					"id": "532925",
					"child": []
				}]
			}, {
				"name": "丽江市",
				"id": "530700",
				"child": [{
					"name": "市辖区",
					"id": "530701",
					"child": []
				}, {
					"name": "华坪县",
					"id": "530723",
					"child": []
				}, {
					"name": "古城区",
					"id": "530702",
					"child": []
				}, {
					"name": "宁蒗彝族自治县",
					"id": "530724",
					"child": []
				}, {
					"name": "玉龙纳西族自治县",
					"id": "530721",
					"child": []
				}, {
					"name": "永胜县",
					"id": "530722",
					"child": []
				}]
			}, {
				"name": "西双版纳傣族自治州",
				"id": "532800",
				"child": [{
					"name": "景洪市",
					"id": "532801",
					"child": []
				}, {
					"name": "勐腊县",
					"id": "532823",
					"child": []
				}, {
					"name": "勐海县",
					"id": "532822",
					"child": []
				}]
			}, {
				"name": "玉溪市",
				"id": "530400",
				"child": [{
					"name": "峨山彝族自治县",
					"id": "530426",
					"child": []
				}, {
					"name": "新平彝族傣族自治县",
					"id": "530427",
					"child": []
				}, {
					"name": "红塔区",
					"id": "530402",
					"child": []
				}, {
					"name": "华宁县",
					"id": "530424",
					"child": []
				}, {
					"name": "江川区",
					"id": "530403",
					"child": []
				}, {
					"name": "易门县",
					"id": "530425",
					"child": []
				}, {
					"name": "澄江县",
					"id": "530422",
					"child": []
				}, {
					"name": "市辖区",
					"id": "530401",
					"child": []
				}, {
					"name": "通海县",
					"id": "530423",
					"child": []
				}, {
					"name": "元江哈尼族彝族傣族自治县",
					"id": "530428",
					"child": []
				}]
			}, {
				"name": "保山市",
				"id": "530500",
				"child": [{
					"name": "市辖区",
					"id": "530501",
					"child": []
				}, {
					"name": "龙陵县",
					"id": "530523",
					"child": []
				}, {
					"name": "隆阳区",
					"id": "530502",
					"child": []
				}, {
					"name": "昌宁县",
					"id": "530524",
					"child": []
				}, {
					"name": "施甸县",
					"id": "530521",
					"child": []
				}, {
					"name": "腾冲市",
					"id": "530581",
					"child": []
				}]
			}, {
				"name": "文山壮族苗族自治州",
				"id": "532600",
				"child": [{
					"name": "广南县",
					"id": "532627",
					"child": []
				}, {
					"name": "丘北县",
					"id": "532626",
					"child": []
				}, {
					"name": "马关县",
					"id": "532625",
					"child": []
				}, {
					"name": "麻栗坡县",
					"id": "532624",
					"child": []
				}, {
					"name": "文山市",
					"id": "532601",
					"child": []
				}, {
					"name": "西畴县",
					"id": "532623",
					"child": []
				}, {
					"name": "砚山县",
					"id": "532622",
					"child": []
				}, {
					"name": "富宁县",
					"id": "532628",
					"child": []
				}]
			}, {
				"name": "红河哈尼族彝族自治州",
				"id": "532500",
				"child": [{
					"name": "绿春县",
					"id": "532531",
					"child": []
				}, {
					"name": "金平苗族瑶族傣族自治县",
					"id": "532530",
					"child": []
				}, {
					"name": "元阳县",
					"id": "532528",
					"child": []
				}, {
					"name": "泸西县",
					"id": "532527",
					"child": []
				}, {
					"name": "弥勒市",
					"id": "532504",
					"child": []
				}, {
					"name": "蒙自市",
					"id": "532503",
					"child": []
				}, {
					"name": "石屏县",
					"id": "532525",
					"child": []
				}, {
					"name": "开远市",
					"id": "532502",
					"child": []
				}, {
					"name": "建水县",
					"id": "532524",
					"child": []
				}, {
					"name": "个旧市",
					"id": "532501",
					"child": []
				}, {
					"name": "屏边苗族自治县",
					"id": "532523",
					"child": []
				}, {
					"name": "河口瑶族自治县",
					"id": "532532",
					"child": []
				}, {
					"name": "红河县",
					"id": "532529",
					"child": []
				}]
			}, {
				"name": "曲靖市",
				"id": "530300",
				"child": [{
					"name": "沾益区",
					"id": "530303",
					"child": []
				}, {
					"name": "富源县",
					"id": "530325",
					"child": []
				}, {
					"name": "会泽县",
					"id": "530326",
					"child": []
				}, {
					"name": "市辖区",
					"id": "530301",
					"child": []
				}, {
					"name": "师宗县",
					"id": "530323",
					"child": []
				}, {
					"name": "麒麟区",
					"id": "530302",
					"child": []
				}, {
					"name": "罗平县",
					"id": "530324",
					"child": []
				}, {
					"name": "马龙县",
					"id": "530321",
					"child": []
				}, {
					"name": "陆良县",
					"id": "530322",
					"child": []
				}, {
					"name": "宣威市",
					"id": "530381",
					"child": []
				}]
			}]
		},
		{
			"name": "海南省",
			"id": "460000",
			"child": [{
				"name": "省直辖县级行政区划",
				"id": "469000",
				"child": [{
					"name": "东方市",
					"id": "469007",
					"child": []
				}, {
					"name": "保亭黎族苗族自治县",
					"id": "469029",
					"child": []
				}, {
					"name": "万宁市",
					"id": "469006",
					"child": []
				}, {
					"name": "陵水黎族自治县",
					"id": "469028",
					"child": []
				}, {
					"name": "文昌市",
					"id": "469005",
					"child": []
				}, {
					"name": "乐东黎族自治县",
					"id": "469027",
					"child": []
				}, {
					"name": "昌江黎族自治县",
					"id": "469026",
					"child": []
				}, {
					"name": "白沙黎族自治县",
					"id": "469025",
					"child": []
				}, {
					"name": "琼海市",
					"id": "469002",
					"child": []
				}, {
					"name": "临高县",
					"id": "469024",
					"child": []
				}, {
					"name": "五指山市",
					"id": "469001",
					"child": []
				}, {
					"name": "澄迈县",
					"id": "469023",
					"child": []
				}, {
					"name": "屯昌县",
					"id": "469022",
					"child": []
				}, {
					"name": "定安县",
					"id": "469021",
					"child": []
				}, {
					"name": "琼中黎族苗族自治县",
					"id": "469030",
					"child": []
				}]
			}, {
				"name": "海口市",
				"id": "460100",
				"child": [{
					"name": "美兰区",
					"id": "460108",
					"child": []
				}, {
					"name": "琼山区",
					"id": "460107",
					"child": []
				}, {
					"name": "龙华区",
					"id": "460106",
					"child": []
				}, {
					"name": "秀英区",
					"id": "460105",
					"child": []
				}, {
					"name": "市辖区",
					"id": "460101",
					"child": []
				}]
			}, {
				"name": "儋州市",
				"id": "460400",
				"child": []
			}, {
				"name": "三沙市",
				"id": "460300",
				"child": []
			}, {
				"name": "三亚市",
				"id": "460200",
				"child": [{
					"name": "崖州区",
					"id": "460205",
					"child": []
				}, {
					"name": "天涯区",
					"id": "460204",
					"child": []
				}, {
					"name": "吉阳区",
					"id": "460203",
					"child": []
				}, {
					"name": "海棠区",
					"id": "460202",
					"child": []
				}, {
					"name": "市辖区",
					"id": "460201",
					"child": []
				}]
			}]
		},
		{
			"name": "浙江省",
			"id": "330000",
			"child": [{
				"name": "台州市",
				"id": "331000",
				"child": [{
					"name": "玉环县",
					"id": "331021",
					"child": []
				}, {
					"name": "三门县",
					"id": "331022",
					"child": []
				}, {
					"name": "温岭市",
					"id": "331081",
					"child": []
				}, {
					"name": "临海市",
					"id": "331082",
					"child": []
				}, {
					"name": "市辖区",
					"id": "331001",
					"child": []
				}, {
					"name": "天台县",
					"id": "331023",
					"child": []
				}, {
					"name": "椒江区",
					"id": "331002",
					"child": []
				}, {
					"name": "仙居县",
					"id": "331024",
					"child": []
				}, {
					"name": "黄岩区",
					"id": "331003",
					"child": []
				}, {
					"name": "路桥区",
					"id": "331004",
					"child": []
				}]
			}, {
				"name": "衢州市",
				"id": "330800",
				"child": [{
					"name": "常山县",
					"id": "330822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330801",
					"child": []
				}, {
					"name": "柯城区",
					"id": "330802",
					"child": []
				}, {
					"name": "开化县",
					"id": "330824",
					"child": []
				}, {
					"name": "衢江区",
					"id": "330803",
					"child": []
				}, {
					"name": "龙游县",
					"id": "330825",
					"child": []
				}, {
					"name": "江山市",
					"id": "330881",
					"child": []
				}]
			}, {
				"name": "舟山市",
				"id": "330900",
				"child": [{
					"name": "普陀区",
					"id": "330903",
					"child": []
				}, {
					"name": "岱山县",
					"id": "330921",
					"child": []
				}, {
					"name": "嵊泗县",
					"id": "330922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330901",
					"child": []
				}, {
					"name": "定海区",
					"id": "330902",
					"child": []
				}]
			}, {
				"name": "嘉兴市",
				"id": "330400",
				"child": [{
					"name": "海宁市",
					"id": "330481",
					"child": []
				}, {
					"name": "平湖市",
					"id": "330482",
					"child": []
				}, {
					"name": "桐乡市",
					"id": "330483",
					"child": []
				}, {
					"name": "秀洲区",
					"id": "330411",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330401",
					"child": []
				}, {
					"name": "南湖区",
					"id": "330402",
					"child": []
				}, {
					"name": "海盐县",
					"id": "330424",
					"child": []
				}, {
					"name": "嘉善县",
					"id": "330421",
					"child": []
				}]
			}, {
				"name": "湖州市",
				"id": "330500",
				"child": [{
					"name": "南浔区",
					"id": "330503",
					"child": []
				}, {
					"name": "德清县",
					"id": "330521",
					"child": []
				}, {
					"name": "长兴县",
					"id": "330522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330501",
					"child": []
				}, {
					"name": "安吉县",
					"id": "330523",
					"child": []
				}, {
					"name": "吴兴区",
					"id": "330502",
					"child": []
				}]
			}, {
				"name": "绍兴市",
				"id": "330600",
				"child": [{
					"name": "诸暨市",
					"id": "330681",
					"child": []
				}, {
					"name": "越城区",
					"id": "330602",
					"child": []
				}, {
					"name": "新昌县",
					"id": "330624",
					"child": []
				}, {
					"name": "柯桥区",
					"id": "330603",
					"child": []
				}, {
					"name": "上虞区",
					"id": "330604",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330601",
					"child": []
				}, {
					"name": "嵊州市",
					"id": "330683",
					"child": []
				}]
			}, {
				"name": "金华市",
				"id": "330700",
				"child": [{
					"name": "磐安县",
					"id": "330727",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330701",
					"child": []
				}, {
					"name": "武义县",
					"id": "330723",
					"child": []
				}, {
					"name": "婺城区",
					"id": "330702",
					"child": []
				}, {
					"name": "金东区",
					"id": "330703",
					"child": []
				}, {
					"name": "浦江县",
					"id": "330726",
					"child": []
				}, {
					"name": "兰溪市",
					"id": "330781",
					"child": []
				}, {
					"name": "义乌市",
					"id": "330782",
					"child": []
				}, {
					"name": "东阳市",
					"id": "330783",
					"child": []
				}, {
					"name": "永康市",
					"id": "330784",
					"child": []
				}]
			}, {
				"name": "丽水市",
				"id": "331100",
				"child": [{
					"name": "青田县",
					"id": "331121",
					"child": []
				}, {
					"name": "龙泉市",
					"id": "331181",
					"child": []
				}, {
					"name": "庆元县",
					"id": "331126",
					"child": []
				}, {
					"name": "景宁畲族自治县",
					"id": "331127",
					"child": []
				}, {
					"name": "缙云县",
					"id": "331122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "331101",
					"child": []
				}, {
					"name": "遂昌县",
					"id": "331123",
					"child": []
				}, {
					"name": "莲都区",
					"id": "331102",
					"child": []
				}, {
					"name": "松阳县",
					"id": "331124",
					"child": []
				}, {
					"name": "云和县",
					"id": "331125",
					"child": []
				}]
			}, {
				"name": "杭州市",
				"id": "330100",
				"child": [{
					"name": "滨江区",
					"id": "330108",
					"child": []
				}, {
					"name": "萧山区",
					"id": "330109",
					"child": []
				}, {
					"name": "下城区",
					"id": "330103",
					"child": []
				}, {
					"name": "江干区",
					"id": "330104",
					"child": []
				}, {
					"name": "拱墅区",
					"id": "330105",
					"child": []
				}, {
					"name": "淳安县",
					"id": "330127",
					"child": []
				}, {
					"name": "西湖区",
					"id": "330106",
					"child": []
				}, {
					"name": "余杭区",
					"id": "330110",
					"child": []
				}, {
					"name": "富阳区",
					"id": "330111",
					"child": []
				}, {
					"name": "桐庐县",
					"id": "330122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330101",
					"child": []
				}, {
					"name": "上城区",
					"id": "330102",
					"child": []
				}, {
					"name": "临安市",
					"id": "330185",
					"child": []
				}, {
					"name": "建德市",
					"id": "330182",
					"child": []
				}]
			}, {
				"name": "宁波市",
				"id": "330200",
				"child": [{
					"name": "慈溪市",
					"id": "330282",
					"child": []
				}, {
					"name": "奉化市",
					"id": "330283",
					"child": []
				}, {
					"name": "北仑区",
					"id": "330206",
					"child": []
				}, {
					"name": "余姚市",
					"id": "330281",
					"child": []
				}, {
					"name": "海曙区",
					"id": "330203",
					"child": []
				}, {
					"name": "象山县",
					"id": "330225",
					"child": []
				}, {
					"name": "江东区",
					"id": "330204",
					"child": []
				}, {
					"name": "宁海县",
					"id": "330226",
					"child": []
				}, {
					"name": "江北区",
					"id": "330205",
					"child": []
				}, {
					"name": "镇海区",
					"id": "330211",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330201",
					"child": []
				}, {
					"name": "鄞州区",
					"id": "330212",
					"child": []
				}]
			}, {
				"name": "温州市",
				"id": "330300",
				"child": [{
					"name": "瑞安市",
					"id": "330381",
					"child": []
				}, {
					"name": "乐清市",
					"id": "330382",
					"child": []
				}, {
					"name": "洞头区",
					"id": "330305",
					"child": []
				}, {
					"name": "苍南县",
					"id": "330327",
					"child": []
				}, {
					"name": "文成县",
					"id": "330328",
					"child": []
				}, {
					"name": "泰顺县",
					"id": "330329",
					"child": []
				}, {
					"name": "市辖区",
					"id": "330301",
					"child": []
				}, {
					"name": "鹿城区",
					"id": "330302",
					"child": []
				}, {
					"name": "永嘉县",
					"id": "330324",
					"child": []
				}, {
					"name": "龙湾区",
					"id": "330303",
					"child": []
				}, {
					"name": "瓯海区",
					"id": "330304",
					"child": []
				}, {
					"name": "平阳县",
					"id": "330326",
					"child": []
				}]
			}]
		},
		{
			"name": "上海市",
			"id": "310000",
			"child": [{
				"name": "市辖区",
				"id": "310100",
				"child": [{
					"name": "崇明区",
					"id": "310151",
					"child": []
				}, {
					"name": "奉贤区",
					"id": "310120",
					"child": []
				}, {
					"name": "杨浦区",
					"id": "310110",
					"child": []
				}, {
					"name": "黄浦区",
					"id": "310101",
					"child": []
				}, {
					"name": "闵行区",
					"id": "310112",
					"child": []
				}, {
					"name": "宝山区",
					"id": "310113",
					"child": []
				}, {
					"name": "嘉定区",
					"id": "310114",
					"child": []
				}, {
					"name": "徐汇区",
					"id": "310104",
					"child": []
				}, {
					"name": "浦东新区",
					"id": "310115",
					"child": []
				}, {
					"name": "长宁区",
					"id": "310105",
					"child": []
				}, {
					"name": "金山区",
					"id": "310116",
					"child": []
				}, {
					"name": "静安区",
					"id": "310106",
					"child": []
				}, {
					"name": "松江区",
					"id": "310117",
					"child": []
				}, {
					"name": "普陀区",
					"id": "310107",
					"child": []
				}, {
					"name": "青浦区",
					"id": "310118",
					"child": []
				}, {
					"name": "虹口区",
					"id": "310109",
					"child": []
				}]
			}]
		},
		{
			"name": "天津市",
			"id": "120000",
			"child": [{
				"name": "市辖区",
				"id": "120100",
				"child": [{
					"name": "河东区",
					"id": "120102",
					"child": []
				}, {
					"name": "北辰区",
					"id": "120113",
					"child": []
				}, {
					"name": "河西区",
					"id": "120103",
					"child": []
				}, {
					"name": "武清区",
					"id": "120114",
					"child": []
				}, {
					"name": "南开区",
					"id": "120104",
					"child": []
				}, {
					"name": "宝坻区",
					"id": "120115",
					"child": []
				}, {
					"name": "河北区",
					"id": "120105",
					"child": []
				}, {
					"name": "滨海新区",
					"id": "120116",
					"child": []
				}, {
					"name": "东丽区",
					"id": "120110",
					"child": []
				}, {
					"name": "西青区",
					"id": "120111",
					"child": []
				}, {
					"name": "和平区",
					"id": "120101",
					"child": []
				}, {
					"name": "津南区",
					"id": "120112",
					"child": []
				}, {
					"name": "红桥区",
					"id": "120106",
					"child": []
				}, {
					"name": "宁河区",
					"id": "120117",
					"child": []
				}, {
					"name": "静海区",
					"id": "120118",
					"child": []
				}, {
					"name": "蓟州区",
					"id": "120119",
					"child": []
				}]
			}]
		},
		{
			"name": "陕西省",
			"id": "610000",
			"child": [{
				"name": "宝鸡市",
				"id": "610300",
				"child": [{
					"name": "千阳县",
					"id": "610328",
					"child": []
				}, {
					"name": "麟游县",
					"id": "610329",
					"child": []
				}, {
					"name": "陈仓区",
					"id": "610304",
					"child": []
				}, {
					"name": "眉县",
					"id": "610326",
					"child": []
				}, {
					"name": "陇县",
					"id": "610327",
					"child": []
				}, {
					"name": "渭滨区",
					"id": "610302",
					"child": []
				}, {
					"name": "扶风县",
					"id": "610324",
					"child": []
				}, {
					"name": "金台区",
					"id": "610303",
					"child": []
				}, {
					"name": "凤翔县",
					"id": "610322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610301",
					"child": []
				}, {
					"name": "岐山县",
					"id": "610323",
					"child": []
				}, {
					"name": "太白县",
					"id": "610331",
					"child": []
				}, {
					"name": "凤县",
					"id": "610330",
					"child": []
				}]
			}, {
				"name": "咸阳市",
				"id": "610400",
				"child": [{
					"name": "旬邑县",
					"id": "610429",
					"child": []
				}, {
					"name": "彬县",
					"id": "610427",
					"child": []
				}, {
					"name": "长武县",
					"id": "610428",
					"child": []
				}, {
					"name": "杨陵区",
					"id": "610403",
					"child": []
				}, {
					"name": "礼泉县",
					"id": "610425",
					"child": []
				}, {
					"name": "渭城区",
					"id": "610404",
					"child": []
				}, {
					"name": "永寿县",
					"id": "610426",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610401",
					"child": []
				}, {
					"name": "泾阳县",
					"id": "610423",
					"child": []
				}, {
					"name": "秦都区",
					"id": "610402",
					"child": []
				}, {
					"name": "乾县",
					"id": "610424",
					"child": []
				}, {
					"name": "三原县",
					"id": "610422",
					"child": []
				}, {
					"name": "淳化县",
					"id": "610430",
					"child": []
				}, {
					"name": "武功县",
					"id": "610431",
					"child": []
				}, {
					"name": "兴平市",
					"id": "610481",
					"child": []
				}]
			}, {
				"name": "西安市",
				"id": "610100",
				"child": [{
					"name": "高陵区",
					"id": "610117",
					"child": []
				}, {
					"name": "莲湖区",
					"id": "610104",
					"child": []
				}, {
					"name": "临潼区",
					"id": "610115",
					"child": []
				}, {
					"name": "长安区",
					"id": "610116",
					"child": []
				}, {
					"name": "新城区",
					"id": "610102",
					"child": []
				}, {
					"name": "雁塔区",
					"id": "610113",
					"child": []
				}, {
					"name": "周至县",
					"id": "610124",
					"child": []
				}, {
					"name": "碑林区",
					"id": "610103",
					"child": []
				}, {
					"name": "阎良区",
					"id": "610114",
					"child": []
				}, {
					"name": "户县",
					"id": "610125",
					"child": []
				}, {
					"name": "灞桥区",
					"id": "610111",
					"child": []
				}, {
					"name": "蓝田县",
					"id": "610122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610101",
					"child": []
				}, {
					"name": "未央区",
					"id": "610112",
					"child": []
				}]
			}, {
				"name": "铜川市",
				"id": "610200",
				"child": [{
					"name": "市辖区",
					"id": "610201",
					"child": []
				}, {
					"name": "王益区",
					"id": "610202",
					"child": []
				}, {
					"name": "宜君县",
					"id": "610222",
					"child": []
				}, {
					"name": "印台区",
					"id": "610203",
					"child": []
				}, {
					"name": "耀州区",
					"id": "610204",
					"child": []
				}]
			}, {
				"name": "商洛市",
				"id": "611000",
				"child": [{
					"name": "柞水县",
					"id": "611026",
					"child": []
				}, {
					"name": "镇安县",
					"id": "611025",
					"child": []
				}, {
					"name": "商州区",
					"id": "611002",
					"child": []
				}, {
					"name": "山阳县",
					"id": "611024",
					"child": []
				}, {
					"name": "市辖区",
					"id": "611001",
					"child": []
				}, {
					"name": "商南县",
					"id": "611023",
					"child": []
				}, {
					"name": "丹凤县",
					"id": "611022",
					"child": []
				}, {
					"name": "洛南县",
					"id": "611021",
					"child": []
				}]
			}, {
				"name": "安康市",
				"id": "610900",
				"child": [{
					"name": "旬阳县",
					"id": "610928",
					"child": []
				}, {
					"name": "白河县",
					"id": "610929",
					"child": []
				}, {
					"name": "平利县",
					"id": "610926",
					"child": []
				}, {
					"name": "镇坪县",
					"id": "610927",
					"child": []
				}, {
					"name": "汉滨区",
					"id": "610902",
					"child": []
				}, {
					"name": "紫阳县",
					"id": "610924",
					"child": []
				}, {
					"name": "岚皋县",
					"id": "610925",
					"child": []
				}, {
					"name": "石泉县",
					"id": "610922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610901",
					"child": []
				}, {
					"name": "宁陕县",
					"id": "610923",
					"child": []
				}, {
					"name": "汉阴县",
					"id": "610921",
					"child": []
				}]
			}, {
				"name": "汉中市",
				"id": "610700",
				"child": [{
					"name": "佛坪县",
					"id": "610730",
					"child": []
				}, {
					"name": "镇巴县",
					"id": "610728",
					"child": []
				}, {
					"name": "留坝县",
					"id": "610729",
					"child": []
				}, {
					"name": "宁强县",
					"id": "610726",
					"child": []
				}, {
					"name": "略阳县",
					"id": "610727",
					"child": []
				}, {
					"name": "汉台区",
					"id": "610702",
					"child": []
				}, {
					"name": "西乡县",
					"id": "610724",
					"child": []
				}, {
					"name": "勉县",
					"id": "610725",
					"child": []
				}, {
					"name": "城固县",
					"id": "610722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610701",
					"child": []
				}, {
					"name": "洋县",
					"id": "610723",
					"child": []
				}, {
					"name": "南郑县",
					"id": "610721",
					"child": []
				}]
			}, {
				"name": "榆林市",
				"id": "610800",
				"child": [{
					"name": "吴堡县",
					"id": "610829",
					"child": []
				}, {
					"name": "米脂县",
					"id": "610827",
					"child": []
				}, {
					"name": "佳县",
					"id": "610828",
					"child": []
				}, {
					"name": "横山区",
					"id": "610803",
					"child": []
				}, {
					"name": "定边县",
					"id": "610825",
					"child": []
				}, {
					"name": "绥德县",
					"id": "610826",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610801",
					"child": []
				}, {
					"name": "榆阳区",
					"id": "610802",
					"child": []
				}, {
					"name": "靖边县",
					"id": "610824",
					"child": []
				}, {
					"name": "神木县",
					"id": "610821",
					"child": []
				}, {
					"name": "府谷县",
					"id": "610822",
					"child": []
				}, {
					"name": "清涧县",
					"id": "610830",
					"child": []
				}, {
					"name": "子洲县",
					"id": "610831",
					"child": []
				}]
			}, {
				"name": "渭南市",
				"id": "610500",
				"child": [{
					"name": "华阴市",
					"id": "610582",
					"child": []
				}, {
					"name": "韩城市",
					"id": "610581",
					"child": []
				}, {
					"name": "富平县",
					"id": "610528",
					"child": []
				}, {
					"name": "蒲城县",
					"id": "610526",
					"child": []
				}, {
					"name": "白水县",
					"id": "610527",
					"child": []
				}, {
					"name": "临渭区",
					"id": "610502",
					"child": []
				}, {
					"name": "合阳县",
					"id": "610524",
					"child": []
				}, {
					"name": "华州区",
					"id": "610503",
					"child": []
				}, {
					"name": "澄城县",
					"id": "610525",
					"child": []
				}, {
					"name": "潼关县",
					"id": "610522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610501",
					"child": []
				}, {
					"name": "大荔县",
					"id": "610523",
					"child": []
				}]
			}, {
				"name": "延安市",
				"id": "610600",
				"child": [{
					"name": "洛川县",
					"id": "610629",
					"child": []
				}, {
					"name": "甘泉县",
					"id": "610627",
					"child": []
				}, {
					"name": "富县",
					"id": "610628",
					"child": []
				}, {
					"name": "安塞区",
					"id": "610603",
					"child": []
				}, {
					"name": "志丹县",
					"id": "610625",
					"child": []
				}, {
					"name": "吴起县",
					"id": "610626",
					"child": []
				}, {
					"name": "市辖区",
					"id": "610601",
					"child": []
				}, {
					"name": "子长县",
					"id": "610623",
					"child": []
				}, {
					"name": "宝塔区",
					"id": "610602",
					"child": []
				}, {
					"name": "延长县",
					"id": "610621",
					"child": []
				}, {
					"name": "黄陵县",
					"id": "610632",
					"child": []
				}, {
					"name": "延川县",
					"id": "610622",
					"child": []
				}, {
					"name": "宜川县",
					"id": "610630",
					"child": []
				}, {
					"name": "黄龙县",
					"id": "610631",
					"child": []
				}]
			}]
		},
		{
			"name": "新疆维吾尔自治区",
			"id": "650000",
			"child": [{
				"name": "哈密市",
				"id": "650500",
				"child": [{
					"name": "伊州区",
					"id": "650502",
					"child": []
				}, {
					"name": "伊吾县",
					"id": "650522",
					"child": []
				}, {
					"name": "巴里坤哈萨克自治县",
					"id": "650521",
					"child": []
				}]
			}, {
				"name": "吐鲁番市",
				"id": "650400",
				"child": [{
					"name": "高昌区",
					"id": "650402",
					"child": []
				}, {
					"name": "托克逊县",
					"id": "650422",
					"child": []
				}, {
					"name": "鄯善县",
					"id": "650421",
					"child": []
				}]
			}, {
				"name": "克拉玛依市",
				"id": "650200",
				"child": [{
					"name": "乌尔禾区",
					"id": "650205",
					"child": []
				}, {
					"name": "白碱滩区",
					"id": "650204",
					"child": []
				}, {
					"name": "克拉玛依区",
					"id": "650203",
					"child": []
				}, {
					"name": "独山子区",
					"id": "650202",
					"child": []
				}, {
					"name": "市辖区",
					"id": "650201",
					"child": []
				}]
			}, {
				"name": "乌鲁木齐市",
				"id": "650100",
				"child": [{
					"name": "达坂城区",
					"id": "650107",
					"child": []
				}, {
					"name": "头屯河区",
					"id": "650106",
					"child": []
				}, {
					"name": "水磨沟区",
					"id": "650105",
					"child": []
				}, {
					"name": "新市区",
					"id": "650104",
					"child": []
				}, {
					"name": "沙依巴克区",
					"id": "650103",
					"child": []
				}, {
					"name": "天山区",
					"id": "650102",
					"child": []
				}, {
					"name": "市辖区",
					"id": "650101",
					"child": []
				}, {
					"name": "乌鲁木齐县",
					"id": "650121",
					"child": []
				}, {
					"name": "米东区",
					"id": "650109",
					"child": []
				}]
			}, {
				"name": "昌吉回族自治州",
				"id": "652300",
				"child": [{
					"name": "昌吉市",
					"id": "652301",
					"child": []
				}, {
					"name": "呼图壁县",
					"id": "652323",
					"child": []
				}, {
					"name": "阜康市",
					"id": "652302",
					"child": []
				}, {
					"name": "玛纳斯县",
					"id": "652324",
					"child": []
				}, {
					"name": "奇台县",
					"id": "652325",
					"child": []
				}, {
					"name": "吉木萨尔县",
					"id": "652327",
					"child": []
				}, {
					"name": "木垒哈萨克自治县",
					"id": "652328",
					"child": []
				}]
			}, {
				"name": "博尔塔拉蒙古自治州",
				"id": "652700",
				"child": [{
					"name": "精河县",
					"id": "652722",
					"child": []
				}, {
					"name": "博乐市",
					"id": "652701",
					"child": []
				}, {
					"name": "温泉县",
					"id": "652723",
					"child": []
				}, {
					"name": "阿拉山口市",
					"id": "652702",
					"child": []
				}]
			}, {
				"name": "巴音郭楞蒙古自治州",
				"id": "652800",
				"child": [{
					"name": "且末县",
					"id": "652825",
					"child": []
				}, {
					"name": "焉耆回族自治县",
					"id": "652826",
					"child": []
				}, {
					"name": "和静县",
					"id": "652827",
					"child": []
				}, {
					"name": "和硕县",
					"id": "652828",
					"child": []
				}, {
					"name": "博湖县",
					"id": "652829",
					"child": []
				}, {
					"name": "轮台县",
					"id": "652822",
					"child": []
				}, {
					"name": "库尔勒市",
					"id": "652801",
					"child": []
				}, {
					"name": "尉犁县",
					"id": "652823",
					"child": []
				}, {
					"name": "若羌县",
					"id": "652824",
					"child": []
				}]
			}, {
				"name": "阿克苏地区",
				"id": "652900",
				"child": [{
					"name": "沙雅县",
					"id": "652924",
					"child": []
				}, {
					"name": "新和县",
					"id": "652925",
					"child": []
				}, {
					"name": "拜城县",
					"id": "652926",
					"child": []
				}, {
					"name": "乌什县",
					"id": "652927",
					"child": []
				}, {
					"name": "阿瓦提县",
					"id": "652928",
					"child": []
				}, {
					"name": "柯坪县",
					"id": "652929",
					"child": []
				}, {
					"name": "温宿县",
					"id": "652922",
					"child": []
				}, {
					"name": "阿克苏市",
					"id": "652901",
					"child": []
				}, {
					"name": "库车县",
					"id": "652923",
					"child": []
				}]
			}, {
				"name": "伊犁哈萨克自治州",
				"id": "654000",
				"child": [{
					"name": "伊宁县",
					"id": "654021",
					"child": []
				}, {
					"name": "察布查尔锡伯自治县",
					"id": "654022",
					"child": []
				}, {
					"name": "霍城县",
					"id": "654023",
					"child": []
				}, {
					"name": "伊宁市",
					"id": "654002",
					"child": []
				}, {
					"name": "巩留县",
					"id": "654024",
					"child": []
				}, {
					"name": "奎屯市",
					"id": "654003",
					"child": []
				}, {
					"name": "新源县",
					"id": "654025",
					"child": []
				}, {
					"name": "霍尔果斯市",
					"id": "654004",
					"child": []
				}, {
					"name": "昭苏县",
					"id": "654026",
					"child": []
				}, {
					"name": "特克斯县",
					"id": "654027",
					"child": []
				}, {
					"name": "尼勒克县",
					"id": "654028",
					"child": []
				}]
			}, {
				"name": "克孜勒苏柯尔克孜自治州",
				"id": "653000",
				"child": [{
					"name": "阿克陶县",
					"id": "653022",
					"child": []
				}, {
					"name": "阿图什市",
					"id": "653001",
					"child": []
				}, {
					"name": "阿合奇县",
					"id": "653023",
					"child": []
				}, {
					"name": "乌恰县",
					"id": "653024",
					"child": []
				}]
			}, {
				"name": "喀什地区",
				"id": "653100",
				"child": [{
					"name": "巴楚县",
					"id": "653130",
					"child": []
				}, {
					"name": "塔什库尔干塔吉克自治县",
					"id": "653131",
					"child": []
				}, {
					"name": "疏附县",
					"id": "653121",
					"child": []
				}, {
					"name": "疏勒县",
					"id": "653122",
					"child": []
				}, {
					"name": "喀什市",
					"id": "653101",
					"child": []
				}, {
					"name": "英吉沙县",
					"id": "653123",
					"child": []
				}, {
					"name": "泽普县",
					"id": "653124",
					"child": []
				}, {
					"name": "莎车县",
					"id": "653125",
					"child": []
				}, {
					"name": "叶城县",
					"id": "653126",
					"child": []
				}, {
					"name": "麦盖提县",
					"id": "653127",
					"child": []
				}, {
					"name": "岳普湖县",
					"id": "653128",
					"child": []
				}, {
					"name": "伽师县",
					"id": "653129",
					"child": []
				}]
			}, {
				"name": "塔城地区",
				"id": "654200",
				"child": [{
					"name": "额敏县",
					"id": "654221",
					"child": []
				}, {
					"name": "塔城市",
					"id": "654201",
					"child": []
				}, {
					"name": "沙湾县",
					"id": "654223",
					"child": []
				}, {
					"name": "乌苏市",
					"id": "654202",
					"child": []
				}, {
					"name": "托里县",
					"id": "654224",
					"child": []
				}, {
					"name": "裕民县",
					"id": "654225",
					"child": []
				}, {
					"name": "和布克赛尔蒙古自治县",
					"id": "654226",
					"child": []
				}]
			}, {
				"name": "和田地区",
				"id": "653200",
				"child": [{
					"name": "和田县",
					"id": "653221",
					"child": []
				}, {
					"name": "墨玉县",
					"id": "653222",
					"child": []
				}, {
					"name": "和田市",
					"id": "653201",
					"child": []
				}, {
					"name": "皮山县",
					"id": "653223",
					"child": []
				}, {
					"name": "洛浦县",
					"id": "653224",
					"child": []
				}, {
					"name": "策勒县",
					"id": "653225",
					"child": []
				}, {
					"name": "于田县",
					"id": "653226",
					"child": []
				}, {
					"name": "民丰县",
					"id": "653227",
					"child": []
				}]
			}, {
				"name": "阿勒泰地区",
				"id": "654300",
				"child": [{
					"name": "布尔津县",
					"id": "654321",
					"child": []
				}, {
					"name": "富蕴县",
					"id": "654322",
					"child": []
				}, {
					"name": "阿勒泰市",
					"id": "654301",
					"child": []
				}, {
					"name": "福海县",
					"id": "654323",
					"child": []
				}, {
					"name": "哈巴河县",
					"id": "654324",
					"child": []
				}, {
					"name": "青河县",
					"id": "654325",
					"child": []
				}, {
					"name": "吉木乃县",
					"id": "654326",
					"child": []
				}]
			}, {
				"name": "自治区直辖县级行政区划",
				"id": "659000",
				"child": [{
					"name": "五家渠市",
					"id": "659004",
					"child": []
				}, {
					"name": "图木舒克市",
					"id": "659003",
					"child": []
				}, {
					"name": "阿拉尔市",
					"id": "659002",
					"child": []
				}, {
					"name": "铁门关市",
					"id": "659006",
					"child": []
				}, {
					"name": "石河子市",
					"id": "659001",
					"child": []
				}]
			}]
		},
		{
			"name": "贵州省",
			"id": "520000",
			"child": [{
				"name": "黔西南布依族苗族自治州",
				"id": "522300",
				"child": [{
					"name": "兴仁县",
					"id": "522322",
					"child": []
				}, {
					"name": "兴义市",
					"id": "522301",
					"child": []
				}, {
					"name": "普安县",
					"id": "522323",
					"child": []
				}, {
					"name": "晴隆县",
					"id": "522324",
					"child": []
				}, {
					"name": "贞丰县",
					"id": "522325",
					"child": []
				}, {
					"name": "望谟县",
					"id": "522326",
					"child": []
				}, {
					"name": "册亨县",
					"id": "522327",
					"child": []
				}, {
					"name": "安龙县",
					"id": "522328",
					"child": []
				}]
			}, {
				"name": "六盘水市",
				"id": "520200",
				"child": [{
					"name": "水城县",
					"id": "520221",
					"child": []
				}, {
					"name": "盘县",
					"id": "520222",
					"child": []
				}, {
					"name": "钟山区",
					"id": "520201",
					"child": []
				}, {
					"name": "六枝特区",
					"id": "520203",
					"child": []
				}]
			}, {
				"name": "遵义市",
				"id": "520300",
				"child": [{
					"name": "桐梓县",
					"id": "520322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "520301",
					"child": []
				}, {
					"name": "绥阳县",
					"id": "520323",
					"child": []
				}, {
					"name": "红花岗区",
					"id": "520302",
					"child": []
				}, {
					"name": "正安县",
					"id": "520324",
					"child": []
				}, {
					"name": "汇川区",
					"id": "520303",
					"child": []
				}, {
					"name": "道真仡佬族苗族自治县",
					"id": "520325",
					"child": []
				}, {
					"name": "播州区",
					"id": "520304",
					"child": []
				}, {
					"name": "务川仡佬族苗族自治县",
					"id": "520326",
					"child": []
				}, {
					"name": "凤冈县",
					"id": "520327",
					"child": []
				}, {
					"name": "湄潭县",
					"id": "520328",
					"child": []
				}, {
					"name": "余庆县",
					"id": "520329",
					"child": []
				}, {
					"name": "赤水市",
					"id": "520381",
					"child": []
				}, {
					"name": "仁怀市",
					"id": "520382",
					"child": []
				}, {
					"name": "习水县",
					"id": "520330",
					"child": []
				}]
			}, {
				"name": "贵阳市",
				"id": "520100",
				"child": [{
					"name": "开阳县",
					"id": "520121",
					"child": []
				}, {
					"name": "云岩区",
					"id": "520103",
					"child": []
				}, {
					"name": "息烽县",
					"id": "520122",
					"child": []
				}, {
					"name": "南明区",
					"id": "520102",
					"child": []
				}, {
					"name": "修文县",
					"id": "520123",
					"child": []
				}, {
					"name": "市辖区",
					"id": "520101",
					"child": []
				}, {
					"name": "乌当区",
					"id": "520112",
					"child": []
				}, {
					"name": "白云区",
					"id": "520113",
					"child": []
				}, {
					"name": "花溪区",
					"id": "520111",
					"child": []
				}, {
					"name": "观山湖区",
					"id": "520115",
					"child": []
				}, {
					"name": "清镇市",
					"id": "520181",
					"child": []
				}]
			}, {
				"name": "安顺市",
				"id": "520400",
				"child": [{
					"name": "普定县",
					"id": "520422",
					"child": []
				}, {
					"name": "市辖区",
					"id": "520401",
					"child": []
				}, {
					"name": "镇宁布依族苗族自治县",
					"id": "520423",
					"child": []
				}, {
					"name": "西秀区",
					"id": "520402",
					"child": []
				}, {
					"name": "关岭布依族苗族自治县",
					"id": "520424",
					"child": []
				}, {
					"name": "平坝区",
					"id": "520403",
					"child": []
				}, {
					"name": "紫云苗族布依族自治县",
					"id": "520425",
					"child": []
				}]
			}, {
				"name": "黔东南苗族侗族自治州",
				"id": "522600",
				"child": [{
					"name": "剑河县",
					"id": "522629",
					"child": []
				}, {
					"name": "榕江县",
					"id": "522632",
					"child": []
				}, {
					"name": "黄平县",
					"id": "522622",
					"child": []
				}, {
					"name": "从江县",
					"id": "522633",
					"child": []
				}, {
					"name": "凯里市",
					"id": "522601",
					"child": []
				}, {
					"name": "施秉县",
					"id": "522623",
					"child": []
				}, {
					"name": "雷山县",
					"id": "522634",
					"child": []
				}, {
					"name": "三穗县",
					"id": "522624",
					"child": []
				}, {
					"name": "麻江县",
					"id": "522635",
					"child": []
				}, {
					"name": "镇远县",
					"id": "522625",
					"child": []
				}, {
					"name": "丹寨县",
					"id": "522636",
					"child": []
				}, {
					"name": "岑巩县",
					"id": "522626",
					"child": []
				}, {
					"name": "天柱县",
					"id": "522627",
					"child": []
				}, {
					"name": "锦屏县",
					"id": "522628",
					"child": []
				}, {
					"name": "台江县",
					"id": "522630",
					"child": []
				}, {
					"name": "黎平县",
					"id": "522631",
					"child": []
				}]
			}, {
				"name": "毕节市",
				"id": "520500",
				"child": [{
					"name": "大方县",
					"id": "520521",
					"child": []
				}, {
					"name": "黔西县",
					"id": "520522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "520501",
					"child": []
				}, {
					"name": "金沙县",
					"id": "520523",
					"child": []
				}, {
					"name": "七星关区",
					"id": "520502",
					"child": []
				}, {
					"name": "织金县",
					"id": "520524",
					"child": []
				}, {
					"name": "纳雍县",
					"id": "520525",
					"child": []
				}, {
					"name": "威宁彝族回族苗族自治县",
					"id": "520526",
					"child": []
				}, {
					"name": "赫章县",
					"id": "520527",
					"child": []
				}]
			}, {
				"name": "黔南布依族苗族自治州",
				"id": "522700",
				"child": [{
					"name": "罗甸县",
					"id": "522728",
					"child": []
				}, {
					"name": "长顺县",
					"id": "522729",
					"child": []
				}, {
					"name": "龙里县",
					"id": "522730",
					"child": []
				}, {
					"name": "惠水县",
					"id": "522731",
					"child": []
				}, {
					"name": "三都水族自治县",
					"id": "522732",
					"child": []
				}, {
					"name": "荔波县",
					"id": "522722",
					"child": []
				}, {
					"name": "都匀市",
					"id": "522701",
					"child": []
				}, {
					"name": "贵定县",
					"id": "522723",
					"child": []
				}, {
					"name": "福泉市",
					"id": "522702",
					"child": []
				}, {
					"name": "瓮安县",
					"id": "522725",
					"child": []
				}, {
					"name": "独山县",
					"id": "522726",
					"child": []
				}, {
					"name": "平塘县",
					"id": "522727",
					"child": []
				}]
			}, {
				"name": "铜仁市",
				"id": "520600",
				"child": [{
					"name": "沿河土家族自治县",
					"id": "520627",
					"child": []
				}, {
					"name": "松桃苗族自治县",
					"id": "520628",
					"child": []
				}, {
					"name": "江口县",
					"id": "520621",
					"child": []
				}, {
					"name": "玉屏侗族自治县",
					"id": "520622",
					"child": []
				}, {
					"name": "市辖区",
					"id": "520601",
					"child": []
				}, {
					"name": "石阡县",
					"id": "520623",
					"child": []
				}, {
					"name": "碧江区",
					"id": "520602",
					"child": []
				}, {
					"name": "思南县",
					"id": "520624",
					"child": []
				}, {
					"name": "万山区",
					"id": "520603",
					"child": []
				}, {
					"name": "印江土家族苗族自治县",
					"id": "520625",
					"child": []
				}, {
					"name": "德江县",
					"id": "520626",
					"child": []
				}]
			}]
		},
		{
			"name": "安徽省",
			"id": "340000",
			"child": [{
				"name": "铜陵市",
				"id": "340700",
				"child": [{
					"name": "郊区",
					"id": "340711",
					"child": []
				}, {
					"name": "枞阳县",
					"id": "340722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340701",
					"child": []
				}, {
					"name": "义安区",
					"id": "340706",
					"child": []
				}, {
					"name": "铜官区",
					"id": "340705",
					"child": []
				}]
			}, {
				"name": "安庆市",
				"id": "340800",
				"child": [{
					"name": "市辖区",
					"id": "340801",
					"child": []
				}, {
					"name": "迎江区",
					"id": "340802",
					"child": []
				}, {
					"name": "潜山县",
					"id": "340824",
					"child": []
				}, {
					"name": "宜秀区",
					"id": "340811",
					"child": []
				}, {
					"name": "怀宁县",
					"id": "340822",
					"child": []
				}, {
					"name": "望江县",
					"id": "340827",
					"child": []
				}, {
					"name": "岳西县",
					"id": "340828",
					"child": []
				}, {
					"name": "大观区",
					"id": "340803",
					"child": []
				}, {
					"name": "太湖县",
					"id": "340825",
					"child": []
				}, {
					"name": "宿松县",
					"id": "340826",
					"child": []
				}, {
					"name": "桐城市",
					"id": "340881",
					"child": []
				}]
			}, {
				"name": "宣城市",
				"id": "341800",
				"child": [{
					"name": "旌德县",
					"id": "341825",
					"child": []
				}, {
					"name": "宣州区",
					"id": "341802",
					"child": []
				}, {
					"name": "绩溪县",
					"id": "341824",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341801",
					"child": []
				}, {
					"name": "泾县",
					"id": "341823",
					"child": []
				}, {
					"name": "广德县",
					"id": "341822",
					"child": []
				}, {
					"name": "宁国市",
					"id": "341881",
					"child": []
				}, {
					"name": "郎溪县",
					"id": "341821",
					"child": []
				}]
			}, {
				"name": "合肥市",
				"id": "340100",
				"child": [{
					"name": "巢湖市",
					"id": "340181",
					"child": []
				}, {
					"name": "包河区",
					"id": "340111",
					"child": []
				}, {
					"name": "肥东县",
					"id": "340122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340101",
					"child": []
				}, {
					"name": "肥西县",
					"id": "340123",
					"child": []
				}, {
					"name": "长丰县",
					"id": "340121",
					"child": []
				}, {
					"name": "蜀山区",
					"id": "340104",
					"child": []
				}, {
					"name": "瑶海区",
					"id": "340102",
					"child": []
				}, {
					"name": "庐江县",
					"id": "340124",
					"child": []
				}, {
					"name": "庐阳区",
					"id": "340103",
					"child": []
				}]
			}, {
				"name": "阜阳市",
				"id": "341200",
				"child": [{
					"name": "界首市",
					"id": "341282",
					"child": []
				}, {
					"name": "太和县",
					"id": "341222",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341201",
					"child": []
				}, {
					"name": "临泉县",
					"id": "341221",
					"child": []
				}, {
					"name": "颍泉区",
					"id": "341204",
					"child": []
				}, {
					"name": "颍上县",
					"id": "341226",
					"child": []
				}, {
					"name": "颍州区",
					"id": "341202",
					"child": []
				}, {
					"name": "颍东区",
					"id": "341203",
					"child": []
				}, {
					"name": "阜南县",
					"id": "341225",
					"child": []
				}]
			}, {
				"name": "芜湖市",
				"id": "340200",
				"child": [{
					"name": "鸠江区",
					"id": "340207",
					"child": []
				}, {
					"name": "三山区",
					"id": "340208",
					"child": []
				}, {
					"name": "芜湖县",
					"id": "340221",
					"child": []
				}, {
					"name": "繁昌县",
					"id": "340222",
					"child": []
				}, {
					"name": "弋江区",
					"id": "340203",
					"child": []
				}, {
					"name": "无为县",
					"id": "340225",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340201",
					"child": []
				}, {
					"name": "南陵县",
					"id": "340223",
					"child": []
				}, {
					"name": "镜湖区",
					"id": "340202",
					"child": []
				}]
			}, {
				"name": "宿州市",
				"id": "341300",
				"child": [{
					"name": "砀山县",
					"id": "341321",
					"child": []
				}, {
					"name": "萧县",
					"id": "341322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341301",
					"child": []
				}, {
					"name": "灵璧县",
					"id": "341323",
					"child": []
				}, {
					"name": "埇桥区",
					"id": "341302",
					"child": []
				}, {
					"name": "泗县",
					"id": "341324",
					"child": []
				}]
			}, {
				"name": "黄山市",
				"id": "341000",
				"child": [{
					"name": "歙县",
					"id": "341021",
					"child": []
				}, {
					"name": "屯溪区",
					"id": "341002",
					"child": []
				}, {
					"name": "祁门县",
					"id": "341024",
					"child": []
				}, {
					"name": "黄山区",
					"id": "341003",
					"child": []
				}, {
					"name": "休宁县",
					"id": "341022",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341001",
					"child": []
				}, {
					"name": "黟县",
					"id": "341023",
					"child": []
				}, {
					"name": "徽州区",
					"id": "341004",
					"child": []
				}]
			}, {
				"name": "滁州市",
				"id": "341100",
				"child": [{
					"name": "天长市",
					"id": "341181",
					"child": []
				}, {
					"name": "明光市",
					"id": "341182",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341101",
					"child": []
				}, {
					"name": "琅琊区",
					"id": "341102",
					"child": []
				}, {
					"name": "全椒县",
					"id": "341124",
					"child": []
				}, {
					"name": "来安县",
					"id": "341122",
					"child": []
				}, {
					"name": "南谯区",
					"id": "341103",
					"child": []
				}, {
					"name": "定远县",
					"id": "341125",
					"child": []
				}, {
					"name": "凤阳县",
					"id": "341126",
					"child": []
				}]
			}, {
				"name": "马鞍山市",
				"id": "340500",
				"child": [{
					"name": "雨山区",
					"id": "340504",
					"child": []
				}, {
					"name": "花山区",
					"id": "340503",
					"child": []
				}, {
					"name": "博望区",
					"id": "340506",
					"child": []
				}, {
					"name": "含山县",
					"id": "340522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340501",
					"child": []
				}, {
					"name": "和县",
					"id": "340523",
					"child": []
				}, {
					"name": "当涂县",
					"id": "340521",
					"child": []
				}]
			}, {
				"name": "池州市",
				"id": "341700",
				"child": [{
					"name": "贵池区",
					"id": "341702",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341701",
					"child": []
				}, {
					"name": "青阳县",
					"id": "341723",
					"child": []
				}, {
					"name": "石台县",
					"id": "341722",
					"child": []
				}, {
					"name": "东至县",
					"id": "341721",
					"child": []
				}]
			}, {
				"name": "淮北市",
				"id": "340600",
				"child": [{
					"name": "相山区",
					"id": "340603",
					"child": []
				}, {
					"name": "烈山区",
					"id": "340604",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340601",
					"child": []
				}, {
					"name": "杜集区",
					"id": "340602",
					"child": []
				}, {
					"name": "濉溪县",
					"id": "340621",
					"child": []
				}]
			}, {
				"name": "亳州市",
				"id": "341600",
				"child": [{
					"name": "谯城区",
					"id": "341602",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341601",
					"child": []
				}, {
					"name": "利辛县",
					"id": "341623",
					"child": []
				}, {
					"name": "蒙城县",
					"id": "341622",
					"child": []
				}, {
					"name": "涡阳县",
					"id": "341621",
					"child": []
				}]
			}, {
				"name": "蚌埠市",
				"id": "340300",
				"child": [{
					"name": "禹会区",
					"id": "340304",
					"child": []
				}, {
					"name": "怀远县",
					"id": "340321",
					"child": []
				}, {
					"name": "龙子湖区",
					"id": "340302",
					"child": []
				}, {
					"name": "蚌山区",
					"id": "340303",
					"child": []
				}, {
					"name": "淮上区",
					"id": "340311",
					"child": []
				}, {
					"name": "五河县",
					"id": "340322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340301",
					"child": []
				}, {
					"name": "固镇县",
					"id": "340323",
					"child": []
				}]
			}, {
				"name": "六安市",
				"id": "341500",
				"child": [{
					"name": "叶集区",
					"id": "341504",
					"child": []
				}, {
					"name": "裕安区",
					"id": "341503",
					"child": []
				}, {
					"name": "霍山县",
					"id": "341525",
					"child": []
				}, {
					"name": "金安区",
					"id": "341502",
					"child": []
				}, {
					"name": "金寨县",
					"id": "341524",
					"child": []
				}, {
					"name": "市辖区",
					"id": "341501",
					"child": []
				}, {
					"name": "舒城县",
					"id": "341523",
					"child": []
				}, {
					"name": "霍邱县",
					"id": "341522",
					"child": []
				}]
			}, {
				"name": "淮南市",
				"id": "340400",
				"child": [{
					"name": "八公山区",
					"id": "340405",
					"child": []
				}, {
					"name": "潘集区",
					"id": "340406",
					"child": []
				}, {
					"name": "田家庵区",
					"id": "340403",
					"child": []
				}, {
					"name": "谢家集区",
					"id": "340404",
					"child": []
				}, {
					"name": "市辖区",
					"id": "340401",
					"child": []
				}, {
					"name": "大通区",
					"id": "340402",
					"child": []
				}, {
					"name": "凤台县",
					"id": "340421",
					"child": []
				}, {
					"name": "寿县",
					"id": "340422",
					"child": []
				}]
			}]
		},
		{
			"name": "澳门特别行政区",
			"id": "820000",
			"child": []
		},
		{
			"name": "湖南省",
			"id": "430000",
			"child": [{
				"name": "株洲市",
				"id": "430200",
				"child": [{
					"name": "天元区",
					"id": "430211",
					"child": []
				}, {
					"name": "株洲县",
					"id": "430221",
					"child": []
				}, {
					"name": "荷塘区",
					"id": "430202",
					"child": []
				}, {
					"name": "茶陵县",
					"id": "430224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430201",
					"child": []
				}, {
					"name": "攸县",
					"id": "430223",
					"child": []
				}, {
					"name": "石峰区",
					"id": "430204",
					"child": []
				}, {
					"name": "芦淞区",
					"id": "430203",
					"child": []
				}, {
					"name": "炎陵县",
					"id": "430225",
					"child": []
				}, {
					"name": "醴陵市",
					"id": "430281",
					"child": []
				}]
			}, {
				"name": "娄底市",
				"id": "431300",
				"child": [{
					"name": "新化县",
					"id": "431322",
					"child": []
				}, {
					"name": "双峰县",
					"id": "431321",
					"child": []
				}, {
					"name": "娄星区",
					"id": "431302",
					"child": []
				}, {
					"name": "市辖区",
					"id": "431301",
					"child": []
				}, {
					"name": "涟源市",
					"id": "431382",
					"child": []
				}, {
					"name": "冷水江市",
					"id": "431381",
					"child": []
				}]
			}, {
				"name": "长沙市",
				"id": "430100",
				"child": [{
					"name": "市辖区",
					"id": "430101",
					"child": []
				}, {
					"name": "望城区",
					"id": "430112",
					"child": []
				}, {
					"name": "雨花区",
					"id": "430111",
					"child": []
				}, {
					"name": "天心区",
					"id": "430103",
					"child": []
				}, {
					"name": "芙蓉区",
					"id": "430102",
					"child": []
				}, {
					"name": "宁乡县",
					"id": "430124",
					"child": []
				}, {
					"name": "开福区",
					"id": "430105",
					"child": []
				}, {
					"name": "岳麓区",
					"id": "430104",
					"child": []
				}, {
					"name": "浏阳市",
					"id": "430181",
					"child": []
				}, {
					"name": "长沙县",
					"id": "430121",
					"child": []
				}]
			}, {
				"name": "怀化市",
				"id": "431200",
				"child": [{
					"name": "市辖区",
					"id": "431201",
					"child": []
				}, {
					"name": "辰溪县",
					"id": "431223",
					"child": []
				}, {
					"name": "沅陵县",
					"id": "431222",
					"child": []
				}, {
					"name": "会同县",
					"id": "431225",
					"child": []
				}, {
					"name": "鹤城区",
					"id": "431202",
					"child": []
				}, {
					"name": "溆浦县",
					"id": "431224",
					"child": []
				}, {
					"name": "新晃侗族自治县",
					"id": "431227",
					"child": []
				}, {
					"name": "麻阳苗族自治县",
					"id": "431226",
					"child": []
				}, {
					"name": "靖州苗族侗族自治县",
					"id": "431229",
					"child": []
				}, {
					"name": "芷江侗族自治县",
					"id": "431228",
					"child": []
				}, {
					"name": "洪江市",
					"id": "431281",
					"child": []
				}, {
					"name": "通道侗族自治县",
					"id": "431230",
					"child": []
				}, {
					"name": "中方县",
					"id": "431221",
					"child": []
				}]
			}, {
				"name": "衡阳市",
				"id": "430400",
				"child": [{
					"name": "衡南县",
					"id": "430422",
					"child": []
				}, {
					"name": "衡阳县",
					"id": "430421",
					"child": []
				}, {
					"name": "衡东县",
					"id": "430424",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430401",
					"child": []
				}, {
					"name": "南岳区",
					"id": "430412",
					"child": []
				}, {
					"name": "衡山县",
					"id": "430423",
					"child": []
				}, {
					"name": "祁东县",
					"id": "430426",
					"child": []
				}, {
					"name": "雁峰区",
					"id": "430406",
					"child": []
				}, {
					"name": "珠晖区",
					"id": "430405",
					"child": []
				}, {
					"name": "蒸湘区",
					"id": "430408",
					"child": []
				}, {
					"name": "石鼓区",
					"id": "430407",
					"child": []
				}, {
					"name": "常宁市",
					"id": "430482",
					"child": []
				}, {
					"name": "耒阳市",
					"id": "430481",
					"child": []
				}]
			}, {
				"name": "湘潭市",
				"id": "430300",
				"child": [{
					"name": "湘潭县",
					"id": "430321",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430301",
					"child": []
				}, {
					"name": "雨湖区",
					"id": "430302",
					"child": []
				}, {
					"name": "岳塘区",
					"id": "430304",
					"child": []
				}, {
					"name": "湘乡市",
					"id": "430381",
					"child": []
				}, {
					"name": "韶山市",
					"id": "430382",
					"child": []
				}]
			}, {
				"name": "岳阳市",
				"id": "430600",
				"child": [{
					"name": "君山区",
					"id": "430611",
					"child": []
				}, {
					"name": "岳阳县",
					"id": "430621",
					"child": []
				}, {
					"name": "岳阳楼区",
					"id": "430602",
					"child": []
				}, {
					"name": "湘阴县",
					"id": "430624",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430601",
					"child": []
				}, {
					"name": "华容县",
					"id": "430623",
					"child": []
				}, {
					"name": "平江县",
					"id": "430626",
					"child": []
				}, {
					"name": "云溪区",
					"id": "430603",
					"child": []
				}, {
					"name": "临湘市",
					"id": "430682",
					"child": []
				}, {
					"name": "汨罗市",
					"id": "430681",
					"child": []
				}]
			}, {
				"name": "邵阳市",
				"id": "430500",
				"child": [{
					"name": "邵东县",
					"id": "430521",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430501",
					"child": []
				}, {
					"name": "邵阳县",
					"id": "430523",
					"child": []
				}, {
					"name": "北塔区",
					"id": "430511",
					"child": []
				}, {
					"name": "新邵县",
					"id": "430522",
					"child": []
				}, {
					"name": "大祥区",
					"id": "430503",
					"child": []
				}, {
					"name": "洞口县",
					"id": "430525",
					"child": []
				}, {
					"name": "双清区",
					"id": "430502",
					"child": []
				}, {
					"name": "隆回县",
					"id": "430524",
					"child": []
				}, {
					"name": "绥宁县",
					"id": "430527",
					"child": []
				}, {
					"name": "城步苗族自治县",
					"id": "430529",
					"child": []
				}, {
					"name": "新宁县",
					"id": "430528",
					"child": []
				}, {
					"name": "武冈市",
					"id": "430581",
					"child": []
				}]
			}, {
				"name": "张家界市",
				"id": "430800",
				"child": [{
					"name": "武陵源区",
					"id": "430811",
					"child": []
				}, {
					"name": "桑植县",
					"id": "430822",
					"child": []
				}, {
					"name": "慈利县",
					"id": "430821",
					"child": []
				}, {
					"name": "永定区",
					"id": "430802",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430801",
					"child": []
				}]
			}, {
				"name": "常德市",
				"id": "430700",
				"child": [{
					"name": "安乡县",
					"id": "430721",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430701",
					"child": []
				}, {
					"name": "澧县",
					"id": "430723",
					"child": []
				}, {
					"name": "汉寿县",
					"id": "430722",
					"child": []
				}, {
					"name": "鼎城区",
					"id": "430703",
					"child": []
				}, {
					"name": "桃源县",
					"id": "430725",
					"child": []
				}, {
					"name": "武陵区",
					"id": "430702",
					"child": []
				}, {
					"name": "临澧县",
					"id": "430724",
					"child": []
				}, {
					"name": "石门县",
					"id": "430726",
					"child": []
				}, {
					"name": "津市市",
					"id": "430781",
					"child": []
				}]
			}, {
				"name": "益阳市",
				"id": "430900",
				"child": [{
					"name": "沅江市",
					"id": "430981",
					"child": []
				}, {
					"name": "南县",
					"id": "430921",
					"child": []
				}, {
					"name": "市辖区",
					"id": "430901",
					"child": []
				}, {
					"name": "安化县",
					"id": "430923",
					"child": []
				}, {
					"name": "桃江县",
					"id": "430922",
					"child": []
				}, {
					"name": "赫山区",
					"id": "430903",
					"child": []
				}, {
					"name": "资阳区",
					"id": "430902",
					"child": []
				}]
			}, {
				"name": "永州市",
				"id": "431100",
				"child": [{
					"name": "零陵区",
					"id": "431102",
					"child": []
				}, {
					"name": "道县",
					"id": "431124",
					"child": []
				}, {
					"name": "市辖区",
					"id": "431101",
					"child": []
				}, {
					"name": "双牌县",
					"id": "431123",
					"child": []
				}, {
					"name": "宁远县",
					"id": "431126",
					"child": []
				}, {
					"name": "冷水滩区",
					"id": "431103",
					"child": []
				}, {
					"name": "江永县",
					"id": "431125",
					"child": []
				}, {
					"name": "新田县",
					"id": "431128",
					"child": []
				}, {
					"name": "蓝山县",
					"id": "431127",
					"child": []
				}, {
					"name": "江华瑶族自治县",
					"id": "431129",
					"child": []
				}, {
					"name": "东安县",
					"id": "431122",
					"child": []
				}, {
					"name": "祁阳县",
					"id": "431121",
					"child": []
				}]
			}, {
				"name": "郴州市",
				"id": "431000",
				"child": [{
					"name": "苏仙区",
					"id": "431003",
					"child": []
				}, {
					"name": "临武县",
					"id": "431025",
					"child": []
				}, {
					"name": "北湖区",
					"id": "431002",
					"child": []
				}, {
					"name": "嘉禾县",
					"id": "431024",
					"child": []
				}, {
					"name": "桂东县",
					"id": "431027",
					"child": []
				}, {
					"name": "汝城县",
					"id": "431026",
					"child": []
				}, {
					"name": "安仁县",
					"id": "431028",
					"child": []
				}, {
					"name": "资兴市",
					"id": "431081",
					"child": []
				}, {
					"name": "桂阳县",
					"id": "431021",
					"child": []
				}, {
					"name": "市辖区",
					"id": "431001",
					"child": []
				}, {
					"name": "永兴县",
					"id": "431023",
					"child": []
				}, {
					"name": "宜章县",
					"id": "431022",
					"child": []
				}]
			}, {
				"name": "湘西土家族苗族自治州",
				"id": "433100",
				"child": [{
					"name": "永顺县",
					"id": "433127",
					"child": []
				}, {
					"name": "保靖县",
					"id": "433125",
					"child": []
				}, {
					"name": "古丈县",
					"id": "433126",
					"child": []
				}, {
					"name": "龙山县",
					"id": "433130",
					"child": []
				}, {
					"name": "吉首市",
					"id": "433101",
					"child": []
				}, {
					"name": "凤凰县",
					"id": "433123",
					"child": []
				}, {
					"name": "花垣县",
					"id": "433124",
					"child": []
				}, {
					"name": "泸溪县",
					"id": "433122",
					"child": []
				}]
			}]
		},
		{
			"name": "河北省",
			"id": "130000",
			"child": [{
				"name": "石家庄市",
				"id": "130100",
				"child": [{
					"name": "鹿泉区",
					"id": "130110",
					"child": []
				}, {
					"name": "井陉县",
					"id": "130121",
					"child": []
				}, {
					"name": "元氏县",
					"id": "130132",
					"child": []
				}, {
					"name": "栾城区",
					"id": "130111",
					"child": []
				}, {
					"name": "赵县",
					"id": "130133",
					"child": []
				}, {
					"name": "无极县",
					"id": "130130",
					"child": []
				}, {
					"name": "平山县",
					"id": "130131",
					"child": []
				}, {
					"name": "行唐县",
					"id": "130125",
					"child": []
				}, {
					"name": "桥西区",
					"id": "130104",
					"child": []
				}, {
					"name": "灵寿县",
					"id": "130126",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130101",
					"child": []
				}, {
					"name": "正定县",
					"id": "130123",
					"child": []
				}, {
					"name": "长安区",
					"id": "130102",
					"child": []
				}, {
					"name": "井陉矿区",
					"id": "130107",
					"child": []
				}, {
					"name": "赞皇县",
					"id": "130129",
					"child": []
				}, {
					"name": "裕华区",
					"id": "130108",
					"child": []
				}, {
					"name": "新华区",
					"id": "130105",
					"child": []
				}, {
					"name": "高邑县",
					"id": "130127",
					"child": []
				}, {
					"name": "深泽县",
					"id": "130128",
					"child": []
				}, {
					"name": "藁城区",
					"id": "130109",
					"child": []
				}, {
					"name": "晋州市",
					"id": "130183",
					"child": []
				}, {
					"name": "新乐市",
					"id": "130184",
					"child": []
				}]
			}, {
				"name": "衡水市",
				"id": "131100",
				"child": [{
					"name": "市辖区",
					"id": "131101",
					"child": []
				}, {
					"name": "武强县",
					"id": "131123",
					"child": []
				}, {
					"name": "武邑县",
					"id": "131122",
					"child": []
				}, {
					"name": "枣强县",
					"id": "131121",
					"child": []
				}, {
					"name": "景县",
					"id": "131127",
					"child": []
				}, {
					"name": "故城县",
					"id": "131126",
					"child": []
				}, {
					"name": "冀州区",
					"id": "131103",
					"child": []
				}, {
					"name": "安平县",
					"id": "131125",
					"child": []
				}, {
					"name": "桃城区",
					"id": "131102",
					"child": []
				}, {
					"name": "饶阳县",
					"id": "131124",
					"child": []
				}, {
					"name": "阜城县",
					"id": "131128",
					"child": []
				}, {
					"name": "深州市",
					"id": "131182",
					"child": []
				}]
			}, {
				"name": "廊坊市",
				"id": "131000",
				"child": [{
					"name": "安次区",
					"id": "131002",
					"child": []
				}, {
					"name": "香河县",
					"id": "131024",
					"child": []
				}, {
					"name": "市辖区",
					"id": "131001",
					"child": []
				}, {
					"name": "永清县",
					"id": "131023",
					"child": []
				}, {
					"name": "固安县",
					"id": "131022",
					"child": []
				}, {
					"name": "大厂回族自治县",
					"id": "131028",
					"child": []
				}, {
					"name": "文安县",
					"id": "131026",
					"child": []
				}, {
					"name": "广阳区",
					"id": "131003",
					"child": []
				}, {
					"name": "大城县",
					"id": "131025",
					"child": []
				}, {
					"name": "三河市",
					"id": "131082",
					"child": []
				}, {
					"name": "霸州市",
					"id": "131081",
					"child": []
				}]
			}, {
				"name": "邯郸市",
				"id": "130400",
				"child": [{
					"name": "邱县",
					"id": "130430",
					"child": []
				}, {
					"name": "馆陶县",
					"id": "130433",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130401",
					"child": []
				}, {
					"name": "临漳县",
					"id": "130423",
					"child": []
				}, {
					"name": "魏县",
					"id": "130434",
					"child": []
				}, {
					"name": "鸡泽县",
					"id": "130431",
					"child": []
				}, {
					"name": "邯郸县",
					"id": "130421",
					"child": []
				}, {
					"name": "广平县",
					"id": "130432",
					"child": []
				}, {
					"name": "复兴区",
					"id": "130404",
					"child": []
				}, {
					"name": "涉县",
					"id": "130426",
					"child": []
				}, {
					"name": "磁县",
					"id": "130427",
					"child": []
				}, {
					"name": "邯山区",
					"id": "130402",
					"child": []
				}, {
					"name": "成安县",
					"id": "130424",
					"child": []
				}, {
					"name": "曲周县",
					"id": "130435",
					"child": []
				}, {
					"name": "丛台区",
					"id": "130403",
					"child": []
				}, {
					"name": "大名县",
					"id": "130425",
					"child": []
				}, {
					"name": "峰峰矿区",
					"id": "130406",
					"child": []
				}, {
					"name": "肥乡县",
					"id": "130428",
					"child": []
				}, {
					"name": "永年县",
					"id": "130429",
					"child": []
				}, {
					"name": "武安市",
					"id": "130481",
					"child": []
				}]
			}, {
				"name": "邢台市",
				"id": "130500",
				"child": [{
					"name": "南宫市",
					"id": "130581",
					"child": []
				}, {
					"name": "沙河市",
					"id": "130582",
					"child": []
				}, {
					"name": "邢台县",
					"id": "130521",
					"child": []
				}, {
					"name": "平乡县",
					"id": "130532",
					"child": []
				}, {
					"name": "临城县",
					"id": "130522",
					"child": []
				}, {
					"name": "威县",
					"id": "130533",
					"child": []
				}, {
					"name": "新河县",
					"id": "130530",
					"child": []
				}, {
					"name": "广宗县",
					"id": "130531",
					"child": []
				}, {
					"name": "桥西区",
					"id": "130503",
					"child": []
				}, {
					"name": "隆尧县",
					"id": "130525",
					"child": []
				}, {
					"name": "任县",
					"id": "130526",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130501",
					"child": []
				}, {
					"name": "内丘县",
					"id": "130523",
					"child": []
				}, {
					"name": "清河县",
					"id": "130534",
					"child": []
				}, {
					"name": "桥东区",
					"id": "130502",
					"child": []
				}, {
					"name": "柏乡县",
					"id": "130524",
					"child": []
				}, {
					"name": "临西县",
					"id": "130535",
					"child": []
				}, {
					"name": "巨鹿县",
					"id": "130529",
					"child": []
				}, {
					"name": "南和县",
					"id": "130527",
					"child": []
				}, {
					"name": "宁晋县",
					"id": "130528",
					"child": []
				}]
			}, {
				"name": "唐山市",
				"id": "130200",
				"child": [{
					"name": "路南区",
					"id": "130202",
					"child": []
				}, {
					"name": "滦南县",
					"id": "130224",
					"child": []
				}, {
					"name": "路北区",
					"id": "130203",
					"child": []
				}, {
					"name": "乐亭县",
					"id": "130225",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130201",
					"child": []
				}, {
					"name": "滦县",
					"id": "130223",
					"child": []
				}, {
					"name": "丰南区",
					"id": "130207",
					"child": []
				}, {
					"name": "玉田县",
					"id": "130229",
					"child": []
				}, {
					"name": "古冶区",
					"id": "130204",
					"child": []
				}, {
					"name": "开平区",
					"id": "130205",
					"child": []
				}, {
					"name": "迁西县",
					"id": "130227",
					"child": []
				}, {
					"name": "丰润区",
					"id": "130208",
					"child": []
				}, {
					"name": "曹妃甸区",
					"id": "130209",
					"child": []
				}, {
					"name": "迁安市",
					"id": "130283",
					"child": []
				}, {
					"name": "遵化市",
					"id": "130281",
					"child": []
				}]
			}, {
				"name": "秦皇岛市",
				"id": "130300",
				"child": [{
					"name": "市辖区",
					"id": "130301",
					"child": []
				}, {
					"name": "海港区",
					"id": "130302",
					"child": []
				}, {
					"name": "卢龙县",
					"id": "130324",
					"child": []
				}, {
					"name": "青龙满族自治县",
					"id": "130321",
					"child": []
				}, {
					"name": "昌黎县",
					"id": "130322",
					"child": []
				}, {
					"name": "抚宁区",
					"id": "130306",
					"child": []
				}, {
					"name": "山海关区",
					"id": "130303",
					"child": []
				}, {
					"name": "北戴河区",
					"id": "130304",
					"child": []
				}]
			}, {
				"name": "承德市",
				"id": "130800",
				"child": [{
					"name": "围场满族蒙古族自治县",
					"id": "130828",
					"child": []
				}, {
					"name": "兴隆县",
					"id": "130822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130801",
					"child": []
				}, {
					"name": "平泉县",
					"id": "130823",
					"child": []
				}, {
					"name": "承德县",
					"id": "130821",
					"child": []
				}, {
					"name": "鹰手营子矿区",
					"id": "130804",
					"child": []
				}, {
					"name": "丰宁满族自治县",
					"id": "130826",
					"child": []
				}, {
					"name": "宽城满族自治县",
					"id": "130827",
					"child": []
				}, {
					"name": "双桥区",
					"id": "130802",
					"child": []
				}, {
					"name": "滦平县",
					"id": "130824",
					"child": []
				}, {
					"name": "双滦区",
					"id": "130803",
					"child": []
				}, {
					"name": "隆化县",
					"id": "130825",
					"child": []
				}]
			}, {
				"name": "沧州市",
				"id": "130900",
				"child": [{
					"name": "黄骅市",
					"id": "130983",
					"child": []
				}, {
					"name": "河间市",
					"id": "130984",
					"child": []
				}, {
					"name": "泊头市",
					"id": "130981",
					"child": []
				}, {
					"name": "任丘市",
					"id": "130982",
					"child": []
				}, {
					"name": "沧县",
					"id": "130921",
					"child": []
				}, {
					"name": "青县",
					"id": "130922",
					"child": []
				}, {
					"name": "孟村回族自治县",
					"id": "130930",
					"child": []
				}, {
					"name": "运河区",
					"id": "130903",
					"child": []
				}, {
					"name": "盐山县",
					"id": "130925",
					"child": []
				}, {
					"name": "肃宁县",
					"id": "130926",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130901",
					"child": []
				}, {
					"name": "东光县",
					"id": "130923",
					"child": []
				}, {
					"name": "新华区",
					"id": "130902",
					"child": []
				}, {
					"name": "海兴县",
					"id": "130924",
					"child": []
				}, {
					"name": "献县",
					"id": "130929",
					"child": []
				}, {
					"name": "南皮县",
					"id": "130927",
					"child": []
				}, {
					"name": "吴桥县",
					"id": "130928",
					"child": []
				}]
			}, {
				"name": "保定市",
				"id": "130600",
				"child": [{
					"name": "安国市",
					"id": "130683",
					"child": []
				}, {
					"name": "涿州市",
					"id": "130681",
					"child": []
				}, {
					"name": "望都县",
					"id": "130631",
					"child": []
				}, {
					"name": "安新县",
					"id": "130632",
					"child": []
				}, {
					"name": "高碑店市",
					"id": "130684",
					"child": []
				}, {
					"name": "涞源县",
					"id": "130630",
					"child": []
				}, {
					"name": "竞秀区",
					"id": "130602",
					"child": []
				}, {
					"name": "阜平县",
					"id": "130624",
					"child": []
				}, {
					"name": "蠡县",
					"id": "130635",
					"child": []
				}, {
					"name": "顺平县",
					"id": "130636",
					"child": []
				}, {
					"name": "易县",
					"id": "130633",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130601",
					"child": []
				}, {
					"name": "涞水县",
					"id": "130623",
					"child": []
				}, {
					"name": "曲阳县",
					"id": "130634",
					"child": []
				}, {
					"name": "莲池区",
					"id": "130606",
					"child": []
				}, {
					"name": "高阳县",
					"id": "130628",
					"child": []
				}, {
					"name": "满城区",
					"id": "130607",
					"child": []
				}, {
					"name": "容城县",
					"id": "130629",
					"child": []
				}, {
					"name": "定兴县",
					"id": "130626",
					"child": []
				}, {
					"name": "博野县",
					"id": "130637",
					"child": []
				}, {
					"name": "唐县",
					"id": "130627",
					"child": []
				}, {
					"name": "雄县",
					"id": "130638",
					"child": []
				}, {
					"name": "清苑区",
					"id": "130608",
					"child": []
				}, {
					"name": "徐水区",
					"id": "130609",
					"child": []
				}]
			}, {
				"name": "张家口市",
				"id": "130700",
				"child": [{
					"name": "怀来县",
					"id": "130730",
					"child": []
				}, {
					"name": "涿鹿县",
					"id": "130731",
					"child": []
				}, {
					"name": "市辖区",
					"id": "130701",
					"child": []
				}, {
					"name": "康保县",
					"id": "130723",
					"child": []
				}, {
					"name": "桥东区",
					"id": "130702",
					"child": []
				}, {
					"name": "沽源县",
					"id": "130724",
					"child": []
				}, {
					"name": "赤城县",
					"id": "130732",
					"child": []
				}, {
					"name": "张北县",
					"id": "130722",
					"child": []
				}, {
					"name": "宣化区",
					"id": "130705",
					"child": []
				}, {
					"name": "阳原县",
					"id": "130727",
					"child": []
				}, {
					"name": "下花园区",
					"id": "130706",
					"child": []
				}, {
					"name": "怀安县",
					"id": "130728",
					"child": []
				}, {
					"name": "桥西区",
					"id": "130703",
					"child": []
				}, {
					"name": "尚义县",
					"id": "130725",
					"child": []
				}, {
					"name": "蔚县",
					"id": "130726",
					"child": []
				}, {
					"name": "崇礼区",
					"id": "130709",
					"child": []
				}, {
					"name": "万全区",
					"id": "130708",
					"child": []
				}]
			}, {
				"name": "省直辖县级行政区划",
				"id": "139000",
				"child": [{
					"name": "定州市",
					"id": "139001",
					"child": []
				}, {
					"name": "辛集市",
					"id": "139002",
					"child": []
				}]
			}]
		},
		{
			"name": "香港特别行政区",
			"id": "810000",
			"child": []
		},
		{
			"name": "辽宁省",
			"id": "210000",
			"child": [{
				"name": "盘锦市",
				"id": "211100",
				"child": [{
					"name": "盘山县",
					"id": "211122",
					"child": []
				}, {
					"name": "大洼区",
					"id": "211104",
					"child": []
				}, {
					"name": "兴隆台区",
					"id": "211103",
					"child": []
				}, {
					"name": "双台子区",
					"id": "211102",
					"child": []
				}, {
					"name": "市辖区",
					"id": "211101",
					"child": []
				}]
			}, {
				"name": "辽阳市",
				"id": "211000",
				"child": [{
					"name": "市辖区",
					"id": "211001",
					"child": []
				}, {
					"name": "太子河区",
					"id": "211011",
					"child": []
				}, {
					"name": "辽阳县",
					"id": "211021",
					"child": []
				}, {
					"name": "弓长岭区",
					"id": "211005",
					"child": []
				}, {
					"name": "宏伟区",
					"id": "211004",
					"child": []
				}, {
					"name": "文圣区",
					"id": "211003",
					"child": []
				}, {
					"name": "白塔区",
					"id": "211002",
					"child": []
				}, {
					"name": "灯塔市",
					"id": "211081",
					"child": []
				}]
			}, {
				"name": "阜新市",
				"id": "210900",
				"child": [{
					"name": "新邱区",
					"id": "210903",
					"child": []
				}, {
					"name": "海州区",
					"id": "210902",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210901",
					"child": []
				}, {
					"name": "细河区",
					"id": "210911",
					"child": []
				}, {
					"name": "彰武县",
					"id": "210922",
					"child": []
				}, {
					"name": "清河门区",
					"id": "210905",
					"child": []
				}, {
					"name": "太平区",
					"id": "210904",
					"child": []
				}, {
					"name": "阜新蒙古族自治县",
					"id": "210921",
					"child": []
				}]
			}, {
				"name": "抚顺市",
				"id": "210400",
				"child": [{
					"name": "顺城区",
					"id": "210411",
					"child": []
				}, {
					"name": "新宾满族自治县",
					"id": "210422",
					"child": []
				}, {
					"name": "抚顺县",
					"id": "210421",
					"child": []
				}, {
					"name": "望花区",
					"id": "210404",
					"child": []
				}, {
					"name": "东洲区",
					"id": "210403",
					"child": []
				}, {
					"name": "新抚区",
					"id": "210402",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210401",
					"child": []
				}, {
					"name": "清原满族自治县",
					"id": "210423",
					"child": []
				}]
			}, {
				"name": "鞍山市",
				"id": "210300",
				"child": [{
					"name": "海城市",
					"id": "210381",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210301",
					"child": []
				}, {
					"name": "岫岩满族自治县",
					"id": "210323",
					"child": []
				}, {
					"name": "千山区",
					"id": "210311",
					"child": []
				}, {
					"name": "台安县",
					"id": "210321",
					"child": []
				}, {
					"name": "立山区",
					"id": "210304",
					"child": []
				}, {
					"name": "铁西区",
					"id": "210303",
					"child": []
				}, {
					"name": "铁东区",
					"id": "210302",
					"child": []
				}]
			}, {
				"name": "葫芦岛市",
				"id": "211400",
				"child": [{
					"name": "兴城市",
					"id": "211481",
					"child": []
				}, {
					"name": "市辖区",
					"id": "211401",
					"child": []
				}, {
					"name": "建昌县",
					"id": "211422",
					"child": []
				}, {
					"name": "绥中县",
					"id": "211421",
					"child": []
				}, {
					"name": "南票区",
					"id": "211404",
					"child": []
				}, {
					"name": "龙港区",
					"id": "211403",
					"child": []
				}, {
					"name": "连山区",
					"id": "211402",
					"child": []
				}]
			}, {
				"name": "大连市",
				"id": "210200",
				"child": [{
					"name": "瓦房店市",
					"id": "210281",
					"child": []
				}, {
					"name": "庄河市",
					"id": "210283",
					"child": []
				}, {
					"name": "中山区",
					"id": "210202",
					"child": []
				}, {
					"name": "金州区",
					"id": "210213",
					"child": []
				}, {
					"name": "长海县",
					"id": "210224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210201",
					"child": []
				}, {
					"name": "旅顺口区",
					"id": "210212",
					"child": []
				}, {
					"name": "甘井子区",
					"id": "210211",
					"child": []
				}, {
					"name": "沙河口区",
					"id": "210204",
					"child": []
				}, {
					"name": "西岗区",
					"id": "210203",
					"child": []
				}, {
					"name": "普兰店区",
					"id": "210214",
					"child": []
				}]
			}, {
				"name": "朝阳市",
				"id": "211300",
				"child": [{
					"name": "凌源市",
					"id": "211382",
					"child": []
				}, {
					"name": "北票市",
					"id": "211381",
					"child": []
				}, {
					"name": "双塔区",
					"id": "211302",
					"child": []
				}, {
					"name": "喀喇沁左翼蒙古族自治县",
					"id": "211324",
					"child": []
				}, {
					"name": "市辖区",
					"id": "211301",
					"child": []
				}, {
					"name": "建平县",
					"id": "211322",
					"child": []
				}, {
					"name": "朝阳县",
					"id": "211321",
					"child": []
				}, {
					"name": "龙城区",
					"id": "211303",
					"child": []
				}]
			}, {
				"name": "沈阳市",
				"id": "210100",
				"child": [{
					"name": "新民市",
					"id": "210181",
					"child": []
				}, {
					"name": "沈河区",
					"id": "210103",
					"child": []
				}, {
					"name": "于洪区",
					"id": "210114",
					"child": []
				}, {
					"name": "和平区",
					"id": "210102",
					"child": []
				}, {
					"name": "沈北新区",
					"id": "210113",
					"child": []
				}, {
					"name": "法库县",
					"id": "210124",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210101",
					"child": []
				}, {
					"name": "浑南区",
					"id": "210112",
					"child": []
				}, {
					"name": "康平县",
					"id": "210123",
					"child": []
				}, {
					"name": "苏家屯区",
					"id": "210111",
					"child": []
				}, {
					"name": "铁西区",
					"id": "210106",
					"child": []
				}, {
					"name": "皇姑区",
					"id": "210105",
					"child": []
				}, {
					"name": "大东区",
					"id": "210104",
					"child": []
				}, {
					"name": "辽中区",
					"id": "210115",
					"child": []
				}]
			}, {
				"name": "铁岭市",
				"id": "211200",
				"child": [{
					"name": "开原市",
					"id": "211282",
					"child": []
				}, {
					"name": "调兵山市",
					"id": "211281",
					"child": []
				}, {
					"name": "铁岭县",
					"id": "211221",
					"child": []
				}, {
					"name": "银州区",
					"id": "211202",
					"child": []
				}, {
					"name": "昌图县",
					"id": "211224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "211201",
					"child": []
				}, {
					"name": "西丰县",
					"id": "211223",
					"child": []
				}, {
					"name": "清河区",
					"id": "211204",
					"child": []
				}]
			}, {
				"name": "营口市",
				"id": "210800",
				"child": [{
					"name": "鲅鱼圈区",
					"id": "210804",
					"child": []
				}, {
					"name": "西市区",
					"id": "210803",
					"child": []
				}, {
					"name": "站前区",
					"id": "210802",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210801",
					"child": []
				}, {
					"name": "大石桥市",
					"id": "210882",
					"child": []
				}, {
					"name": "盖州市",
					"id": "210881",
					"child": []
				}, {
					"name": "老边区",
					"id": "210811",
					"child": []
				}]
			}, {
				"name": "锦州市",
				"id": "210700",
				"child": [{
					"name": "义县",
					"id": "210727",
					"child": []
				}, {
					"name": "黑山县",
					"id": "210726",
					"child": []
				}, {
					"name": "凌河区",
					"id": "210703",
					"child": []
				}, {
					"name": "古塔区",
					"id": "210702",
					"child": []
				}, {
					"name": "凌海市",
					"id": "210781",
					"child": []
				}, {
					"name": "北镇市",
					"id": "210782",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210701",
					"child": []
				}, {
					"name": "太和区",
					"id": "210711",
					"child": []
				}]
			}, {
				"name": "丹东市",
				"id": "210600",
				"child": [{
					"name": "振安区",
					"id": "210604",
					"child": []
				}, {
					"name": "振兴区",
					"id": "210603",
					"child": []
				}, {
					"name": "凤城市",
					"id": "210682",
					"child": []
				}, {
					"name": "东港市",
					"id": "210681",
					"child": []
				}, {
					"name": "元宝区",
					"id": "210602",
					"child": []
				}, {
					"name": "宽甸满族自治县",
					"id": "210624",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210601",
					"child": []
				}]
			}, {
				"name": "本溪市",
				"id": "210500",
				"child": [{
					"name": "南芬区",
					"id": "210505",
					"child": []
				}, {
					"name": "明山区",
					"id": "210504",
					"child": []
				}, {
					"name": "本溪满族自治县",
					"id": "210521",
					"child": []
				}, {
					"name": "溪湖区",
					"id": "210503",
					"child": []
				}, {
					"name": "平山区",
					"id": "210502",
					"child": []
				}, {
					"name": "市辖区",
					"id": "210501",
					"child": []
				}, {
					"name": "桓仁满族自治县",
					"id": "210522",
					"child": []
				}]
			}]
		},
		{
			"name": "四川省",
			"id": "510000",
			"child": [{
				"name": "资阳市",
				"id": "512000",
				"child": [{
					"name": "乐至县",
					"id": "512022",
					"child": []
				}, {
					"name": "市辖区",
					"id": "512001",
					"child": []
				}, {
					"name": "安岳县",
					"id": "512021",
					"child": []
				}, {
					"name": "雁江区",
					"id": "512002",
					"child": []
				}]
			}, {
				"name": "阿坝藏族羌族自治州",
				"id": "513200",
				"child": [{
					"name": "理县",
					"id": "513222",
					"child": []
				}, {
					"name": "红原县",
					"id": "513233",
					"child": []
				}, {
					"name": "汶川县",
					"id": "513221",
					"child": []
				}, {
					"name": "若尔盖县",
					"id": "513232",
					"child": []
				}, {
					"name": "阿坝县",
					"id": "513231",
					"child": []
				}, {
					"name": "壤塘县",
					"id": "513230",
					"child": []
				}, {
					"name": "金川县",
					"id": "513226",
					"child": []
				}, {
					"name": "九寨沟县",
					"id": "513225",
					"child": []
				}, {
					"name": "松潘县",
					"id": "513224",
					"child": []
				}, {
					"name": "马尔康市",
					"id": "513201",
					"child": []
				}, {
					"name": "茂县",
					"id": "513223",
					"child": []
				}, {
					"name": "黑水县",
					"id": "513228",
					"child": []
				}, {
					"name": "小金县",
					"id": "513227",
					"child": []
				}]
			}, {
				"name": "内江市",
				"id": "511000",
				"child": [{
					"name": "东兴区",
					"id": "511011",
					"child": []
				}, {
					"name": "资中县",
					"id": "511025",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511001",
					"child": []
				}, {
					"name": "市中区",
					"id": "511002",
					"child": []
				}, {
					"name": "威远县",
					"id": "511024",
					"child": []
				}, {
					"name": "隆昌县",
					"id": "511028",
					"child": []
				}]
			}, {
				"name": "成都市",
				"id": "510100",
				"child": [{
					"name": "崇州市",
					"id": "510184",
					"child": []
				}, {
					"name": "邛崃市",
					"id": "510183",
					"child": []
				}, {
					"name": "蒲江县",
					"id": "510131",
					"child": []
				}, {
					"name": "简阳市",
					"id": "510185",
					"child": []
				}, {
					"name": "金堂县",
					"id": "510121",
					"child": []
				}, {
					"name": "新津县",
					"id": "510132",
					"child": []
				}, {
					"name": "青白江区",
					"id": "510113",
					"child": []
				}, {
					"name": "郫县",
					"id": "510124",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510101",
					"child": []
				}, {
					"name": "龙泉驿区",
					"id": "510112",
					"child": []
				}, {
					"name": "彭州市",
					"id": "510182",
					"child": []
				}, {
					"name": "都江堰市",
					"id": "510181",
					"child": []
				}, {
					"name": "锦江区",
					"id": "510104",
					"child": []
				}, {
					"name": "温江区",
					"id": "510115",
					"child": []
				}, {
					"name": "新都区",
					"id": "510114",
					"child": []
				}, {
					"name": "金牛区",
					"id": "510106",
					"child": []
				}, {
					"name": "青羊区",
					"id": "510105",
					"child": []
				}, {
					"name": "双流区",
					"id": "510116",
					"child": []
				}, {
					"name": "成华区",
					"id": "510108",
					"child": []
				}, {
					"name": "武侯区",
					"id": "510107",
					"child": []
				}, {
					"name": "大邑县",
					"id": "510129",
					"child": []
				}]
			}, {
				"name": "南充市",
				"id": "511300",
				"child": [{
					"name": "营山县",
					"id": "511322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511301",
					"child": []
				}, {
					"name": "蓬安县",
					"id": "511323",
					"child": []
				}, {
					"name": "南部县",
					"id": "511321",
					"child": []
				}, {
					"name": "嘉陵区",
					"id": "511304",
					"child": []
				}, {
					"name": "顺庆区",
					"id": "511302",
					"child": []
				}, {
					"name": "仪陇县",
					"id": "511324",
					"child": []
				}, {
					"name": "高坪区",
					"id": "511303",
					"child": []
				}, {
					"name": "西充县",
					"id": "511325",
					"child": []
				}, {
					"name": "阆中市",
					"id": "511381",
					"child": []
				}]
			}, {
				"name": "眉山市",
				"id": "511400",
				"child": [{
					"name": "仁寿县",
					"id": "511421",
					"child": []
				}, {
					"name": "彭山区",
					"id": "511403",
					"child": []
				}, {
					"name": "青神县",
					"id": "511425",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511401",
					"child": []
				}, {
					"name": "洪雅县",
					"id": "511423",
					"child": []
				}, {
					"name": "东坡区",
					"id": "511402",
					"child": []
				}, {
					"name": "丹棱县",
					"id": "511424",
					"child": []
				}]
			}, {
				"name": "自贡市",
				"id": "510300",
				"child": [{
					"name": "沿滩区",
					"id": "510311",
					"child": []
				}, {
					"name": "富顺县",
					"id": "510322",
					"child": []
				}, {
					"name": "荣县",
					"id": "510321",
					"child": []
				}, {
					"name": "自流井区",
					"id": "510302",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510301",
					"child": []
				}, {
					"name": "大安区",
					"id": "510304",
					"child": []
				}, {
					"name": "贡井区",
					"id": "510303",
					"child": []
				}]
			}, {
				"name": "乐山市",
				"id": "511100",
				"child": [{
					"name": "峨边彝族自治县",
					"id": "511132",
					"child": []
				}, {
					"name": "市中区",
					"id": "511102",
					"child": []
				}, {
					"name": "金口河区",
					"id": "511113",
					"child": []
				}, {
					"name": "井研县",
					"id": "511124",
					"child": []
				}, {
					"name": "沙湾区",
					"id": "511111",
					"child": []
				}, {
					"name": "马边彝族自治县",
					"id": "511133",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511101",
					"child": []
				}, {
					"name": "五通桥区",
					"id": "511112",
					"child": []
				}, {
					"name": "犍为县",
					"id": "511123",
					"child": []
				}, {
					"name": "沐川县",
					"id": "511129",
					"child": []
				}, {
					"name": "夹江县",
					"id": "511126",
					"child": []
				}, {
					"name": "峨眉山市",
					"id": "511181",
					"child": []
				}]
			}, {
				"name": "凉山彝族自治州",
				"id": "513400",
				"child": [{
					"name": "昭觉县",
					"id": "513431",
					"child": []
				}, {
					"name": "金阳县",
					"id": "513430",
					"child": []
				}, {
					"name": "德昌县",
					"id": "513424",
					"child": []
				}, {
					"name": "甘洛县",
					"id": "513435",
					"child": []
				}, {
					"name": "西昌市",
					"id": "513401",
					"child": []
				}, {
					"name": "盐源县",
					"id": "513423",
					"child": []
				}, {
					"name": "越西县",
					"id": "513434",
					"child": []
				}, {
					"name": "木里藏族自治县",
					"id": "513422",
					"child": []
				}, {
					"name": "冕宁县",
					"id": "513433",
					"child": []
				}, {
					"name": "喜德县",
					"id": "513432",
					"child": []
				}, {
					"name": "普格县",
					"id": "513428",
					"child": []
				}, {
					"name": "宁南县",
					"id": "513427",
					"child": []
				}, {
					"name": "会东县",
					"id": "513426",
					"child": []
				}, {
					"name": "雷波县",
					"id": "513437",
					"child": []
				}, {
					"name": "会理县",
					"id": "513425",
					"child": []
				}, {
					"name": "美姑县",
					"id": "513436",
					"child": []
				}, {
					"name": "布拖县",
					"id": "513429",
					"child": []
				}]
			}, {
				"name": "甘孜藏族自治州",
				"id": "513300",
				"child": [{
					"name": "石渠县",
					"id": "513332",
					"child": []
				}, {
					"name": "白玉县",
					"id": "513331",
					"child": []
				}, {
					"name": "德格县",
					"id": "513330",
					"child": []
				}, {
					"name": "雅江县",
					"id": "513325",
					"child": []
				}, {
					"name": "乡城县",
					"id": "513336",
					"child": []
				}, {
					"name": "九龙县",
					"id": "513324",
					"child": []
				}, {
					"name": "巴塘县",
					"id": "513335",
					"child": []
				}, {
					"name": "康定市",
					"id": "513301",
					"child": []
				}, {
					"name": "丹巴县",
					"id": "513323",
					"child": []
				}, {
					"name": "理塘县",
					"id": "513334",
					"child": []
				}, {
					"name": "泸定县",
					"id": "513322",
					"child": []
				}, {
					"name": "色达县",
					"id": "513333",
					"child": []
				}, {
					"name": "新龙县",
					"id": "513329",
					"child": []
				}, {
					"name": "甘孜县",
					"id": "513328",
					"child": []
				}, {
					"name": "炉霍县",
					"id": "513327",
					"child": []
				}, {
					"name": "得荣县",
					"id": "513338",
					"child": []
				}, {
					"name": "道孚县",
					"id": "513326",
					"child": []
				}, {
					"name": "稻城县",
					"id": "513337",
					"child": []
				}]
			}, {
				"name": "泸州市",
				"id": "510500",
				"child": [{
					"name": "合江县",
					"id": "510522",
					"child": []
				}, {
					"name": "泸县",
					"id": "510521",
					"child": []
				}, {
					"name": "江阳区",
					"id": "510502",
					"child": []
				}, {
					"name": "叙永县",
					"id": "510524",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510501",
					"child": []
				}, {
					"name": "龙马潭区",
					"id": "510504",
					"child": []
				}, {
					"name": "纳溪区",
					"id": "510503",
					"child": []
				}, {
					"name": "古蔺县",
					"id": "510525",
					"child": []
				}]
			}, {
				"name": "达州市",
				"id": "511700",
				"child": [{
					"name": "万源市",
					"id": "511781",
					"child": []
				}, {
					"name": "宣汉县",
					"id": "511722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511701",
					"child": []
				}, {
					"name": "开江县",
					"id": "511723",
					"child": []
				}, {
					"name": "通川区",
					"id": "511702",
					"child": []
				}, {
					"name": "大竹县",
					"id": "511724",
					"child": []
				}, {
					"name": "达川区",
					"id": "511703",
					"child": []
				}, {
					"name": "渠县",
					"id": "511725",
					"child": []
				}]
			}, {
				"name": "攀枝花市",
				"id": "510400",
				"child": [{
					"name": "米易县",
					"id": "510421",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510401",
					"child": []
				}, {
					"name": "仁和区",
					"id": "510411",
					"child": []
				}, {
					"name": "盐边县",
					"id": "510422",
					"child": []
				}, {
					"name": "西区",
					"id": "510403",
					"child": []
				}, {
					"name": "东区",
					"id": "510402",
					"child": []
				}]
			}, {
				"name": "雅安市",
				"id": "511800",
				"child": [{
					"name": "宝兴县",
					"id": "511827",
					"child": []
				}, {
					"name": "荥经县",
					"id": "511822",
					"child": []
				}, {
					"name": "名山区",
					"id": "511803",
					"child": []
				}, {
					"name": "天全县",
					"id": "511825",
					"child": []
				}, {
					"name": "芦山县",
					"id": "511826",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511801",
					"child": []
				}, {
					"name": "汉源县",
					"id": "511823",
					"child": []
				}, {
					"name": "雨城区",
					"id": "511802",
					"child": []
				}, {
					"name": "石棉县",
					"id": "511824",
					"child": []
				}]
			}, {
				"name": "绵阳市",
				"id": "510700",
				"child": [{
					"name": "安州区",
					"id": "510705",
					"child": []
				}, {
					"name": "平武县",
					"id": "510727",
					"child": []
				}, {
					"name": "江油市",
					"id": "510781",
					"child": []
				}, {
					"name": "三台县",
					"id": "510722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510701",
					"child": []
				}, {
					"name": "盐亭县",
					"id": "510723",
					"child": []
				}, {
					"name": "游仙区",
					"id": "510704",
					"child": []
				}, {
					"name": "北川羌族自治县",
					"id": "510726",
					"child": []
				}, {
					"name": "涪城区",
					"id": "510703",
					"child": []
				}, {
					"name": "梓潼县",
					"id": "510725",
					"child": []
				}]
			}, {
				"name": "宜宾市",
				"id": "511500",
				"child": [{
					"name": "宜宾县",
					"id": "511521",
					"child": []
				}, {
					"name": "翠屏区",
					"id": "511502",
					"child": []
				}, {
					"name": "长宁县",
					"id": "511524",
					"child": []
				}, {
					"name": "南溪区",
					"id": "511503",
					"child": []
				}, {
					"name": "高县",
					"id": "511525",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511501",
					"child": []
				}, {
					"name": "江安县",
					"id": "511523",
					"child": []
				}, {
					"name": "兴文县",
					"id": "511528",
					"child": []
				}, {
					"name": "屏山县",
					"id": "511529",
					"child": []
				}, {
					"name": "珙县",
					"id": "511526",
					"child": []
				}, {
					"name": "筠连县",
					"id": "511527",
					"child": []
				}]
			}, {
				"name": "德阳市",
				"id": "510600",
				"child": [{
					"name": "广汉市",
					"id": "510681",
					"child": []
				}, {
					"name": "绵竹市",
					"id": "510683",
					"child": []
				}, {
					"name": "什邡市",
					"id": "510682",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510601",
					"child": []
				}, {
					"name": "中江县",
					"id": "510623",
					"child": []
				}, {
					"name": "旌阳区",
					"id": "510603",
					"child": []
				}, {
					"name": "罗江县",
					"id": "510626",
					"child": []
				}]
			}, {
				"name": "广安市",
				"id": "511600",
				"child": [{
					"name": "华蓥市",
					"id": "511681",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511601",
					"child": []
				}, {
					"name": "邻水县",
					"id": "511623",
					"child": []
				}, {
					"name": "广安区",
					"id": "511602",
					"child": []
				}, {
					"name": "岳池县",
					"id": "511621",
					"child": []
				}, {
					"name": "武胜县",
					"id": "511622",
					"child": []
				}, {
					"name": "前锋区",
					"id": "511603",
					"child": []
				}]
			}, {
				"name": "广元市",
				"id": "510800",
				"child": [{
					"name": "旺苍县",
					"id": "510821",
					"child": []
				}, {
					"name": "利州区",
					"id": "510802",
					"child": []
				}, {
					"name": "苍溪县",
					"id": "510824",
					"child": []
				}, {
					"name": "昭化区",
					"id": "510811",
					"child": []
				}, {
					"name": "青川县",
					"id": "510822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510801",
					"child": []
				}, {
					"name": "朝天区",
					"id": "510812",
					"child": []
				}, {
					"name": "剑阁县",
					"id": "510823",
					"child": []
				}]
			}, {
				"name": "巴中市",
				"id": "511900",
				"child": [{
					"name": "通江县",
					"id": "511921",
					"child": []
				}, {
					"name": "巴州区",
					"id": "511902",
					"child": []
				}, {
					"name": "恩阳区",
					"id": "511903",
					"child": []
				}, {
					"name": "南江县",
					"id": "511922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "511901",
					"child": []
				}, {
					"name": "平昌县",
					"id": "511923",
					"child": []
				}]
			}, {
				"name": "遂宁市",
				"id": "510900",
				"child": [{
					"name": "船山区",
					"id": "510903",
					"child": []
				}, {
					"name": "安居区",
					"id": "510904",
					"child": []
				}, {
					"name": "市辖区",
					"id": "510901",
					"child": []
				}, {
					"name": "大英县",
					"id": "510923",
					"child": []
				}, {
					"name": "蓬溪县",
					"id": "510921",
					"child": []
				}, {
					"name": "射洪县",
					"id": "510922",
					"child": []
				}]
			}]
		},
		{
			"name": "宁夏回族自治区",
			"id": "640000",
			"child": [{
				"name": "银川市",
				"id": "640100",
				"child": [{
					"name": "灵武市",
					"id": "640181",
					"child": []
				}, {
					"name": "贺兰县",
					"id": "640122",
					"child": []
				}, {
					"name": "永宁县",
					"id": "640121",
					"child": []
				}, {
					"name": "市辖区",
					"id": "640101",
					"child": []
				}, {
					"name": "兴庆区",
					"id": "640104",
					"child": []
				}, {
					"name": "金凤区",
					"id": "640106",
					"child": []
				}, {
					"name": "西夏区",
					"id": "640105",
					"child": []
				}]
			}, {
				"name": "吴忠市",
				"id": "640300",
				"child": [{
					"name": "青铜峡市",
					"id": "640381",
					"child": []
				}, {
					"name": "利通区",
					"id": "640302",
					"child": []
				}, {
					"name": "同心县",
					"id": "640324",
					"child": []
				}, {
					"name": "市辖区",
					"id": "640301",
					"child": []
				}, {
					"name": "盐池县",
					"id": "640323",
					"child": []
				}, {
					"name": "红寺堡区",
					"id": "640303",
					"child": []
				}]
			}, {
				"name": "石嘴山市",
				"id": "640200",
				"child": [{
					"name": "平罗县",
					"id": "640221",
					"child": []
				}, {
					"name": "市辖区",
					"id": "640201",
					"child": []
				}, {
					"name": "大武口区",
					"id": "640202",
					"child": []
				}, {
					"name": "惠农区",
					"id": "640205",
					"child": []
				}]
			}, {
				"name": "中卫市",
				"id": "640500",
				"child": [{
					"name": "海原县",
					"id": "640522",
					"child": []
				}, {
					"name": "中宁县",
					"id": "640521",
					"child": []
				}, {
					"name": "沙坡头区",
					"id": "640502",
					"child": []
				}, {
					"name": "市辖区",
					"id": "640501",
					"child": []
				}]
			}, {
				"name": "固原市",
				"id": "640400",
				"child": [{
					"name": "市辖区",
					"id": "640401",
					"child": []
				}, {
					"name": "隆德县",
					"id": "640423",
					"child": []
				}, {
					"name": "西吉县",
					"id": "640422",
					"child": []
				}, {
					"name": "彭阳县",
					"id": "640425",
					"child": []
				}, {
					"name": "原州区",
					"id": "640402",
					"child": []
				}, {
					"name": "泾源县",
					"id": "640424",
					"child": []
				}]
			}]
		},
		{
			"name": "吉林省",
			"id": "220000",
			"child": [{
				"name": "白城市",
				"id": "220800",
				"child": [{
					"name": "市辖区",
					"id": "220801",
					"child": []
				}, {
					"name": "通榆县",
					"id": "220822",
					"child": []
				}, {
					"name": "洮北区",
					"id": "220802",
					"child": []
				}, {
					"name": "洮南市",
					"id": "220881",
					"child": []
				}, {
					"name": "大安市",
					"id": "220882",
					"child": []
				}, {
					"name": "镇赉县",
					"id": "220821",
					"child": []
				}]
			}, {
				"name": "长春市",
				"id": "220100",
				"child": [{
					"name": "榆树市",
					"id": "220182",
					"child": []
				}, {
					"name": "德惠市",
					"id": "220183",
					"child": []
				}, {
					"name": "农安县",
					"id": "220122",
					"child": []
				}, {
					"name": "南关区",
					"id": "220102",
					"child": []
				}, {
					"name": "九台区",
					"id": "220113",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220101",
					"child": []
				}, {
					"name": "双阳区",
					"id": "220112",
					"child": []
				}, {
					"name": "朝阳区",
					"id": "220104",
					"child": []
				}, {
					"name": "宽城区",
					"id": "220103",
					"child": []
				}, {
					"name": "绿园区",
					"id": "220106",
					"child": []
				}, {
					"name": "二道区",
					"id": "220105",
					"child": []
				}]
			}, {
				"name": "延边朝鲜族自治州",
				"id": "222400",
				"child": [{
					"name": "和龙市",
					"id": "222406",
					"child": []
				}, {
					"name": "延吉市",
					"id": "222401",
					"child": []
				}, {
					"name": "珲春市",
					"id": "222404",
					"child": []
				}, {
					"name": "安图县",
					"id": "222426",
					"child": []
				}, {
					"name": "龙井市",
					"id": "222405",
					"child": []
				}, {
					"name": "图们市",
					"id": "222402",
					"child": []
				}, {
					"name": "汪清县",
					"id": "222424",
					"child": []
				}, {
					"name": "敦化市",
					"id": "222403",
					"child": []
				}]
			}, {
				"name": "四平市",
				"id": "220300",
				"child": [{
					"name": "双辽市",
					"id": "220382",
					"child": []
				}, {
					"name": "公主岭市",
					"id": "220381",
					"child": []
				}, {
					"name": "梨树县",
					"id": "220322",
					"child": []
				}, {
					"name": "铁西区",
					"id": "220302",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220301",
					"child": []
				}, {
					"name": "伊通满族自治县",
					"id": "220323",
					"child": []
				}, {
					"name": "铁东区",
					"id": "220303",
					"child": []
				}]
			}, {
				"name": "吉林市",
				"id": "220200",
				"child": [{
					"name": "蛟河市",
					"id": "220281",
					"child": []
				}, {
					"name": "舒兰市",
					"id": "220283",
					"child": []
				}, {
					"name": "桦甸市",
					"id": "220282",
					"child": []
				}, {
					"name": "磐石市",
					"id": "220284",
					"child": []
				}, {
					"name": "永吉县",
					"id": "220221",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220201",
					"child": []
				}, {
					"name": "丰满区",
					"id": "220211",
					"child": []
				}, {
					"name": "龙潭区",
					"id": "220203",
					"child": []
				}, {
					"name": "昌邑区",
					"id": "220202",
					"child": []
				}, {
					"name": "船营区",
					"id": "220204",
					"child": []
				}]
			}, {
				"name": "通化市",
				"id": "220500",
				"child": [{
					"name": "二道江区",
					"id": "220503",
					"child": []
				}, {
					"name": "集安市",
					"id": "220582",
					"child": []
				}, {
					"name": "梅河口市",
					"id": "220581",
					"child": []
				}, {
					"name": "通化县",
					"id": "220521",
					"child": []
				}, {
					"name": "东昌区",
					"id": "220502",
					"child": []
				}, {
					"name": "柳河县",
					"id": "220524",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220501",
					"child": []
				}, {
					"name": "辉南县",
					"id": "220523",
					"child": []
				}]
			}, {
				"name": "辽源市",
				"id": "220400",
				"child": [{
					"name": "东丰县",
					"id": "220421",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220401",
					"child": []
				}, {
					"name": "东辽县",
					"id": "220422",
					"child": []
				}, {
					"name": "西安区",
					"id": "220403",
					"child": []
				}, {
					"name": "龙山区",
					"id": "220402",
					"child": []
				}]
			}, {
				"name": "松原市",
				"id": "220700",
				"child": [{
					"name": "宁江区",
					"id": "220702",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220701",
					"child": []
				}, {
					"name": "乾安县",
					"id": "220723",
					"child": []
				}, {
					"name": "扶余市",
					"id": "220781",
					"child": []
				}, {
					"name": "长岭县",
					"id": "220722",
					"child": []
				}, {
					"name": "前郭尔罗斯蒙古族自治县",
					"id": "220721",
					"child": []
				}]
			}, {
				"name": "白山市",
				"id": "220600",
				"child": [{
					"name": "浑江区",
					"id": "220602",
					"child": []
				}, {
					"name": "江源区",
					"id": "220605",
					"child": []
				}, {
					"name": "临江市",
					"id": "220681",
					"child": []
				}, {
					"name": "抚松县",
					"id": "220621",
					"child": []
				}, {
					"name": "市辖区",
					"id": "220601",
					"child": []
				}, {
					"name": "长白朝鲜族自治县",
					"id": "220623",
					"child": []
				}, {
					"name": "靖宇县",
					"id": "220622",
					"child": []
				}]
			}]
		},
		{
			"name": "福建省",
			"id": "350000",
			"child": [{
				"name": "漳州市",
				"id": "350600",
				"child": [{
					"name": "云霄县",
					"id": "350622",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350601",
					"child": []
				}, {
					"name": "漳浦县",
					"id": "350623",
					"child": []
				}, {
					"name": "芗城区",
					"id": "350602",
					"child": []
				}, {
					"name": "诏安县",
					"id": "350624",
					"child": []
				}, {
					"name": "龙文区",
					"id": "350603",
					"child": []
				}, {
					"name": "长泰县",
					"id": "350625",
					"child": []
				}, {
					"name": "东山县",
					"id": "350626",
					"child": []
				}, {
					"name": "南靖县",
					"id": "350627",
					"child": []
				}, {
					"name": "平和县",
					"id": "350628",
					"child": []
				}, {
					"name": "华安县",
					"id": "350629",
					"child": []
				}, {
					"name": "龙海市",
					"id": "350681",
					"child": []
				}]
			}, {
				"name": "南平市",
				"id": "350700",
				"child": [{
					"name": "顺昌县",
					"id": "350721",
					"child": []
				}, {
					"name": "浦城县",
					"id": "350722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350701",
					"child": []
				}, {
					"name": "光泽县",
					"id": "350723",
					"child": []
				}, {
					"name": "延平区",
					"id": "350702",
					"child": []
				}, {
					"name": "松溪县",
					"id": "350724",
					"child": []
				}, {
					"name": "建阳区",
					"id": "350703",
					"child": []
				}, {
					"name": "政和县",
					"id": "350725",
					"child": []
				}, {
					"name": "邵武市",
					"id": "350781",
					"child": []
				}, {
					"name": "武夷山市",
					"id": "350782",
					"child": []
				}, {
					"name": "建瓯市",
					"id": "350783",
					"child": []
				}]
			}, {
				"name": "龙岩市",
				"id": "350800",
				"child": [{
					"name": "长汀县",
					"id": "350821",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350801",
					"child": []
				}, {
					"name": "上杭县",
					"id": "350823",
					"child": []
				}, {
					"name": "新罗区",
					"id": "350802",
					"child": []
				}, {
					"name": "武平县",
					"id": "350824",
					"child": []
				}, {
					"name": "永定区",
					"id": "350803",
					"child": []
				}, {
					"name": "连城县",
					"id": "350825",
					"child": []
				}, {
					"name": "漳平市",
					"id": "350881",
					"child": []
				}]
			}, {
				"name": "宁德市",
				"id": "350900",
				"child": [{
					"name": "霞浦县",
					"id": "350921",
					"child": []
				}, {
					"name": "古田县",
					"id": "350922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350901",
					"child": []
				}, {
					"name": "屏南县",
					"id": "350923",
					"child": []
				}, {
					"name": "蕉城区",
					"id": "350902",
					"child": []
				}, {
					"name": "寿宁县",
					"id": "350924",
					"child": []
				}, {
					"name": "周宁县",
					"id": "350925",
					"child": []
				}, {
					"name": "柘荣县",
					"id": "350926",
					"child": []
				}, {
					"name": "福安市",
					"id": "350981",
					"child": []
				}, {
					"name": "福鼎市",
					"id": "350982",
					"child": []
				}]
			}, {
				"name": "福州市",
				"id": "350100",
				"child": [{
					"name": "马尾区",
					"id": "350105",
					"child": []
				}, {
					"name": "平潭县",
					"id": "350128",
					"child": []
				}, {
					"name": "闽侯县",
					"id": "350121",
					"child": []
				}, {
					"name": "晋安区",
					"id": "350111",
					"child": []
				}, {
					"name": "连江县",
					"id": "350122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350101",
					"child": []
				}, {
					"name": "罗源县",
					"id": "350123",
					"child": []
				}, {
					"name": "鼓楼区",
					"id": "350102",
					"child": []
				}, {
					"name": "闽清县",
					"id": "350124",
					"child": []
				}, {
					"name": "台江区",
					"id": "350103",
					"child": []
				}, {
					"name": "永泰县",
					"id": "350125",
					"child": []
				}, {
					"name": "仓山区",
					"id": "350104",
					"child": []
				}, {
					"name": "福清市",
					"id": "350181",
					"child": []
				}, {
					"name": "长乐市",
					"id": "350182",
					"child": []
				}]
			}, {
				"name": "厦门市",
				"id": "350200",
				"child": [{
					"name": "海沧区",
					"id": "350205",
					"child": []
				}, {
					"name": "湖里区",
					"id": "350206",
					"child": []
				}, {
					"name": "集美区",
					"id": "350211",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350201",
					"child": []
				}, {
					"name": "同安区",
					"id": "350212",
					"child": []
				}, {
					"name": "翔安区",
					"id": "350213",
					"child": []
				}, {
					"name": "思明区",
					"id": "350203",
					"child": []
				}]
			}, {
				"name": "莆田市",
				"id": "350300",
				"child": [{
					"name": "涵江区",
					"id": "350303",
					"child": []
				}, {
					"name": "荔城区",
					"id": "350304",
					"child": []
				}, {
					"name": "秀屿区",
					"id": "350305",
					"child": []
				}, {
					"name": "仙游县",
					"id": "350322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350301",
					"child": []
				}, {
					"name": "城厢区",
					"id": "350302",
					"child": []
				}]
			}, {
				"name": "三明市",
				"id": "350400",
				"child": [{
					"name": "梅列区",
					"id": "350402",
					"child": []
				}, {
					"name": "宁化县",
					"id": "350424",
					"child": []
				}, {
					"name": "三元区",
					"id": "350403",
					"child": []
				}, {
					"name": "大田县",
					"id": "350425",
					"child": []
				}, {
					"name": "尤溪县",
					"id": "350426",
					"child": []
				}, {
					"name": "沙县",
					"id": "350427",
					"child": []
				}, {
					"name": "将乐县",
					"id": "350428",
					"child": []
				}, {
					"name": "泰宁县",
					"id": "350429",
					"child": []
				}, {
					"name": "建宁县",
					"id": "350430",
					"child": []
				}, {
					"name": "明溪县",
					"id": "350421",
					"child": []
				}, {
					"name": "市辖区",
					"id": "350401",
					"child": []
				}, {
					"name": "清流县",
					"id": "350423",
					"child": []
				}, {
					"name": "永安市",
					"id": "350481",
					"child": []
				}]
			}, {
				"name": "泉州市",
				"id": "350500",
				"child": [{
					"name": "市辖区",
					"id": "350501",
					"child": []
				}, {
					"name": "鲤城区",
					"id": "350502",
					"child": []
				}, {
					"name": "安溪县",
					"id": "350524",
					"child": []
				}, {
					"name": "丰泽区",
					"id": "350503",
					"child": []
				}, {
					"name": "永春县",
					"id": "350525",
					"child": []
				}, {
					"name": "洛江区",
					"id": "350504",
					"child": []
				}, {
					"name": "德化县",
					"id": "350526",
					"child": []
				}, {
					"name": "泉港区",
					"id": "350505",
					"child": []
				}, {
					"name": "金门县",
					"id": "350527",
					"child": []
				}, {
					"name": "石狮市",
					"id": "350581",
					"child": []
				}, {
					"name": "晋江市",
					"id": "350582",
					"child": []
				}, {
					"name": "南安市",
					"id": "350583",
					"child": []
				}, {
					"name": "惠安县",
					"id": "350521",
					"child": []
				}]
			}]
		},
		{
			"name": "湖北省",
			"id": "420000",
			"child": [{
				"name": "省直辖县级行政区划",
				"id": "429000",
				"child": [{
					"name": "神农架林区",
					"id": "429021",
					"child": []
				}, {
					"name": "天门市",
					"id": "429006",
					"child": []
				}, {
					"name": "潜江市",
					"id": "429005",
					"child": []
				}, {
					"name": "仙桃市",
					"id": "429004",
					"child": []
				}]
			}, {
				"name": "武汉市",
				"id": "420100",
				"child": [{
					"name": "洪山区",
					"id": "420111",
					"child": []
				}, {
					"name": "硚口区",
					"id": "420104",
					"child": []
				}, {
					"name": "江夏区",
					"id": "420115",
					"child": []
				}, {
					"name": "江汉区",
					"id": "420103",
					"child": []
				}, {
					"name": "蔡甸区",
					"id": "420114",
					"child": []
				}, {
					"name": "江岸区",
					"id": "420102",
					"child": []
				}, {
					"name": "汉南区",
					"id": "420113",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420101",
					"child": []
				}, {
					"name": "东西湖区",
					"id": "420112",
					"child": []
				}, {
					"name": "青山区",
					"id": "420107",
					"child": []
				}, {
					"name": "武昌区",
					"id": "420106",
					"child": []
				}, {
					"name": "新洲区",
					"id": "420117",
					"child": []
				}, {
					"name": "汉阳区",
					"id": "420105",
					"child": []
				}, {
					"name": "黄陂区",
					"id": "420116",
					"child": []
				}]
			}, {
				"name": "咸宁市",
				"id": "421200",
				"child": [{
					"name": "咸安区",
					"id": "421202",
					"child": []
				}, {
					"name": "通山县",
					"id": "421224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "421201",
					"child": []
				}, {
					"name": "崇阳县",
					"id": "421223",
					"child": []
				}, {
					"name": "赤壁市",
					"id": "421281",
					"child": []
				}, {
					"name": "通城县",
					"id": "421222",
					"child": []
				}, {
					"name": "嘉鱼县",
					"id": "421221",
					"child": []
				}]
			}, {
				"name": "黄冈市",
				"id": "421100",
				"child": [{
					"name": "黄梅县",
					"id": "421127",
					"child": []
				}, {
					"name": "蕲春县",
					"id": "421126",
					"child": []
				}, {
					"name": "浠水县",
					"id": "421125",
					"child": []
				}, {
					"name": "黄州区",
					"id": "421102",
					"child": []
				}, {
					"name": "英山县",
					"id": "421124",
					"child": []
				}, {
					"name": "麻城市",
					"id": "421181",
					"child": []
				}, {
					"name": "武穴市",
					"id": "421182",
					"child": []
				}, {
					"name": "市辖区",
					"id": "421101",
					"child": []
				}, {
					"name": "罗田县",
					"id": "421123",
					"child": []
				}, {
					"name": "红安县",
					"id": "421122",
					"child": []
				}, {
					"name": "团风县",
					"id": "421121",
					"child": []
				}]
			}, {
				"name": "荆州市",
				"id": "421000",
				"child": [{
					"name": "荆州区",
					"id": "421003",
					"child": []
				}, {
					"name": "石首市",
					"id": "421081",
					"child": []
				}, {
					"name": "洪湖市",
					"id": "421083",
					"child": []
				}, {
					"name": "沙市区",
					"id": "421002",
					"child": []
				}, {
					"name": "江陵县",
					"id": "421024",
					"child": []
				}, {
					"name": "市辖区",
					"id": "421001",
					"child": []
				}, {
					"name": "监利县",
					"id": "421023",
					"child": []
				}, {
					"name": "公安县",
					"id": "421022",
					"child": []
				}, {
					"name": "松滋市",
					"id": "421087",
					"child": []
				}]
			}, {
				"name": "宜昌市",
				"id": "420500",
				"child": [{
					"name": "枝江市",
					"id": "420583",
					"child": []
				}, {
					"name": "当阳市",
					"id": "420582",
					"child": []
				}, {
					"name": "宜都市",
					"id": "420581",
					"child": []
				}, {
					"name": "点军区",
					"id": "420504",
					"child": []
				}, {
					"name": "兴山县",
					"id": "420526",
					"child": []
				}, {
					"name": "伍家岗区",
					"id": "420503",
					"child": []
				}, {
					"name": "远安县",
					"id": "420525",
					"child": []
				}, {
					"name": "西陵区",
					"id": "420502",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420501",
					"child": []
				}, {
					"name": "五峰土家族自治县",
					"id": "420529",
					"child": []
				}, {
					"name": "夷陵区",
					"id": "420506",
					"child": []
				}, {
					"name": "长阳土家族自治县",
					"id": "420528",
					"child": []
				}, {
					"name": "猇亭区",
					"id": "420505",
					"child": []
				}, {
					"name": "秭归县",
					"id": "420527",
					"child": []
				}]
			}, {
				"name": "恩施土家族苗族自治州",
				"id": "422800",
				"child": [{
					"name": "建始县",
					"id": "422822",
					"child": []
				}, {
					"name": "恩施市",
					"id": "422801",
					"child": []
				}, {
					"name": "巴东县",
					"id": "422823",
					"child": []
				}, {
					"name": "利川市",
					"id": "422802",
					"child": []
				}, {
					"name": "宣恩县",
					"id": "422825",
					"child": []
				}, {
					"name": "咸丰县",
					"id": "422826",
					"child": []
				}, {
					"name": "来凤县",
					"id": "422827",
					"child": []
				}, {
					"name": "鹤峰县",
					"id": "422828",
					"child": []
				}]
			}, {
				"name": "十堰市",
				"id": "420300",
				"child": [{
					"name": "茅箭区",
					"id": "420302",
					"child": []
				}, {
					"name": "竹溪县",
					"id": "420324",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420301",
					"child": []
				}, {
					"name": "竹山县",
					"id": "420323",
					"child": []
				}, {
					"name": "郧西县",
					"id": "420322",
					"child": []
				}, {
					"name": "郧阳区",
					"id": "420304",
					"child": []
				}, {
					"name": "张湾区",
					"id": "420303",
					"child": []
				}, {
					"name": "房县",
					"id": "420325",
					"child": []
				}, {
					"name": "丹江口市",
					"id": "420381",
					"child": []
				}]
			}, {
				"name": "黄石市",
				"id": "420200",
				"child": [{
					"name": "西塞山区",
					"id": "420203",
					"child": []
				}, {
					"name": "黄石港区",
					"id": "420202",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420201",
					"child": []
				}, {
					"name": "阳新县",
					"id": "420222",
					"child": []
				}, {
					"name": "铁山区",
					"id": "420205",
					"child": []
				}, {
					"name": "下陆区",
					"id": "420204",
					"child": []
				}, {
					"name": "大冶市",
					"id": "420281",
					"child": []
				}]
			}, {
				"name": "随州市",
				"id": "421300",
				"child": [{
					"name": "曾都区",
					"id": "421303",
					"child": []
				}, {
					"name": "市辖区",
					"id": "421301",
					"child": []
				}, {
					"name": "广水市",
					"id": "421381",
					"child": []
				}, {
					"name": "随县",
					"id": "421321",
					"child": []
				}]
			}, {
				"name": "孝感市",
				"id": "420900",
				"child": [{
					"name": "汉川市",
					"id": "420984",
					"child": []
				}, {
					"name": "安陆市",
					"id": "420982",
					"child": []
				}, {
					"name": "应城市",
					"id": "420981",
					"child": []
				}, {
					"name": "大悟县",
					"id": "420922",
					"child": []
				}, {
					"name": "孝昌县",
					"id": "420921",
					"child": []
				}, {
					"name": "孝南区",
					"id": "420902",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420901",
					"child": []
				}, {
					"name": "云梦县",
					"id": "420923",
					"child": []
				}]
			}, {
				"name": "荆门市",
				"id": "420800",
				"child": [{
					"name": "市辖区",
					"id": "420801",
					"child": []
				}, {
					"name": "沙洋县",
					"id": "420822",
					"child": []
				}, {
					"name": "京山县",
					"id": "420821",
					"child": []
				}, {
					"name": "掇刀区",
					"id": "420804",
					"child": []
				}, {
					"name": "东宝区",
					"id": "420802",
					"child": []
				}, {
					"name": "钟祥市",
					"id": "420881",
					"child": []
				}]
			}, {
				"name": "鄂州市",
				"id": "420700",
				"child": [{
					"name": "梁子湖区",
					"id": "420702",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420701",
					"child": []
				}, {
					"name": "鄂城区",
					"id": "420704",
					"child": []
				}, {
					"name": "华容区",
					"id": "420703",
					"child": []
				}]
			}, {
				"name": "襄阳市",
				"id": "420600",
				"child": [{
					"name": "宜城市",
					"id": "420684",
					"child": []
				}, {
					"name": "谷城县",
					"id": "420625",
					"child": []
				}, {
					"name": "襄城区",
					"id": "420602",
					"child": []
				}, {
					"name": "南漳县",
					"id": "420624",
					"child": []
				}, {
					"name": "市辖区",
					"id": "420601",
					"child": []
				}, {
					"name": "襄州区",
					"id": "420607",
					"child": []
				}, {
					"name": "樊城区",
					"id": "420606",
					"child": []
				}, {
					"name": "保康县",
					"id": "420626",
					"child": []
				}, {
					"name": "枣阳市",
					"id": "420683",
					"child": []
				}, {
					"name": "老河口市",
					"id": "420682",
					"child": []
				}]
			}]
		},
		{
			"name": "广东省",
			"id": "440000",
			"child": [{
				"name": "茂名市",
				"id": "440900",
				"child": [{
					"name": "电白区",
					"id": "440904",
					"child": []
				}, {
					"name": "茂南区",
					"id": "440902",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440901",
					"child": []
				}, {
					"name": "信宜市",
					"id": "440983",
					"child": []
				}, {
					"name": "化州市",
					"id": "440982",
					"child": []
				}, {
					"name": "高州市",
					"id": "440981",
					"child": []
				}]
			}, {
				"name": "湛江市",
				"id": "440800",
				"child": [{
					"name": "坡头区",
					"id": "440804",
					"child": []
				}, {
					"name": "霞山区",
					"id": "440803",
					"child": []
				}, {
					"name": "徐闻县",
					"id": "440825",
					"child": []
				}, {
					"name": "赤坎区",
					"id": "440802",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440801",
					"child": []
				}, {
					"name": "遂溪县",
					"id": "440823",
					"child": []
				}, {
					"name": "麻章区",
					"id": "440811",
					"child": []
				}, {
					"name": "吴川市",
					"id": "440883",
					"child": []
				}, {
					"name": "雷州市",
					"id": "440882",
					"child": []
				}, {
					"name": "廉江市",
					"id": "440881",
					"child": []
				}]
			}, {
				"name": "东莞市",
				"id": "441900",
				"child": []
			}, {
				"name": "江门市",
				"id": "440700",
				"child": [{
					"name": "新会区",
					"id": "440705",
					"child": []
				}, {
					"name": "江海区",
					"id": "440704",
					"child": []
				}, {
					"name": "蓬江区",
					"id": "440703",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440701",
					"child": []
				}, {
					"name": "恩平市",
					"id": "440785",
					"child": []
				}, {
					"name": "鹤山市",
					"id": "440784",
					"child": []
				}, {
					"name": "开平市",
					"id": "440783",
					"child": []
				}, {
					"name": "台山市",
					"id": "440781",
					"child": []
				}]
			}, {
				"name": "清远市",
				"id": "441800",
				"child": [{
					"name": "连南瑶族自治县",
					"id": "441826",
					"child": []
				}, {
					"name": "清新区",
					"id": "441803",
					"child": []
				}, {
					"name": "连山壮族瑶族自治县",
					"id": "441825",
					"child": []
				}, {
					"name": "清城区",
					"id": "441802",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441801",
					"child": []
				}, {
					"name": "阳山县",
					"id": "441823",
					"child": []
				}, {
					"name": "佛冈县",
					"id": "441821",
					"child": []
				}, {
					"name": "连州市",
					"id": "441882",
					"child": []
				}, {
					"name": "英德市",
					"id": "441881",
					"child": []
				}]
			}, {
				"name": "佛山市",
				"id": "440600",
				"child": [{
					"name": "高明区",
					"id": "440608",
					"child": []
				}, {
					"name": "三水区",
					"id": "440607",
					"child": []
				}, {
					"name": "顺德区",
					"id": "440606",
					"child": []
				}, {
					"name": "南海区",
					"id": "440605",
					"child": []
				}, {
					"name": "禅城区",
					"id": "440604",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440601",
					"child": []
				}]
			}, {
				"name": "阳江市",
				"id": "441700",
				"child": [{
					"name": "阳春市",
					"id": "441781",
					"child": []
				}, {
					"name": "阳东区",
					"id": "441704",
					"child": []
				}, {
					"name": "江城区",
					"id": "441702",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441701",
					"child": []
				}, {
					"name": "阳西县",
					"id": "441721",
					"child": []
				}]
			}, {
				"name": "汕头市",
				"id": "440500",
				"child": [{
					"name": "龙湖区",
					"id": "440507",
					"child": []
				}, {
					"name": "澄海区",
					"id": "440515",
					"child": []
				}, {
					"name": "潮南区",
					"id": "440514",
					"child": []
				}, {
					"name": "潮阳区",
					"id": "440513",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440501",
					"child": []
				}, {
					"name": "濠江区",
					"id": "440512",
					"child": []
				}, {
					"name": "南澳县",
					"id": "440523",
					"child": []
				}, {
					"name": "金平区",
					"id": "440511",
					"child": []
				}]
			}, {
				"name": "河源市",
				"id": "441600",
				"child": [{
					"name": "东源县",
					"id": "441625",
					"child": []
				}, {
					"name": "源城区",
					"id": "441602",
					"child": []
				}, {
					"name": "和平县",
					"id": "441624",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441601",
					"child": []
				}, {
					"name": "连平县",
					"id": "441623",
					"child": []
				}, {
					"name": "龙川县",
					"id": "441622",
					"child": []
				}, {
					"name": "紫金县",
					"id": "441621",
					"child": []
				}]
			}, {
				"name": "珠海市",
				"id": "440400",
				"child": [{
					"name": "金湾区",
					"id": "440404",
					"child": []
				}, {
					"name": "斗门区",
					"id": "440403",
					"child": []
				}, {
					"name": "香洲区",
					"id": "440402",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440401",
					"child": []
				}]
			}, {
				"name": "汕尾市",
				"id": "441500",
				"child": [{
					"name": "陆丰市",
					"id": "441581",
					"child": []
				}, {
					"name": "城区",
					"id": "441502",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441501",
					"child": []
				}, {
					"name": "陆河县",
					"id": "441523",
					"child": []
				}, {
					"name": "海丰县",
					"id": "441521",
					"child": []
				}]
			}, {
				"name": "深圳市",
				"id": "440300",
				"child": [{
					"name": "盐田区",
					"id": "440308",
					"child": []
				}, {
					"name": "龙岗区",
					"id": "440307",
					"child": []
				}, {
					"name": "宝安区",
					"id": "440306",
					"child": []
				}, {
					"name": "南山区",
					"id": "440305",
					"child": []
				}, {
					"name": "福田区",
					"id": "440304",
					"child": []
				}, {
					"name": "罗湖区",
					"id": "440303",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440301",
					"child": []
				}]
			}, {
				"name": "梅州市",
				"id": "441400",
				"child": [{
					"name": "兴宁市",
					"id": "441481",
					"child": []
				}, {
					"name": "蕉岭县",
					"id": "441427",
					"child": []
				}, {
					"name": "平远县",
					"id": "441426",
					"child": []
				}, {
					"name": "梅县区",
					"id": "441403",
					"child": []
				}, {
					"name": "梅江区",
					"id": "441402",
					"child": []
				}, {
					"name": "五华县",
					"id": "441424",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441401",
					"child": []
				}, {
					"name": "丰顺县",
					"id": "441423",
					"child": []
				}, {
					"name": "大埔县",
					"id": "441422",
					"child": []
				}]
			}, {
				"name": "揭阳市",
				"id": "445200",
				"child": [{
					"name": "揭东区",
					"id": "445203",
					"child": []
				}, {
					"name": "普宁市",
					"id": "445281",
					"child": []
				}, {
					"name": "揭西县",
					"id": "445222",
					"child": []
				}, {
					"name": "榕城区",
					"id": "445202",
					"child": []
				}, {
					"name": "惠来县",
					"id": "445224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "445201",
					"child": []
				}]
			}, {
				"name": "韶关市",
				"id": "440200",
				"child": [{
					"name": "南雄市",
					"id": "440282",
					"child": []
				}, {
					"name": "乐昌市",
					"id": "440281",
					"child": []
				}, {
					"name": "翁源县",
					"id": "440229",
					"child": []
				}, {
					"name": "曲江区",
					"id": "440205",
					"child": []
				}, {
					"name": "浈江区",
					"id": "440204",
					"child": []
				}, {
					"name": "武江区",
					"id": "440203",
					"child": []
				}, {
					"name": "仁化县",
					"id": "440224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440201",
					"child": []
				}, {
					"name": "始兴县",
					"id": "440222",
					"child": []
				}, {
					"name": "新丰县",
					"id": "440233",
					"child": []
				}, {
					"name": "乳源瑶族自治县",
					"id": "440232",
					"child": []
				}]
			}, {
				"name": "惠州市",
				"id": "441300",
				"child": [{
					"name": "惠阳区",
					"id": "441303",
					"child": []
				}, {
					"name": "惠城区",
					"id": "441302",
					"child": []
				}, {
					"name": "龙门县",
					"id": "441324",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441301",
					"child": []
				}, {
					"name": "惠东县",
					"id": "441323",
					"child": []
				}, {
					"name": "博罗县",
					"id": "441322",
					"child": []
				}]
			}, {
				"name": "潮州市",
				"id": "445100",
				"child": [{
					"name": "市辖区",
					"id": "445101",
					"child": []
				}, {
					"name": "饶平县",
					"id": "445122",
					"child": []
				}, {
					"name": "潮安区",
					"id": "445103",
					"child": []
				}, {
					"name": "湘桥区",
					"id": "445102",
					"child": []
				}]
			}, {
				"name": "广州市",
				"id": "440100",
				"child": [{
					"name": "增城区",
					"id": "440118",
					"child": []
				}, {
					"name": "天河区",
					"id": "440106",
					"child": []
				}, {
					"name": "从化区",
					"id": "440117",
					"child": []
				}, {
					"name": "海珠区",
					"id": "440105",
					"child": []
				}, {
					"name": "越秀区",
					"id": "440104",
					"child": []
				}, {
					"name": "南沙区",
					"id": "440115",
					"child": []
				}, {
					"name": "荔湾区",
					"id": "440103",
					"child": []
				}, {
					"name": "花都区",
					"id": "440114",
					"child": []
				}, {
					"name": "番禺区",
					"id": "440113",
					"child": []
				}, {
					"name": "市辖区",
					"id": "440101",
					"child": []
				}, {
					"name": "黄埔区",
					"id": "440112",
					"child": []
				}, {
					"name": "白云区",
					"id": "440111",
					"child": []
				}]
			}, {
				"name": "肇庆市",
				"id": "441200",
				"child": [{
					"name": "四会市",
					"id": "441284",
					"child": []
				}, {
					"name": "高要区",
					"id": "441204",
					"child": []
				}, {
					"name": "德庆县",
					"id": "441226",
					"child": []
				}, {
					"name": "鼎湖区",
					"id": "441203",
					"child": []
				}, {
					"name": "封开县",
					"id": "441225",
					"child": []
				}, {
					"name": "端州区",
					"id": "441202",
					"child": []
				}, {
					"name": "怀集县",
					"id": "441224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "441201",
					"child": []
				}, {
					"name": "广宁县",
					"id": "441223",
					"child": []
				}]
			}, {
				"name": "中山市",
				"id": "442000",
				"child": []
			}, {
				"name": "云浮市",
				"id": "445300",
				"child": [{
					"name": "云安区",
					"id": "445303",
					"child": []
				}, {
					"name": "云城区",
					"id": "445302",
					"child": []
				}, {
					"name": "罗定市",
					"id": "445381",
					"child": []
				}, {
					"name": "新兴县",
					"id": "445321",
					"child": []
				}, {
					"name": "市辖区",
					"id": "445301",
					"child": []
				}, {
					"name": "郁南县",
					"id": "445322",
					"child": []
				}]
			}]
		},
		{
			"name": "重庆市",
			"id": "500000",
			"child": [{
				"name": "县",
				"id": "500200",
				"child": [{
					"name": "梁平县",
					"id": "500228",
					"child": []
				}, {
					"name": "巫溪县",
					"id": "500238",
					"child": []
				}, {
					"name": "巫山县",
					"id": "500237",
					"child": []
				}, {
					"name": "奉节县",
					"id": "500236",
					"child": []
				}, {
					"name": "城口县",
					"id": "500229",
					"child": []
				}, {
					"name": "垫江县",
					"id": "500231",
					"child": []
				}, {
					"name": "酉阳土家族苗族自治县",
					"id": "500242",
					"child": []
				}, {
					"name": "丰都县",
					"id": "500230",
					"child": []
				}, {
					"name": "秀山土家族苗族自治县",
					"id": "500241",
					"child": []
				}, {
					"name": "石柱土家族自治县",
					"id": "500240",
					"child": []
				}, {
					"name": "云阳县",
					"id": "500235",
					"child": []
				}, {
					"name": "忠县",
					"id": "500233",
					"child": []
				}, {
					"name": "武隆县",
					"id": "500232",
					"child": []
				}, {
					"name": "彭水苗族土家族自治县",
					"id": "500243",
					"child": []
				}]
			}, {
				"name": "市辖区",
				"id": "500100",
				"child": [{
					"name": "九龙坡区",
					"id": "500107",
					"child": []
				}, {
					"name": "永川区",
					"id": "500118",
					"child": []
				}, {
					"name": "沙坪坝区",
					"id": "500106",
					"child": []
				}, {
					"name": "合川区",
					"id": "500117",
					"child": []
				}, {
					"name": "江北区",
					"id": "500105",
					"child": []
				}, {
					"name": "江津区",
					"id": "500116",
					"child": []
				}, {
					"name": "大渡口区",
					"id": "500104",
					"child": []
				}, {
					"name": "长寿区",
					"id": "500115",
					"child": []
				}, {
					"name": "北碚区",
					"id": "500109",
					"child": []
				}, {
					"name": "南岸区",
					"id": "500108",
					"child": []
				}, {
					"name": "南川区",
					"id": "500119",
					"child": []
				}, {
					"name": "綦江区",
					"id": "500110",
					"child": []
				}, {
					"name": "开州区",
					"id": "500154",
					"child": []
				}, {
					"name": "璧山区",
					"id": "500120",
					"child": []
				}, {
					"name": "荣昌区",
					"id": "500153",
					"child": []
				}, {
					"name": "潼南区",
					"id": "500152",
					"child": []
				}, {
					"name": "铜梁区",
					"id": "500151",
					"child": []
				}, {
					"name": "渝中区",
					"id": "500103",
					"child": []
				}, {
					"name": "黔江区",
					"id": "500114",
					"child": []
				}, {
					"name": "涪陵区",
					"id": "500102",
					"child": []
				}, {
					"name": "巴南区",
					"id": "500113",
					"child": []
				}, {
					"name": "万州区",
					"id": "500101",
					"child": []
				}, {
					"name": "渝北区",
					"id": "500112",
					"child": []
				}, {
					"name": "大足区",
					"id": "500111",
					"child": []
				}]
			}]
		},
		{
			"name": "山西省",
			"id": "140000",
			"child": [{
				"name": "吕梁市",
				"id": "141100",
				"child": [{
					"name": "汾阳市",
					"id": "141182",
					"child": []
				}, {
					"name": "孝义市",
					"id": "141181",
					"child": []
				}, {
					"name": "交口县",
					"id": "141130",
					"child": []
				}, {
					"name": "交城县",
					"id": "141122",
					"child": []
				}, {
					"name": "文水县",
					"id": "141121",
					"child": []
				}, {
					"name": "离石区",
					"id": "141102",
					"child": []
				}, {
					"name": "临县",
					"id": "141124",
					"child": []
				}, {
					"name": "市辖区",
					"id": "141101",
					"child": []
				}, {
					"name": "兴县",
					"id": "141123",
					"child": []
				}, {
					"name": "石楼县",
					"id": "141126",
					"child": []
				}, {
					"name": "柳林县",
					"id": "141125",
					"child": []
				}, {
					"name": "方山县",
					"id": "141128",
					"child": []
				}, {
					"name": "岚县",
					"id": "141127",
					"child": []
				}, {
					"name": "中阳县",
					"id": "141129",
					"child": []
				}]
			}, {
				"name": "临汾市",
				"id": "141000",
				"child": [{
					"name": "侯马市",
					"id": "141081",
					"child": []
				}, {
					"name": "霍州市",
					"id": "141082",
					"child": []
				}, {
					"name": "大宁县",
					"id": "141030",
					"child": []
				}, {
					"name": "曲沃县",
					"id": "141021",
					"child": []
				}, {
					"name": "永和县",
					"id": "141032",
					"child": []
				}, {
					"name": "隰县",
					"id": "141031",
					"child": []
				}, {
					"name": "市辖区",
					"id": "141001",
					"child": []
				}, {
					"name": "襄汾县",
					"id": "141023",
					"child": []
				}, {
					"name": "汾西县",
					"id": "141034",
					"child": []
				}, {
					"name": "翼城县",
					"id": "141022",
					"child": []
				}, {
					"name": "蒲县",
					"id": "141033",
					"child": []
				}, {
					"name": "古县",
					"id": "141025",
					"child": []
				}, {
					"name": "尧都区",
					"id": "141002",
					"child": []
				}, {
					"name": "洪洞县",
					"id": "141024",
					"child": []
				}, {
					"name": "浮山县",
					"id": "141027",
					"child": []
				}, {
					"name": "安泽县",
					"id": "141026",
					"child": []
				}, {
					"name": "乡宁县",
					"id": "141029",
					"child": []
				}, {
					"name": "吉县",
					"id": "141028",
					"child": []
				}]
			}, {
				"name": "太原市",
				"id": "140100",
				"child": [{
					"name": "晋源区",
					"id": "140110",
					"child": []
				}, {
					"name": "清徐县",
					"id": "140121",
					"child": []
				}, {
					"name": "阳曲县",
					"id": "140122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140101",
					"child": []
				}, {
					"name": "娄烦县",
					"id": "140123",
					"child": []
				}, {
					"name": "小店区",
					"id": "140105",
					"child": []
				}, {
					"name": "迎泽区",
					"id": "140106",
					"child": []
				}, {
					"name": "杏花岭区",
					"id": "140107",
					"child": []
				}, {
					"name": "尖草坪区",
					"id": "140108",
					"child": []
				}, {
					"name": "万柏林区",
					"id": "140109",
					"child": []
				}, {
					"name": "古交市",
					"id": "140181",
					"child": []
				}]
			}, {
				"name": "大同市",
				"id": "140200",
				"child": [{
					"name": "阳高县",
					"id": "140221",
					"child": []
				}, {
					"name": "南郊区",
					"id": "140211",
					"child": []
				}, {
					"name": "天镇县",
					"id": "140222",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140201",
					"child": []
				}, {
					"name": "新荣区",
					"id": "140212",
					"child": []
				}, {
					"name": "广灵县",
					"id": "140223",
					"child": []
				}, {
					"name": "城区",
					"id": "140202",
					"child": []
				}, {
					"name": "灵丘县",
					"id": "140224",
					"child": []
				}, {
					"name": "矿区",
					"id": "140203",
					"child": []
				}, {
					"name": "浑源县",
					"id": "140225",
					"child": []
				}, {
					"name": "左云县",
					"id": "140226",
					"child": []
				}, {
					"name": "大同县",
					"id": "140227",
					"child": []
				}]
			}, {
				"name": "阳泉市",
				"id": "140300",
				"child": [{
					"name": "平定县",
					"id": "140321",
					"child": []
				}, {
					"name": "郊区",
					"id": "140311",
					"child": []
				}, {
					"name": "盂县",
					"id": "140322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140301",
					"child": []
				}, {
					"name": "城区",
					"id": "140302",
					"child": []
				}, {
					"name": "矿区",
					"id": "140303",
					"child": []
				}]
			}, {
				"name": "长治市",
				"id": "140400",
				"child": [{
					"name": "潞城市",
					"id": "140481",
					"child": []
				}, {
					"name": "沁县",
					"id": "140430",
					"child": []
				}, {
					"name": "沁源县",
					"id": "140431",
					"child": []
				}, {
					"name": "长治县",
					"id": "140421",
					"child": []
				}, {
					"name": "郊区",
					"id": "140411",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140401",
					"child": []
				}, {
					"name": "襄垣县",
					"id": "140423",
					"child": []
				}, {
					"name": "城区",
					"id": "140402",
					"child": []
				}, {
					"name": "屯留县",
					"id": "140424",
					"child": []
				}, {
					"name": "平顺县",
					"id": "140425",
					"child": []
				}, {
					"name": "黎城县",
					"id": "140426",
					"child": []
				}, {
					"name": "壶关县",
					"id": "140427",
					"child": []
				}, {
					"name": "长子县",
					"id": "140428",
					"child": []
				}, {
					"name": "武乡县",
					"id": "140429",
					"child": []
				}]
			}, {
				"name": "晋城市",
				"id": "140500",
				"child": [{
					"name": "高平市",
					"id": "140581",
					"child": []
				}, {
					"name": "沁水县",
					"id": "140521",
					"child": []
				}, {
					"name": "阳城县",
					"id": "140522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140501",
					"child": []
				}, {
					"name": "城区",
					"id": "140502",
					"child": []
				}, {
					"name": "陵川县",
					"id": "140524",
					"child": []
				}, {
					"name": "泽州县",
					"id": "140525",
					"child": []
				}]
			}, {
				"name": "朔州市",
				"id": "140600",
				"child": [{
					"name": "山阴县",
					"id": "140621",
					"child": []
				}, {
					"name": "应县",
					"id": "140622",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140601",
					"child": []
				}, {
					"name": "右玉县",
					"id": "140623",
					"child": []
				}, {
					"name": "朔城区",
					"id": "140602",
					"child": []
				}, {
					"name": "怀仁县",
					"id": "140624",
					"child": []
				}, {
					"name": "平鲁区",
					"id": "140603",
					"child": []
				}]
			}, {
				"name": "晋中市",
				"id": "140700",
				"child": [{
					"name": "平遥县",
					"id": "140728",
					"child": []
				}, {
					"name": "灵石县",
					"id": "140729",
					"child": []
				}, {
					"name": "介休市",
					"id": "140781",
					"child": []
				}, {
					"name": "榆社县",
					"id": "140721",
					"child": []
				}, {
					"name": "左权县",
					"id": "140722",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140701",
					"child": []
				}, {
					"name": "和顺县",
					"id": "140723",
					"child": []
				}, {
					"name": "榆次区",
					"id": "140702",
					"child": []
				}, {
					"name": "昔阳县",
					"id": "140724",
					"child": []
				}, {
					"name": "寿阳县",
					"id": "140725",
					"child": []
				}, {
					"name": "太谷县",
					"id": "140726",
					"child": []
				}, {
					"name": "祁县",
					"id": "140727",
					"child": []
				}]
			}, {
				"name": "运城市",
				"id": "140800",
				"child": [{
					"name": "垣曲县",
					"id": "140827",
					"child": []
				}, {
					"name": "夏县",
					"id": "140828",
					"child": []
				}, {
					"name": "平陆县",
					"id": "140829",
					"child": []
				}, {
					"name": "永济市",
					"id": "140881",
					"child": []
				}, {
					"name": "河津市",
					"id": "140882",
					"child": []
				}, {
					"name": "芮城县",
					"id": "140830",
					"child": []
				}, {
					"name": "临猗县",
					"id": "140821",
					"child": []
				}, {
					"name": "万荣县",
					"id": "140822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140801",
					"child": []
				}, {
					"name": "闻喜县",
					"id": "140823",
					"child": []
				}, {
					"name": "盐湖区",
					"id": "140802",
					"child": []
				}, {
					"name": "稷山县",
					"id": "140824",
					"child": []
				}, {
					"name": "新绛县",
					"id": "140825",
					"child": []
				}, {
					"name": "绛县",
					"id": "140826",
					"child": []
				}]
			}, {
				"name": "忻州市",
				"id": "140900",
				"child": [{
					"name": "静乐县",
					"id": "140926",
					"child": []
				}, {
					"name": "神池县",
					"id": "140927",
					"child": []
				}, {
					"name": "五寨县",
					"id": "140928",
					"child": []
				}, {
					"name": "岢岚县",
					"id": "140929",
					"child": []
				}, {
					"name": "原平市",
					"id": "140981",
					"child": []
				}, {
					"name": "河曲县",
					"id": "140930",
					"child": []
				}, {
					"name": "保德县",
					"id": "140931",
					"child": []
				}, {
					"name": "定襄县",
					"id": "140921",
					"child": []
				}, {
					"name": "偏关县",
					"id": "140932",
					"child": []
				}, {
					"name": "五台县",
					"id": "140922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "140901",
					"child": []
				}, {
					"name": "代县",
					"id": "140923",
					"child": []
				}, {
					"name": "忻府区",
					"id": "140902",
					"child": []
				}, {
					"name": "繁峙县",
					"id": "140924",
					"child": []
				}, {
					"name": "宁武县",
					"id": "140925",
					"child": []
				}]
			}]
		},
		{
			"name": "江西省",
			"id": "360000",
			"child": [{
				"name": "萍乡市",
				"id": "360300",
				"child": [{
					"name": "上栗县",
					"id": "360322",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360301",
					"child": []
				}, {
					"name": "芦溪县",
					"id": "360323",
					"child": []
				}, {
					"name": "莲花县",
					"id": "360321",
					"child": []
				}, {
					"name": "安源区",
					"id": "360302",
					"child": []
				}, {
					"name": "湘东区",
					"id": "360313",
					"child": []
				}]
			}, {
				"name": "九江市",
				"id": "360400",
				"child": [{
					"name": "九江县",
					"id": "360421",
					"child": []
				}, {
					"name": "彭泽县",
					"id": "360430",
					"child": []
				}, {
					"name": "庐山市",
					"id": "360483",
					"child": []
				}, {
					"name": "瑞昌市",
					"id": "360481",
					"child": []
				}, {
					"name": "共青城市",
					"id": "360482",
					"child": []
				}, {
					"name": "湖口县",
					"id": "360429",
					"child": []
				}, {
					"name": "都昌县",
					"id": "360428",
					"child": []
				}, {
					"name": "浔阳区",
					"id": "360403",
					"child": []
				}, {
					"name": "永修县",
					"id": "360425",
					"child": []
				}, {
					"name": "德安县",
					"id": "360426",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360401",
					"child": []
				}, {
					"name": "武宁县",
					"id": "360423",
					"child": []
				}, {
					"name": "濂溪区",
					"id": "360402",
					"child": []
				}, {
					"name": "修水县",
					"id": "360424",
					"child": []
				}]
			}, {
				"name": "南昌市",
				"id": "360100",
				"child": [{
					"name": "东湖区",
					"id": "360102",
					"child": []
				}, {
					"name": "进贤县",
					"id": "360124",
					"child": []
				}, {
					"name": "西湖区",
					"id": "360103",
					"child": []
				}, {
					"name": "青山湖区",
					"id": "360111",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360101",
					"child": []
				}, {
					"name": "新建区",
					"id": "360112",
					"child": []
				}, {
					"name": "安义县",
					"id": "360123",
					"child": []
				}, {
					"name": "南昌县",
					"id": "360121",
					"child": []
				}, {
					"name": "青云谱区",
					"id": "360104",
					"child": []
				}, {
					"name": "湾里区",
					"id": "360105",
					"child": []
				}]
			}, {
				"name": "景德镇市",
				"id": "360200",
				"child": [{
					"name": "市辖区",
					"id": "360201",
					"child": []
				}, {
					"name": "昌江区",
					"id": "360202",
					"child": []
				}, {
					"name": "浮梁县",
					"id": "360222",
					"child": []
				}, {
					"name": "乐平市",
					"id": "360281",
					"child": []
				}, {
					"name": "珠山区",
					"id": "360203",
					"child": []
				}]
			}, {
				"name": "上饶市",
				"id": "361100",
				"child": [{
					"name": "德兴市",
					"id": "361181",
					"child": []
				}, {
					"name": "弋阳县",
					"id": "361126",
					"child": []
				}, {
					"name": "广丰区",
					"id": "361103",
					"child": []
				}, {
					"name": "横峰县",
					"id": "361125",
					"child": []
				}, {
					"name": "信州区",
					"id": "361102",
					"child": []
				}, {
					"name": "铅山县",
					"id": "361124",
					"child": []
				}, {
					"name": "市辖区",
					"id": "361101",
					"child": []
				}, {
					"name": "玉山县",
					"id": "361123",
					"child": []
				}, {
					"name": "上饶县",
					"id": "361121",
					"child": []
				}, {
					"name": "婺源县",
					"id": "361130",
					"child": []
				}, {
					"name": "万年县",
					"id": "361129",
					"child": []
				}, {
					"name": "鄱阳县",
					"id": "361128",
					"child": []
				}, {
					"name": "余干县",
					"id": "361127",
					"child": []
				}]
			}, {
				"name": "抚州市",
				"id": "361000",
				"child": [{
					"name": "金溪县",
					"id": "361027",
					"child": []
				}, {
					"name": "宜黄县",
					"id": "361026",
					"child": []
				}, {
					"name": "乐安县",
					"id": "361025",
					"child": []
				}, {
					"name": "临川区",
					"id": "361002",
					"child": []
				}, {
					"name": "崇仁县",
					"id": "361024",
					"child": []
				}, {
					"name": "市辖区",
					"id": "361001",
					"child": []
				}, {
					"name": "南丰县",
					"id": "361023",
					"child": []
				}, {
					"name": "黎川县",
					"id": "361022",
					"child": []
				}, {
					"name": "南城县",
					"id": "361021",
					"child": []
				}, {
					"name": "广昌县",
					"id": "361030",
					"child": []
				}, {
					"name": "东乡县",
					"id": "361029",
					"child": []
				}, {
					"name": "资溪县",
					"id": "361028",
					"child": []
				}]
			}, {
				"name": "宜春市",
				"id": "360900",
				"child": [{
					"name": "樟树市",
					"id": "360982",
					"child": []
				}, {
					"name": "高安市",
					"id": "360983",
					"child": []
				}, {
					"name": "丰城市",
					"id": "360981",
					"child": []
				}, {
					"name": "铜鼓县",
					"id": "360926",
					"child": []
				}, {
					"name": "袁州区",
					"id": "360902",
					"child": []
				}, {
					"name": "宜丰县",
					"id": "360924",
					"child": []
				}, {
					"name": "靖安县",
					"id": "360925",
					"child": []
				}, {
					"name": "万载县",
					"id": "360922",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360901",
					"child": []
				}, {
					"name": "上高县",
					"id": "360923",
					"child": []
				}, {
					"name": "奉新县",
					"id": "360921",
					"child": []
				}]
			}, {
				"name": "赣州市",
				"id": "360700",
				"child": [{
					"name": "定南县",
					"id": "360728",
					"child": []
				}, {
					"name": "全南县",
					"id": "360729",
					"child": []
				}, {
					"name": "宁都县",
					"id": "360730",
					"child": []
				}, {
					"name": "瑞金市",
					"id": "360781",
					"child": []
				}, {
					"name": "安远县",
					"id": "360726",
					"child": []
				}, {
					"name": "龙南县",
					"id": "360727",
					"child": []
				}, {
					"name": "章贡区",
					"id": "360702",
					"child": []
				}, {
					"name": "上犹县",
					"id": "360724",
					"child": []
				}, {
					"name": "石城县",
					"id": "360735",
					"child": []
				}, {
					"name": "南康区",
					"id": "360703",
					"child": []
				}, {
					"name": "崇义县",
					"id": "360725",
					"child": []
				}, {
					"name": "信丰县",
					"id": "360722",
					"child": []
				}, {
					"name": "会昌县",
					"id": "360733",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360701",
					"child": []
				}, {
					"name": "大余县",
					"id": "360723",
					"child": []
				}, {
					"name": "寻乌县",
					"id": "360734",
					"child": []
				}, {
					"name": "于都县",
					"id": "360731",
					"child": []
				}, {
					"name": "赣县",
					"id": "360721",
					"child": []
				}, {
					"name": "兴国县",
					"id": "360732",
					"child": []
				}]
			}, {
				"name": "吉安市",
				"id": "360800",
				"child": [{
					"name": "安福县",
					"id": "360829",
					"child": []
				}, {
					"name": "遂川县",
					"id": "360827",
					"child": []
				}, {
					"name": "万安县",
					"id": "360828",
					"child": []
				}, {
					"name": "井冈山市",
					"id": "360881",
					"child": []
				}, {
					"name": "青原区",
					"id": "360803",
					"child": []
				}, {
					"name": "永丰县",
					"id": "360825",
					"child": []
				}, {
					"name": "泰和县",
					"id": "360826",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360801",
					"child": []
				}, {
					"name": "峡江县",
					"id": "360823",
					"child": []
				}, {
					"name": "吉州区",
					"id": "360802",
					"child": []
				}, {
					"name": "新干县",
					"id": "360824",
					"child": []
				}, {
					"name": "吉安县",
					"id": "360821",
					"child": []
				}, {
					"name": "吉水县",
					"id": "360822",
					"child": []
				}, {
					"name": "永新县",
					"id": "360830",
					"child": []
				}]
			}, {
				"name": "新余市",
				"id": "360500",
				"child": [{
					"name": "分宜县",
					"id": "360521",
					"child": []
				}, {
					"name": "渝水区",
					"id": "360502",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360501",
					"child": []
				}]
			}, {
				"name": "鹰潭市",
				"id": "360600",
				"child": [{
					"name": "贵溪市",
					"id": "360681",
					"child": []
				}, {
					"name": "市辖区",
					"id": "360601",
					"child": []
				}, {
					"name": "月湖区",
					"id": "360602",
					"child": []
				}, {
					"name": "余江县",
					"id": "360622",
					"child": []
				}]
			}]
		},
		{
			"name": "黑龙江省",
			"id": "230000",
			"child": [{
				"name": "大庆市",
				"id": "230600",
				"child": [{
					"name": "肇源县",
					"id": "230622",
					"child": []
				}, {
					"name": "肇州县",
					"id": "230621",
					"child": []
				}, {
					"name": "大同区",
					"id": "230606",
					"child": []
				}, {
					"name": "红岗区",
					"id": "230605",
					"child": []
				}, {
					"name": "让胡路区",
					"id": "230604",
					"child": []
				}, {
					"name": "龙凤区",
					"id": "230603",
					"child": []
				}, {
					"name": "萨尔图区",
					"id": "230602",
					"child": []
				}, {
					"name": "杜尔伯特蒙古族自治县",
					"id": "230624",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230601",
					"child": []
				}, {
					"name": "林甸县",
					"id": "230623",
					"child": []
				}]
			}, {
				"name": "双鸭山市",
				"id": "230500",
				"child": [{
					"name": "市辖区",
					"id": "230501",
					"child": []
				}, {
					"name": "宝清县",
					"id": "230523",
					"child": []
				}, {
					"name": "友谊县",
					"id": "230522",
					"child": []
				}, {
					"name": "集贤县",
					"id": "230521",
					"child": []
				}, {
					"name": "宝山区",
					"id": "230506",
					"child": []
				}, {
					"name": "四方台区",
					"id": "230505",
					"child": []
				}, {
					"name": "岭东区",
					"id": "230503",
					"child": []
				}, {
					"name": "尖山区",
					"id": "230502",
					"child": []
				}, {
					"name": "饶河县",
					"id": "230524",
					"child": []
				}]
			}, {
				"name": "鹤岗市",
				"id": "230400",
				"child": [{
					"name": "向阳区",
					"id": "230402",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230401",
					"child": []
				}, {
					"name": "绥滨县",
					"id": "230422",
					"child": []
				}, {
					"name": "萝北县",
					"id": "230421",
					"child": []
				}, {
					"name": "兴山区",
					"id": "230407",
					"child": []
				}, {
					"name": "东山区",
					"id": "230406",
					"child": []
				}, {
					"name": "兴安区",
					"id": "230405",
					"child": []
				}, {
					"name": "南山区",
					"id": "230404",
					"child": []
				}, {
					"name": "工农区",
					"id": "230403",
					"child": []
				}]
			}, {
				"name": "鸡西市",
				"id": "230300",
				"child": [{
					"name": "恒山区",
					"id": "230303",
					"child": []
				}, {
					"name": "鸡冠区",
					"id": "230302",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230301",
					"child": []
				}, {
					"name": "鸡东县",
					"id": "230321",
					"child": []
				}, {
					"name": "密山市",
					"id": "230382",
					"child": []
				}, {
					"name": "虎林市",
					"id": "230381",
					"child": []
				}, {
					"name": "麻山区",
					"id": "230307",
					"child": []
				}, {
					"name": "城子河区",
					"id": "230306",
					"child": []
				}, {
					"name": "梨树区",
					"id": "230305",
					"child": []
				}, {
					"name": "滴道区",
					"id": "230304",
					"child": []
				}]
			}, {
				"name": "齐齐哈尔市",
				"id": "230200",
				"child": [{
					"name": "讷河市",
					"id": "230281",
					"child": []
				}, {
					"name": "铁锋区",
					"id": "230204",
					"child": []
				}, {
					"name": "建华区",
					"id": "230203",
					"child": []
				}, {
					"name": "甘南县",
					"id": "230225",
					"child": []
				}, {
					"name": "龙沙区",
					"id": "230202",
					"child": []
				}, {
					"name": "泰来县",
					"id": "230224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230201",
					"child": []
				}, {
					"name": "依安县",
					"id": "230223",
					"child": []
				}, {
					"name": "龙江县",
					"id": "230221",
					"child": []
				}, {
					"name": "拜泉县",
					"id": "230231",
					"child": []
				}, {
					"name": "克东县",
					"id": "230230",
					"child": []
				}, {
					"name": "梅里斯达斡尔族区",
					"id": "230208",
					"child": []
				}, {
					"name": "碾子山区",
					"id": "230207",
					"child": []
				}, {
					"name": "克山县",
					"id": "230229",
					"child": []
				}, {
					"name": "富拉尔基区",
					"id": "230206",
					"child": []
				}, {
					"name": "昂昂溪区",
					"id": "230205",
					"child": []
				}, {
					"name": "富裕县",
					"id": "230227",
					"child": []
				}]
			}, {
				"name": "哈尔滨市",
				"id": "230100",
				"child": [{
					"name": "五常市",
					"id": "230184",
					"child": []
				}, {
					"name": "尚志市",
					"id": "230183",
					"child": []
				}, {
					"name": "木兰县",
					"id": "230127",
					"child": []
				}, {
					"name": "道外区",
					"id": "230104",
					"child": []
				}, {
					"name": "巴彦县",
					"id": "230126",
					"child": []
				}, {
					"name": "南岗区",
					"id": "230103",
					"child": []
				}, {
					"name": "宾县",
					"id": "230125",
					"child": []
				}, {
					"name": "道里区",
					"id": "230102",
					"child": []
				}, {
					"name": "双城区",
					"id": "230113",
					"child": []
				}, {
					"name": "方正县",
					"id": "230124",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230101",
					"child": []
				}, {
					"name": "阿城区",
					"id": "230112",
					"child": []
				}, {
					"name": "依兰县",
					"id": "230123",
					"child": []
				}, {
					"name": "呼兰区",
					"id": "230111",
					"child": []
				}, {
					"name": "香坊区",
					"id": "230110",
					"child": []
				}, {
					"name": "松北区",
					"id": "230109",
					"child": []
				}, {
					"name": "平房区",
					"id": "230108",
					"child": []
				}, {
					"name": "延寿县",
					"id": "230129",
					"child": []
				}, {
					"name": "通河县",
					"id": "230128",
					"child": []
				}]
			}, {
				"name": "牡丹江市",
				"id": "231000",
				"child": [{
					"name": "西安区",
					"id": "231005",
					"child": []
				}, {
					"name": "爱民区",
					"id": "231004",
					"child": []
				}, {
					"name": "阳明区",
					"id": "231003",
					"child": []
				}, {
					"name": "林口县",
					"id": "231025",
					"child": []
				}, {
					"name": "东安区",
					"id": "231002",
					"child": []
				}, {
					"name": "市辖区",
					"id": "231001",
					"child": []
				}, {
					"name": "东宁市",
					"id": "231086",
					"child": []
				}, {
					"name": "穆棱市",
					"id": "231085",
					"child": []
				}, {
					"name": "宁安市",
					"id": "231084",
					"child": []
				}, {
					"name": "海林市",
					"id": "231083",
					"child": []
				}, {
					"name": "绥芬河市",
					"id": "231081",
					"child": []
				}]
			}, {
				"name": "黑河市",
				"id": "231100",
				"child": [{
					"name": "北安市",
					"id": "231181",
					"child": []
				}, {
					"name": "五大连池市",
					"id": "231182",
					"child": []
				}, {
					"name": "嫩江县",
					"id": "231121",
					"child": []
				}, {
					"name": "市辖区",
					"id": "231101",
					"child": []
				}, {
					"name": "逊克县",
					"id": "231123",
					"child": []
				}, {
					"name": "爱辉区",
					"id": "231102",
					"child": []
				}, {
					"name": "孙吴县",
					"id": "231124",
					"child": []
				}]
			}, {
				"name": "绥化市",
				"id": "231200",
				"child": [{
					"name": "安达市",
					"id": "231281",
					"child": []
				}, {
					"name": "肇东市",
					"id": "231282",
					"child": []
				}, {
					"name": "海伦市",
					"id": "231283",
					"child": []
				}, {
					"name": "望奎县",
					"id": "231221",
					"child": []
				}, {
					"name": "兰西县",
					"id": "231222",
					"child": []
				}, {
					"name": "市辖区",
					"id": "231201",
					"child": []
				}, {
					"name": "青冈县",
					"id": "231223",
					"child": []
				}, {
					"name": "北林区",
					"id": "231202",
					"child": []
				}, {
					"name": "庆安县",
					"id": "231224",
					"child": []
				}, {
					"name": "明水县",
					"id": "231225",
					"child": []
				}, {
					"name": "绥棱县",
					"id": "231226",
					"child": []
				}]
			}, {
				"name": "七台河市",
				"id": "230900",
				"child": [{
					"name": "茄子河区",
					"id": "230904",
					"child": []
				}, {
					"name": "桃山区",
					"id": "230903",
					"child": []
				}, {
					"name": "新兴区",
					"id": "230902",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230901",
					"child": []
				}, {
					"name": "勃利县",
					"id": "230921",
					"child": []
				}]
			}, {
				"name": "佳木斯市",
				"id": "230800",
				"child": [{
					"name": "抚远市",
					"id": "230883",
					"child": []
				}, {
					"name": "富锦市",
					"id": "230882",
					"child": []
				}, {
					"name": "同江市",
					"id": "230881",
					"child": []
				}, {
					"name": "汤原县",
					"id": "230828",
					"child": []
				}, {
					"name": "东风区",
					"id": "230805",
					"child": []
				}, {
					"name": "前进区",
					"id": "230804",
					"child": []
				}, {
					"name": "桦川县",
					"id": "230826",
					"child": []
				}, {
					"name": "向阳区",
					"id": "230803",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230801",
					"child": []
				}, {
					"name": "郊区",
					"id": "230811",
					"child": []
				}, {
					"name": "桦南县",
					"id": "230822",
					"child": []
				}]
			}, {
				"name": "大兴安岭地区",
				"id": "232700",
				"child": [{
					"name": "呼玛县",
					"id": "232721",
					"child": []
				}, {
					"name": "塔河县",
					"id": "232722",
					"child": []
				}, {
					"name": "漠河县",
					"id": "232723",
					"child": []
				}]
			}, {
				"name": "伊春市",
				"id": "230700",
				"child": [{
					"name": "金山屯区",
					"id": "230709",
					"child": []
				}, {
					"name": "美溪区",
					"id": "230708",
					"child": []
				}, {
					"name": "五营区",
					"id": "230710",
					"child": []
				}, {
					"name": "铁力市",
					"id": "230781",
					"child": []
				}, {
					"name": "新青区",
					"id": "230707",
					"child": []
				}, {
					"name": "翠峦区",
					"id": "230706",
					"child": []
				}, {
					"name": "西林区",
					"id": "230705",
					"child": []
				}, {
					"name": "上甘岭区",
					"id": "230716",
					"child": []
				}, {
					"name": "友好区",
					"id": "230704",
					"child": []
				}, {
					"name": "红星区",
					"id": "230715",
					"child": []
				}, {
					"name": "南岔区",
					"id": "230703",
					"child": []
				}, {
					"name": "乌伊岭区",
					"id": "230714",
					"child": []
				}, {
					"name": "伊春区",
					"id": "230702",
					"child": []
				}, {
					"name": "带岭区",
					"id": "230713",
					"child": []
				}, {
					"name": "市辖区",
					"id": "230701",
					"child": []
				}, {
					"name": "汤旺河区",
					"id": "230712",
					"child": []
				}, {
					"name": "乌马河区",
					"id": "230711",
					"child": []
				}, {
					"name": "嘉荫县",
					"id": "230722",
					"child": []
				}]
			}]
		},
		{
			"name": "青海省",
			"id": "630000",
			"child": [{
				"name": "西宁市",
				"id": "630100",
				"child": [{
					"name": "湟中县",
					"id": "630122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "630101",
					"child": []
				}, {
					"name": "湟源县",
					"id": "630123",
					"child": []
				}, {
					"name": "大通回族土族自治县",
					"id": "630121",
					"child": []
				}, {
					"name": "城西区",
					"id": "630104",
					"child": []
				}, {
					"name": "城北区",
					"id": "630105",
					"child": []
				}, {
					"name": "城东区",
					"id": "630102",
					"child": []
				}, {
					"name": "城中区",
					"id": "630103",
					"child": []
				}]
			}, {
				"name": "海东市",
				"id": "630200",
				"child": [{
					"name": "民和回族土族自治县",
					"id": "630222",
					"child": []
				}, {
					"name": "平安区",
					"id": "630203",
					"child": []
				}, {
					"name": "循化撒拉族自治县",
					"id": "630225",
					"child": []
				}, {
					"name": "互助土族自治县",
					"id": "630223",
					"child": []
				}, {
					"name": "乐都区",
					"id": "630202",
					"child": []
				}, {
					"name": "化隆回族自治县",
					"id": "630224",
					"child": []
				}]
			}, {
				"name": "黄南藏族自治州",
				"id": "632300",
				"child": [{
					"name": "泽库县",
					"id": "632323",
					"child": []
				}, {
					"name": "尖扎县",
					"id": "632322",
					"child": []
				}, {
					"name": "同仁县",
					"id": "632321",
					"child": []
				}, {
					"name": "河南蒙古族自治县",
					"id": "632324",
					"child": []
				}]
			}, {
				"name": "海北藏族自治州",
				"id": "632200",
				"child": [{
					"name": "刚察县",
					"id": "632224",
					"child": []
				}, {
					"name": "海晏县",
					"id": "632223",
					"child": []
				}, {
					"name": "祁连县",
					"id": "632222",
					"child": []
				}, {
					"name": "门源回族自治县",
					"id": "632221",
					"child": []
				}]
			}, {
				"name": "海西蒙古族藏族自治州",
				"id": "632800",
				"child": [{
					"name": "都兰县",
					"id": "632822",
					"child": []
				}, {
					"name": "乌兰县",
					"id": "632821",
					"child": []
				}, {
					"name": "德令哈市",
					"id": "632802",
					"child": []
				}, {
					"name": "格尔木市",
					"id": "632801",
					"child": []
				}, {
					"name": "天峻县",
					"id": "632823",
					"child": []
				}]
			}, {
				"name": "玉树藏族自治州",
				"id": "632700",
				"child": [{
					"name": "玉树市",
					"id": "632701",
					"child": []
				}, {
					"name": "称多县",
					"id": "632723",
					"child": []
				}, {
					"name": "杂多县",
					"id": "632722",
					"child": []
				}, {
					"name": "曲麻莱县",
					"id": "632726",
					"child": []
				}, {
					"name": "囊谦县",
					"id": "632725",
					"child": []
				}, {
					"name": "治多县",
					"id": "632724",
					"child": []
				}]
			}, {
				"name": "果洛藏族自治州",
				"id": "632600",
				"child": [{
					"name": "达日县",
					"id": "632624",
					"child": []
				}, {
					"name": "甘德县",
					"id": "632623",
					"child": []
				}, {
					"name": "班玛县",
					"id": "632622",
					"child": []
				}, {
					"name": "玛沁县",
					"id": "632621",
					"child": []
				}, {
					"name": "玛多县",
					"id": "632626",
					"child": []
				}, {
					"name": "久治县",
					"id": "632625",
					"child": []
				}]
			}, {
				"name": "海南藏族自治州",
				"id": "632500",
				"child": [{
					"name": "共和县",
					"id": "632521",
					"child": []
				}, {
					"name": "贵南县",
					"id": "632525",
					"child": []
				}, {
					"name": "兴海县",
					"id": "632524",
					"child": []
				}, {
					"name": "贵德县",
					"id": "632523",
					"child": []
				}, {
					"name": "同德县",
					"id": "632522",
					"child": []
				}]
			}]
		},
		{
			"name": "河南省",
			"id": "410000",
			"child": [{
				"name": "焦作市",
				"id": "410800",
				"child": [{
					"name": "山阳区",
					"id": "410811",
					"child": []
				}, {
					"name": "博爱县",
					"id": "410822",
					"child": []
				}, {
					"name": "修武县",
					"id": "410821",
					"child": []
				}, {
					"name": "解放区",
					"id": "410802",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410801",
					"child": []
				}, {
					"name": "武陟县",
					"id": "410823",
					"child": []
				}, {
					"name": "孟州市",
					"id": "410883",
					"child": []
				}, {
					"name": "沁阳市",
					"id": "410882",
					"child": []
				}, {
					"name": "马村区",
					"id": "410804",
					"child": []
				}, {
					"name": "中站区",
					"id": "410803",
					"child": []
				}, {
					"name": "温县",
					"id": "410825",
					"child": []
				}]
			}, {
				"name": "新乡市",
				"id": "410700",
				"child": [{
					"name": "市辖区",
					"id": "410701",
					"child": []
				}, {
					"name": "牧野区",
					"id": "410711",
					"child": []
				}, {
					"name": "卫滨区",
					"id": "410703",
					"child": []
				}, {
					"name": "原阳县",
					"id": "410725",
					"child": []
				}, {
					"name": "红旗区",
					"id": "410702",
					"child": []
				}, {
					"name": "获嘉县",
					"id": "410724",
					"child": []
				}, {
					"name": "新乡县",
					"id": "410721",
					"child": []
				}, {
					"name": "封丘县",
					"id": "410727",
					"child": []
				}, {
					"name": "凤泉区",
					"id": "410704",
					"child": []
				}, {
					"name": "延津县",
					"id": "410726",
					"child": []
				}, {
					"name": "长垣县",
					"id": "410728",
					"child": []
				}, {
					"name": "卫辉市",
					"id": "410781",
					"child": []
				}, {
					"name": "辉县市",
					"id": "410782",
					"child": []
				}]
			}, {
				"name": "濮阳市",
				"id": "410900",
				"child": [{
					"name": "市辖区",
					"id": "410901",
					"child": []
				}, {
					"name": "南乐县",
					"id": "410923",
					"child": []
				}, {
					"name": "清丰县",
					"id": "410922",
					"child": []
				}, {
					"name": "濮阳县",
					"id": "410928",
					"child": []
				}, {
					"name": "华龙区",
					"id": "410902",
					"child": []
				}, {
					"name": "台前县",
					"id": "410927",
					"child": []
				}, {
					"name": "范县",
					"id": "410926",
					"child": []
				}]
			}, {
				"name": "平顶山市",
				"id": "410400",
				"child": [{
					"name": "石龙区",
					"id": "410404",
					"child": []
				}, {
					"name": "卫东区",
					"id": "410403",
					"child": []
				}, {
					"name": "郏县",
					"id": "410425",
					"child": []
				}, {
					"name": "湛河区",
					"id": "410411",
					"child": []
				}, {
					"name": "叶县",
					"id": "410422",
					"child": []
				}, {
					"name": "宝丰县",
					"id": "410421",
					"child": []
				}, {
					"name": "新华区",
					"id": "410402",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410401",
					"child": []
				}, {
					"name": "鲁山县",
					"id": "410423",
					"child": []
				}, {
					"name": "汝州市",
					"id": "410482",
					"child": []
				}, {
					"name": "舞钢市",
					"id": "410481",
					"child": []
				}]
			}, {
				"name": "信阳市",
				"id": "411500",
				"child": [{
					"name": "潢川县",
					"id": "411526",
					"child": []
				}, {
					"name": "平桥区",
					"id": "411503",
					"child": []
				}, {
					"name": "固始县",
					"id": "411525",
					"child": []
				}, {
					"name": "息县",
					"id": "411528",
					"child": []
				}, {
					"name": "淮滨县",
					"id": "411527",
					"child": []
				}, {
					"name": "光山县",
					"id": "411522",
					"child": []
				}, {
					"name": "罗山县",
					"id": "411521",
					"child": []
				}, {
					"name": "浉河区",
					"id": "411502",
					"child": []
				}, {
					"name": "商城县",
					"id": "411524",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411501",
					"child": []
				}, {
					"name": "新县",
					"id": "411523",
					"child": []
				}]
			}, {
				"name": "洛阳市",
				"id": "410300",
				"child": [{
					"name": "涧西区",
					"id": "410305",
					"child": []
				}, {
					"name": "宜阳县",
					"id": "410327",
					"child": []
				}, {
					"name": "瀍河回族区",
					"id": "410304",
					"child": []
				}, {
					"name": "汝阳县",
					"id": "410326",
					"child": []
				}, {
					"name": "伊川县",
					"id": "410329",
					"child": []
				}, {
					"name": "吉利区",
					"id": "410306",
					"child": []
				}, {
					"name": "洛宁县",
					"id": "410328",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410301",
					"child": []
				}, {
					"name": "新安县",
					"id": "410323",
					"child": []
				}, {
					"name": "洛龙区",
					"id": "410311",
					"child": []
				}, {
					"name": "孟津县",
					"id": "410322",
					"child": []
				}, {
					"name": "西工区",
					"id": "410303",
					"child": []
				}, {
					"name": "嵩县",
					"id": "410325",
					"child": []
				}, {
					"name": "老城区",
					"id": "410302",
					"child": []
				}, {
					"name": "栾川县",
					"id": "410324",
					"child": []
				}, {
					"name": "偃师市",
					"id": "410381",
					"child": []
				}]
			}, {
				"name": "商丘市",
				"id": "411400",
				"child": [{
					"name": "夏邑县",
					"id": "411426",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411401",
					"child": []
				}, {
					"name": "宁陵县",
					"id": "411423",
					"child": []
				}, {
					"name": "睢县",
					"id": "411422",
					"child": []
				}, {
					"name": "睢阳区",
					"id": "411403",
					"child": []
				}, {
					"name": "虞城县",
					"id": "411425",
					"child": []
				}, {
					"name": "梁园区",
					"id": "411402",
					"child": []
				}, {
					"name": "柘城县",
					"id": "411424",
					"child": []
				}, {
					"name": "民权县",
					"id": "411421",
					"child": []
				}, {
					"name": "永城市",
					"id": "411481",
					"child": []
				}]
			}, {
				"name": "鹤壁市",
				"id": "410600",
				"child": [{
					"name": "鹤山区",
					"id": "410602",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410601",
					"child": []
				}, {
					"name": "山城区",
					"id": "410603",
					"child": []
				}, {
					"name": "淇滨区",
					"id": "410611",
					"child": []
				}, {
					"name": "淇县",
					"id": "410622",
					"child": []
				}, {
					"name": "浚县",
					"id": "410621",
					"child": []
				}]
			}, {
				"name": "驻马店市",
				"id": "411700",
				"child": [{
					"name": "驿城区",
					"id": "411702",
					"child": []
				}, {
					"name": "正阳县",
					"id": "411724",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411701",
					"child": []
				}, {
					"name": "平舆县",
					"id": "411723",
					"child": []
				}, {
					"name": "泌阳县",
					"id": "411726",
					"child": []
				}, {
					"name": "确山县",
					"id": "411725",
					"child": []
				}, {
					"name": "上蔡县",
					"id": "411722",
					"child": []
				}, {
					"name": "西平县",
					"id": "411721",
					"child": []
				}, {
					"name": "遂平县",
					"id": "411728",
					"child": []
				}, {
					"name": "汝南县",
					"id": "411727",
					"child": []
				}, {
					"name": "新蔡县",
					"id": "411729",
					"child": []
				}]
			}, {
				"name": "安阳市",
				"id": "410500",
				"child": [{
					"name": "北关区",
					"id": "410503",
					"child": []
				}, {
					"name": "文峰区",
					"id": "410502",
					"child": []
				}, {
					"name": "殷都区",
					"id": "410505",
					"child": []
				}, {
					"name": "内黄县",
					"id": "410527",
					"child": []
				}, {
					"name": "滑县",
					"id": "410526",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410501",
					"child": []
				}, {
					"name": "汤阴县",
					"id": "410523",
					"child": []
				}, {
					"name": "安阳县",
					"id": "410522",
					"child": []
				}, {
					"name": "龙安区",
					"id": "410506",
					"child": []
				}, {
					"name": "林州市",
					"id": "410581",
					"child": []
				}]
			}, {
				"name": "周口市",
				"id": "411600",
				"child": [{
					"name": "郸城县",
					"id": "411625",
					"child": []
				}, {
					"name": "川汇区",
					"id": "411602",
					"child": []
				}, {
					"name": "沈丘县",
					"id": "411624",
					"child": []
				}, {
					"name": "太康县",
					"id": "411627",
					"child": []
				}, {
					"name": "淮阳县",
					"id": "411626",
					"child": []
				}, {
					"name": "扶沟县",
					"id": "411621",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411601",
					"child": []
				}, {
					"name": "商水县",
					"id": "411623",
					"child": []
				}, {
					"name": "西华县",
					"id": "411622",
					"child": []
				}, {
					"name": "鹿邑县",
					"id": "411628",
					"child": []
				}, {
					"name": "项城市",
					"id": "411681",
					"child": []
				}]
			}, {
				"name": "漯河市",
				"id": "411100",
				"child": [{
					"name": "召陵区",
					"id": "411104",
					"child": []
				}, {
					"name": "郾城区",
					"id": "411103",
					"child": []
				}, {
					"name": "临颍县",
					"id": "411122",
					"child": []
				}, {
					"name": "舞阳县",
					"id": "411121",
					"child": []
				}, {
					"name": "源汇区",
					"id": "411102",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411101",
					"child": []
				}]
			}, {
				"name": "许昌市",
				"id": "411000",
				"child": [{
					"name": "禹州市",
					"id": "411081",
					"child": []
				}, {
					"name": "长葛市",
					"id": "411082",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411001",
					"child": []
				}, {
					"name": "许昌县",
					"id": "411023",
					"child": []
				}, {
					"name": "襄城县",
					"id": "411025",
					"child": []
				}, {
					"name": "魏都区",
					"id": "411002",
					"child": []
				}, {
					"name": "鄢陵县",
					"id": "411024",
					"child": []
				}]
			}, {
				"name": "开封市",
				"id": "410200",
				"child": [{
					"name": "禹王台区",
					"id": "410205",
					"child": []
				}, {
					"name": "龙亭区",
					"id": "410202",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410201",
					"child": []
				}, {
					"name": "祥符区",
					"id": "410212",
					"child": []
				}, {
					"name": "尉氏县",
					"id": "410223",
					"child": []
				}, {
					"name": "鼓楼区",
					"id": "410204",
					"child": []
				}, {
					"name": "顺河回族区",
					"id": "410203",
					"child": []
				}, {
					"name": "兰考县",
					"id": "410225",
					"child": []
				}, {
					"name": "金明区",
					"id": "410211",
					"child": []
				}, {
					"name": "通许县",
					"id": "410222",
					"child": []
				}, {
					"name": "杞县",
					"id": "410221",
					"child": []
				}]
			}, {
				"name": "南阳市",
				"id": "411300",
				"child": [{
					"name": "唐河县",
					"id": "411328",
					"child": []
				}, {
					"name": "社旗县",
					"id": "411327",
					"child": []
				}, {
					"name": "新野县",
					"id": "411329",
					"child": []
				}, {
					"name": "宛城区",
					"id": "411302",
					"child": []
				}, {
					"name": "镇平县",
					"id": "411324",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411301",
					"child": []
				}, {
					"name": "西峡县",
					"id": "411323",
					"child": []
				}, {
					"name": "淅川县",
					"id": "411326",
					"child": []
				}, {
					"name": "卧龙区",
					"id": "411303",
					"child": []
				}, {
					"name": "内乡县",
					"id": "411325",
					"child": []
				}, {
					"name": "桐柏县",
					"id": "411330",
					"child": []
				}, {
					"name": "方城县",
					"id": "411322",
					"child": []
				}, {
					"name": "南召县",
					"id": "411321",
					"child": []
				}, {
					"name": "邓州市",
					"id": "411381",
					"child": []
				}]
			}, {
				"name": "郑州市",
				"id": "410100",
				"child": [{
					"name": "上街区",
					"id": "410106",
					"child": []
				}, {
					"name": "惠济区",
					"id": "410108",
					"child": []
				}, {
					"name": "二七区",
					"id": "410103",
					"child": []
				}, {
					"name": "中原区",
					"id": "410102",
					"child": []
				}, {
					"name": "金水区",
					"id": "410105",
					"child": []
				}, {
					"name": "管城回族区",
					"id": "410104",
					"child": []
				}, {
					"name": "巩义市",
					"id": "410181",
					"child": []
				}, {
					"name": "市辖区",
					"id": "410101",
					"child": []
				}, {
					"name": "中牟县",
					"id": "410122",
					"child": []
				}, {
					"name": "新密市",
					"id": "410183",
					"child": []
				}, {
					"name": "荥阳市",
					"id": "410182",
					"child": []
				}, {
					"name": "登封市",
					"id": "410185",
					"child": []
				}, {
					"name": "新郑市",
					"id": "410184",
					"child": []
				}]
			}, {
				"name": "三门峡市",
				"id": "411200",
				"child": [{
					"name": "义马市",
					"id": "411281",
					"child": []
				}, {
					"name": "陕州区",
					"id": "411203",
					"child": []
				}, {
					"name": "湖滨区",
					"id": "411202",
					"child": []
				}, {
					"name": "卢氏县",
					"id": "411224",
					"child": []
				}, {
					"name": "渑池县",
					"id": "411221",
					"child": []
				}, {
					"name": "市辖区",
					"id": "411201",
					"child": []
				}, {
					"name": "灵宝市",
					"id": "411282",
					"child": []
				}]
			}, {
				"name": "省直辖县级行政区划",
				"id": "419000",
				"child": [{
					"name": "济源市",
					"id": "419001",
					"child": []
				}]
			}]
		},
		{
			"name": "台湾省",
			"id": "710000",
			"child": []
		},
		{
			"name": "内蒙古自治区",
			"id": "150000",
			"child": [{
				"name": "巴彦淖尔市",
				"id": "150800",
				"child": [{
					"name": "临河区",
					"id": "150802",
					"child": []
				}, {
					"name": "乌拉特中旗",
					"id": "150824",
					"child": []
				}, {
					"name": "乌拉特后旗",
					"id": "150825",
					"child": []
				}, {
					"name": "磴口县",
					"id": "150822",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150801",
					"child": []
				}, {
					"name": "乌拉特前旗",
					"id": "150823",
					"child": []
				}, {
					"name": "五原县",
					"id": "150821",
					"child": []
				}, {
					"name": "杭锦后旗",
					"id": "150826",
					"child": []
				}]
			}, {
				"name": "乌兰察布市",
				"id": "150900",
				"child": [{
					"name": "集宁区",
					"id": "150902",
					"child": []
				}, {
					"name": "兴和县",
					"id": "150924",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150901",
					"child": []
				}, {
					"name": "商都县",
					"id": "150923",
					"child": []
				}, {
					"name": "化德县",
					"id": "150922",
					"child": []
				}, {
					"name": "卓资县",
					"id": "150921",
					"child": []
				}, {
					"name": "丰镇市",
					"id": "150981",
					"child": []
				}, {
					"name": "四子王旗",
					"id": "150929",
					"child": []
				}, {
					"name": "察哈尔右翼后旗",
					"id": "150928",
					"child": []
				}, {
					"name": "察哈尔右翼中旗",
					"id": "150927",
					"child": []
				}, {
					"name": "察哈尔右翼前旗",
					"id": "150926",
					"child": []
				}, {
					"name": "凉城县",
					"id": "150925",
					"child": []
				}]
			}, {
				"name": "鄂尔多斯市",
				"id": "150600",
				"child": [{
					"name": "乌审旗",
					"id": "150626",
					"child": []
				}, {
					"name": "伊金霍洛旗",
					"id": "150627",
					"child": []
				}, {
					"name": "东胜区",
					"id": "150602",
					"child": []
				}, {
					"name": "鄂托克旗",
					"id": "150624",
					"child": []
				}, {
					"name": "康巴什区",
					"id": "150603",
					"child": []
				}, {
					"name": "杭锦旗",
					"id": "150625",
					"child": []
				}, {
					"name": "准格尔旗",
					"id": "150622",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150601",
					"child": []
				}, {
					"name": "鄂托克前旗",
					"id": "150623",
					"child": []
				}, {
					"name": "达拉特旗",
					"id": "150621",
					"child": []
				}]
			}, {
				"name": "阿拉善盟",
				"id": "152900",
				"child": [{
					"name": "额济纳旗",
					"id": "152923",
					"child": []
				}, {
					"name": "阿拉善右旗",
					"id": "152922",
					"child": []
				}, {
					"name": "阿拉善左旗",
					"id": "152921",
					"child": []
				}]
			}, {
				"name": "呼伦贝尔市",
				"id": "150700",
				"child": [{
					"name": "新巴尔虎右旗",
					"id": "150727",
					"child": []
				}, {
					"name": "扎赉诺尔区",
					"id": "150703",
					"child": []
				}, {
					"name": "陈巴尔虎旗",
					"id": "150725",
					"child": []
				}, {
					"name": "新巴尔虎左旗",
					"id": "150726",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150701",
					"child": []
				}, {
					"name": "鄂伦春自治旗",
					"id": "150723",
					"child": []
				}, {
					"name": "海拉尔区",
					"id": "150702",
					"child": []
				}, {
					"name": "鄂温克族自治旗",
					"id": "150724",
					"child": []
				}, {
					"name": "阿荣旗",
					"id": "150721",
					"child": []
				}, {
					"name": "莫力达瓦达斡尔族自治旗",
					"id": "150722",
					"child": []
				}, {
					"name": "根河市",
					"id": "150785",
					"child": []
				}, {
					"name": "扎兰屯市",
					"id": "150783",
					"child": []
				}, {
					"name": "额尔古纳市",
					"id": "150784",
					"child": []
				}, {
					"name": "满洲里市",
					"id": "150781",
					"child": []
				}, {
					"name": "牙克石市",
					"id": "150782",
					"child": []
				}]
			}, {
				"name": "赤峰市",
				"id": "150400",
				"child": [{
					"name": "喀喇沁旗",
					"id": "150428",
					"child": []
				}, {
					"name": "宁城县",
					"id": "150429",
					"child": []
				}, {
					"name": "松山区",
					"id": "150404",
					"child": []
				}, {
					"name": "翁牛特旗",
					"id": "150426",
					"child": []
				}, {
					"name": "红山区",
					"id": "150402",
					"child": []
				}, {
					"name": "林西县",
					"id": "150424",
					"child": []
				}, {
					"name": "元宝山区",
					"id": "150403",
					"child": []
				}, {
					"name": "克什克腾旗",
					"id": "150425",
					"child": []
				}, {
					"name": "巴林左旗",
					"id": "150422",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150401",
					"child": []
				}, {
					"name": "巴林右旗",
					"id": "150423",
					"child": []
				}, {
					"name": "阿鲁科尔沁旗",
					"id": "150421",
					"child": []
				}, {
					"name": "敖汉旗",
					"id": "150430",
					"child": []
				}]
			}, {
				"name": "通辽市",
				"id": "150500",
				"child": [{
					"name": "奈曼旗",
					"id": "150525",
					"child": []
				}, {
					"name": "扎鲁特旗",
					"id": "150526",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150501",
					"child": []
				}, {
					"name": "开鲁县",
					"id": "150523",
					"child": []
				}, {
					"name": "科尔沁区",
					"id": "150502",
					"child": []
				}, {
					"name": "库伦旗",
					"id": "150524",
					"child": []
				}, {
					"name": "科尔沁左翼中旗",
					"id": "150521",
					"child": []
				}, {
					"name": "科尔沁左翼后旗",
					"id": "150522",
					"child": []
				}, {
					"name": "霍林郭勒市",
					"id": "150581",
					"child": []
				}]
			}, {
				"name": "包头市",
				"id": "150200",
				"child": [{
					"name": "白云鄂博矿区",
					"id": "150206",
					"child": []
				}, {
					"name": "九原区",
					"id": "150207",
					"child": []
				}, {
					"name": "青山区",
					"id": "150204",
					"child": []
				}, {
					"name": "石拐区",
					"id": "150205",
					"child": []
				}, {
					"name": "东河区",
					"id": "150202",
					"child": []
				}, {
					"name": "昆都仑区",
					"id": "150203",
					"child": []
				}, {
					"name": "固阳县",
					"id": "150222",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150201",
					"child": []
				}, {
					"name": "达尔罕茂明安联合旗",
					"id": "150223",
					"child": []
				}, {
					"name": "土默特右旗",
					"id": "150221",
					"child": []
				}]
			}, {
				"name": "锡林郭勒盟",
				"id": "152500",
				"child": [{
					"name": "正镶白旗",
					"id": "152529",
					"child": []
				}, {
					"name": "镶黄旗",
					"id": "152528",
					"child": []
				}, {
					"name": "太仆寺旗",
					"id": "152527",
					"child": []
				}, {
					"name": "西乌珠穆沁旗",
					"id": "152526",
					"child": []
				}, {
					"name": "东乌珠穆沁旗",
					"id": "152525",
					"child": []
				}, {
					"name": "锡林浩特市",
					"id": "152502",
					"child": []
				}, {
					"name": "苏尼特右旗",
					"id": "152524",
					"child": []
				}, {
					"name": "二连浩特市",
					"id": "152501",
					"child": []
				}, {
					"name": "苏尼特左旗",
					"id": "152523",
					"child": []
				}, {
					"name": "阿巴嘎旗",
					"id": "152522",
					"child": []
				}, {
					"name": "多伦县",
					"id": "152531",
					"child": []
				}, {
					"name": "正蓝旗",
					"id": "152530",
					"child": []
				}]
			}, {
				"name": "乌海市",
				"id": "150300",
				"child": [{
					"name": "海南区",
					"id": "150303",
					"child": []
				}, {
					"name": "乌达区",
					"id": "150304",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150301",
					"child": []
				}, {
					"name": "海勃湾区",
					"id": "150302",
					"child": []
				}]
			}, {
				"name": "呼和浩特市",
				"id": "150100",
				"child": [{
					"name": "赛罕区",
					"id": "150105",
					"child": []
				}, {
					"name": "回民区",
					"id": "150103",
					"child": []
				}, {
					"name": "武川县",
					"id": "150125",
					"child": []
				}, {
					"name": "玉泉区",
					"id": "150104",
					"child": []
				}, {
					"name": "市辖区",
					"id": "150101",
					"child": []
				}, {
					"name": "和林格尔县",
					"id": "150123",
					"child": []
				}, {
					"name": "新城区",
					"id": "150102",
					"child": []
				}, {
					"name": "清水河县",
					"id": "150124",
					"child": []
				}, {
					"name": "土默特左旗",
					"id": "150121",
					"child": []
				}, {
					"name": "托克托县",
					"id": "150122",
					"child": []
				}]
			}, {
				"name": "兴安盟",
				"id": "152200",
				"child": [{
					"name": "阿尔山市",
					"id": "152202",
					"child": []
				}, {
					"name": "突泉县",
					"id": "152224",
					"child": []
				}, {
					"name": "乌兰浩特市",
					"id": "152201",
					"child": []
				}, {
					"name": "扎赉特旗",
					"id": "152223",
					"child": []
				}, {
					"name": "科尔沁右翼中旗",
					"id": "152222",
					"child": []
				}, {
					"name": "科尔沁右翼前旗",
					"id": "152221",
					"child": []
				}]
			}]
		},
		{
			"name": "西藏自治区",
			"id": "540000",
			"child": [{
				"name": "山南市",
				"id": "540500",
				"child": [{
					"name": "贡嘎县",
					"id": "540522",
					"child": []
				}, {
					"name": "市辖区",
					"id": "540501",
					"child": []
				}, {
					"name": "桑日县",
					"id": "540523",
					"child": []
				}, {
					"name": "乃东区",
					"id": "540502",
					"child": []
				}, {
					"name": "琼结县",
					"id": "540524",
					"child": []
				}, {
					"name": "曲松县",
					"id": "540525",
					"child": []
				}, {
					"name": "错那县",
					"id": "540530",
					"child": []
				}, {
					"name": "浪卡子县",
					"id": "540531",
					"child": []
				}, {
					"name": "扎囊县",
					"id": "540521",
					"child": []
				}, {
					"name": "措美县",
					"id": "540526",
					"child": []
				}, {
					"name": "洛扎县",
					"id": "540527",
					"child": []
				}, {
					"name": "加查县",
					"id": "540528",
					"child": []
				}, {
					"name": "隆子县",
					"id": "540529",
					"child": []
				}]
			}, {
				"name": "拉萨市",
				"id": "540100",
				"child": [{
					"name": "达孜县",
					"id": "540126",
					"child": []
				}, {
					"name": "墨竹工卡县",
					"id": "540127",
					"child": []
				}, {
					"name": "当雄县",
					"id": "540122",
					"child": []
				}, {
					"name": "市辖区",
					"id": "540101",
					"child": []
				}, {
					"name": "尼木县",
					"id": "540123",
					"child": []
				}, {
					"name": "城关区",
					"id": "540102",
					"child": []
				}, {
					"name": "曲水县",
					"id": "540124",
					"child": []
				}, {
					"name": "堆龙德庆区",
					"id": "540103",
					"child": []
				}, {
					"name": "林周县",
					"id": "540121",
					"child": []
				}]
			}, {
				"name": "那曲地区",
				"id": "542400",
				"child": [{
					"name": "申扎县",
					"id": "542426",
					"child": []
				}, {
					"name": "安多县",
					"id": "542425",
					"child": []
				}, {
					"name": "班戈县",
					"id": "542428",
					"child": []
				}, {
					"name": "索县",
					"id": "542427",
					"child": []
				}, {
					"name": "嘉黎县",
					"id": "542422",
					"child": []
				}, {
					"name": "那曲县",
					"id": "542421",
					"child": []
				}, {
					"name": "聂荣县",
					"id": "542424",
					"child": []
				}, {
					"name": "比如县",
					"id": "542423",
					"child": []
				}, {
					"name": "双湖县",
					"id": "542431",
					"child": []
				}, {
					"name": "尼玛县",
					"id": "542430",
					"child": []
				}, {
					"name": "巴青县",
					"id": "542429",
					"child": []
				}]
			}, {
				"name": "日喀则市",
				"id": "540200",
				"child": [{
					"name": "拉孜县",
					"id": "540225",
					"child": []
				}, {
					"name": "萨嘎县",
					"id": "540236",
					"child": []
				}, {
					"name": "昂仁县",
					"id": "540226",
					"child": []
				}, {
					"name": "岗巴县",
					"id": "540237",
					"child": []
				}, {
					"name": "谢通门县",
					"id": "540227",
					"child": []
				}, {
					"name": "白朗县",
					"id": "540228",
					"child": []
				}, {
					"name": "南木林县",
					"id": "540221",
					"child": []
				}, {
					"name": "仲巴县",
					"id": "540232",
					"child": []
				}, {
					"name": "江孜县",
					"id": "540222",
					"child": []
				}, {
					"name": "亚东县",
					"id": "540233",
					"child": []
				}, {
					"name": "定日县",
					"id": "540223",
					"child": []
				}, {
					"name": "吉隆县",
					"id": "540234",
					"child": []
				}, {
					"name": "桑珠孜区",
					"id": "540202",
					"child": []
				}, {
					"name": "萨迦县",
					"id": "540224",
					"child": []
				}, {
					"name": "聂拉木县",
					"id": "540235",
					"child": []
				}, {
					"name": "仁布县",
					"id": "540229",
					"child": []
				}, {
					"name": "康马县",
					"id": "540230",
					"child": []
				}, {
					"name": "定结县",
					"id": "540231",
					"child": []
				}]
			}, {
				"name": "昌都市",
				"id": "540300",
				"child": [{
					"name": "卡若区",
					"id": "540302",
					"child": []
				}, {
					"name": "丁青县",
					"id": "540324",
					"child": []
				}, {
					"name": "察雅县",
					"id": "540325",
					"child": []
				}, {
					"name": "八宿县",
					"id": "540326",
					"child": []
				}, {
					"name": "左贡县",
					"id": "540327",
					"child": []
				}, {
					"name": "江达县",
					"id": "540321",
					"child": []
				}, {
					"name": "贡觉县",
					"id": "540322",
					"child": []
				}, {
					"name": "类乌齐县",
					"id": "540323",
					"child": []
				}, {
					"name": "边坝县",
					"id": "540330",
					"child": []
				}, {
					"name": "芒康县",
					"id": "540328",
					"child": []
				}, {
					"name": "洛隆县",
					"id": "540329",
					"child": []
				}]
			}, {
				"name": "林芝市",
				"id": "540400",
				"child": [{
					"name": "墨脱县",
					"id": "540423",
					"child": []
				}, {
					"name": "巴宜区",
					"id": "540402",
					"child": []
				}, {
					"name": "波密县",
					"id": "540424",
					"child": []
				}, {
					"name": "察隅县",
					"id": "540425",
					"child": []
				}, {
					"name": "朗县",
					"id": "540426",
					"child": []
				}, {
					"name": "工布江达县",
					"id": "540421",
					"child": []
				}, {
					"name": "米林县",
					"id": "540422",
					"child": []
				}]
			}, {
				"name": "阿里地区",
				"id": "542500",
				"child": [{
					"name": "革吉县",
					"id": "542525",
					"child": []
				}, {
					"name": "日土县",
					"id": "542524",
					"child": []
				}, {
					"name": "措勤县",
					"id": "542527",
					"child": []
				}, {
					"name": "改则县",
					"id": "542526",
					"child": []
				}, {
					"name": "普兰县",
					"id": "542521",
					"child": []
				}, {
					"name": "噶尔县",
					"id": "542523",
					"child": []
				}, {
					"name": "札达县",
					"id": "542522",
					"child": []
				}]
			}]
		},
		{
			"name": "广西壮族自治区",
			"id": "450000",
			"child": [{
				"name": "贵港市",
				"id": "450800",
				"child": [{
					"name": "覃塘区",
					"id": "450804",
					"child": []
				}, {
					"name": "港南区",
					"id": "450803",
					"child": []
				}, {
					"name": "平南县",
					"id": "450821",
					"child": []
				}, {
					"name": "港北区",
					"id": "450802",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450801",
					"child": []
				}, {
					"name": "桂平市",
					"id": "450881",
					"child": []
				}]
			}, {
				"name": "钦州市",
				"id": "450700",
				"child": [{
					"name": "市辖区",
					"id": "450701",
					"child": []
				}, {
					"name": "浦北县",
					"id": "450722",
					"child": []
				}, {
					"name": "钦北区",
					"id": "450703",
					"child": []
				}, {
					"name": "钦南区",
					"id": "450702",
					"child": []
				}, {
					"name": "灵山县",
					"id": "450721",
					"child": []
				}]
			}, {
				"name": "玉林市",
				"id": "450900",
				"child": [{
					"name": "福绵区",
					"id": "450903",
					"child": []
				}, {
					"name": "玉州区",
					"id": "450902",
					"child": []
				}, {
					"name": "兴业县",
					"id": "450924",
					"child": []
				}, {
					"name": "容县",
					"id": "450921",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450901",
					"child": []
				}, {
					"name": "博白县",
					"id": "450923",
					"child": []
				}, {
					"name": "陆川县",
					"id": "450922",
					"child": []
				}, {
					"name": "北流市",
					"id": "450981",
					"child": []
				}]
			}, {
				"name": "梧州市",
				"id": "450400",
				"child": [{
					"name": "岑溪市",
					"id": "450481",
					"child": []
				}, {
					"name": "万秀区",
					"id": "450403",
					"child": []
				}, {
					"name": "龙圩区",
					"id": "450406",
					"child": []
				}, {
					"name": "长洲区",
					"id": "450405",
					"child": []
				}, {
					"name": "藤县",
					"id": "450422",
					"child": []
				}, {
					"name": "苍梧县",
					"id": "450421",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450401",
					"child": []
				}, {
					"name": "蒙山县",
					"id": "450423",
					"child": []
				}]
			}, {
				"name": "桂林市",
				"id": "450300",
				"child": [{
					"name": "七星区",
					"id": "450305",
					"child": []
				}, {
					"name": "灌阳县",
					"id": "450327",
					"child": []
				}, {
					"name": "象山区",
					"id": "450304",
					"child": []
				}, {
					"name": "永福县",
					"id": "450326",
					"child": []
				}, {
					"name": "资源县",
					"id": "450329",
					"child": []
				}, {
					"name": "龙胜各族自治县",
					"id": "450328",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450301",
					"child": []
				}, {
					"name": "临桂区",
					"id": "450312",
					"child": []
				}, {
					"name": "灵川县",
					"id": "450323",
					"child": []
				}, {
					"name": "雁山区",
					"id": "450311",
					"child": []
				}, {
					"name": "叠彩区",
					"id": "450303",
					"child": []
				}, {
					"name": "兴安县",
					"id": "450325",
					"child": []
				}, {
					"name": "秀峰区",
					"id": "450302",
					"child": []
				}, {
					"name": "全州县",
					"id": "450324",
					"child": []
				}, {
					"name": "平乐县",
					"id": "450330",
					"child": []
				}, {
					"name": "阳朔县",
					"id": "450321",
					"child": []
				}, {
					"name": "恭城瑶族自治县",
					"id": "450332",
					"child": []
				}, {
					"name": "荔浦县",
					"id": "450331",
					"child": []
				}]
			}, {
				"name": "崇左市",
				"id": "451400",
				"child": [{
					"name": "凭祥市",
					"id": "451481",
					"child": []
				}, {
					"name": "市辖区",
					"id": "451401",
					"child": []
				}, {
					"name": "龙州县",
					"id": "451423",
					"child": []
				}, {
					"name": "宁明县",
					"id": "451422",
					"child": []
				}, {
					"name": "天等县",
					"id": "451425",
					"child": []
				}, {
					"name": "江州区",
					"id": "451402",
					"child": []
				}, {
					"name": "大新县",
					"id": "451424",
					"child": []
				}, {
					"name": "扶绥县",
					"id": "451421",
					"child": []
				}]
			}, {
				"name": "防城港市",
				"id": "450600",
				"child": [{
					"name": "港口区",
					"id": "450602",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450601",
					"child": []
				}, {
					"name": "防城区",
					"id": "450603",
					"child": []
				}, {
					"name": "上思县",
					"id": "450621",
					"child": []
				}, {
					"name": "东兴市",
					"id": "450681",
					"child": []
				}]
			}, {
				"name": "北海市",
				"id": "450500",
				"child": [{
					"name": "银海区",
					"id": "450503",
					"child": []
				}, {
					"name": "海城区",
					"id": "450502",
					"child": []
				}, {
					"name": "合浦县",
					"id": "450521",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450501",
					"child": []
				}, {
					"name": "铁山港区",
					"id": "450512",
					"child": []
				}]
			}, {
				"name": "贺州市",
				"id": "451100",
				"child": [{
					"name": "平桂区",
					"id": "451103",
					"child": []
				}, {
					"name": "钟山县",
					"id": "451122",
					"child": []
				}, {
					"name": "昭平县",
					"id": "451121",
					"child": []
				}, {
					"name": "八步区",
					"id": "451102",
					"child": []
				}, {
					"name": "市辖区",
					"id": "451101",
					"child": []
				}, {
					"name": "富川瑶族自治县",
					"id": "451123",
					"child": []
				}]
			}, {
				"name": "百色市",
				"id": "451000",
				"child": [{
					"name": "西林县",
					"id": "451030",
					"child": []
				}, {
					"name": "田阳县",
					"id": "451021",
					"child": []
				}, {
					"name": "隆林各族自治县",
					"id": "451031",
					"child": []
				}, {
					"name": "靖西市",
					"id": "451081",
					"child": []
				}, {
					"name": "凌云县",
					"id": "451027",
					"child": []
				}, {
					"name": "那坡县",
					"id": "451026",
					"child": []
				}, {
					"name": "田林县",
					"id": "451029",
					"child": []
				}, {
					"name": "乐业县",
					"id": "451028",
					"child": []
				}, {
					"name": "市辖区",
					"id": "451001",
					"child": []
				}, {
					"name": "平果县",
					"id": "451023",
					"child": []
				}, {
					"name": "田东县",
					"id": "451022",
					"child": []
				}, {
					"name": "右江区",
					"id": "451002",
					"child": []
				}, {
					"name": "德保县",
					"id": "451024",
					"child": []
				}]
			}, {
				"name": "柳州市",
				"id": "450200",
				"child": [{
					"name": "柳江区",
					"id": "450206",
					"child": []
				}, {
					"name": "柳北区",
					"id": "450205",
					"child": []
				}, {
					"name": "城中区",
					"id": "450202",
					"child": []
				}, {
					"name": "融安县",
					"id": "450224",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450201",
					"child": []
				}, {
					"name": "鹿寨县",
					"id": "450223",
					"child": []
				}, {
					"name": "柳南区",
					"id": "450204",
					"child": []
				}, {
					"name": "三江侗族自治县",
					"id": "450226",
					"child": []
				}, {
					"name": "鱼峰区",
					"id": "450203",
					"child": []
				}, {
					"name": "融水苗族自治县",
					"id": "450225",
					"child": []
				}, {
					"name": "柳城县",
					"id": "450222",
					"child": []
				}]
			}, {
				"name": "来宾市",
				"id": "451300",
				"child": [{
					"name": "合山市",
					"id": "451381",
					"child": []
				}, {
					"name": "兴宾区",
					"id": "451302",
					"child": []
				}, {
					"name": "金秀瑶族自治县",
					"id": "451324",
					"child": []
				}, {
					"name": "市辖区",
					"id": "451301",
					"child": []
				}, {
					"name": "武宣县",
					"id": "451323",
					"child": []
				}, {
					"name": "象州县",
					"id": "451322",
					"child": []
				}, {
					"name": "忻城县",
					"id": "451321",
					"child": []
				}]
			}, {
				"name": "南宁市",
				"id": "450100",
				"child": [{
					"name": "西乡塘区",
					"id": "450107",
					"child": []
				}, {
					"name": "邕宁区",
					"id": "450109",
					"child": []
				}, {
					"name": "良庆区",
					"id": "450108",
					"child": []
				}, {
					"name": "青秀区",
					"id": "450103",
					"child": []
				}, {
					"name": "上林县",
					"id": "450125",
					"child": []
				}, {
					"name": "兴宁区",
					"id": "450102",
					"child": []
				}, {
					"name": "马山县",
					"id": "450124",
					"child": []
				}, {
					"name": "江南区",
					"id": "450105",
					"child": []
				}, {
					"name": "横县",
					"id": "450127",
					"child": []
				}, {
					"name": "宾阳县",
					"id": "450126",
					"child": []
				}, {
					"name": "武鸣区",
					"id": "450110",
					"child": []
				}, {
					"name": "市辖区",
					"id": "450101",
					"child": []
				}, {
					"name": "隆安县",
					"id": "450123",
					"child": []
				}]
			}, {
				"name": "河池市",
				"id": "451200",
				"child": [{
					"name": "大化瑶族自治县",
					"id": "451229",
					"child": []
				}, {
					"name": "都安瑶族自治县",
					"id": "451228",
					"child": []
				}, {
					"name": "宜州市",
					"id": "451281",
					"child": []
				}, {
					"name": "罗城仫佬族自治县",
					"id": "451225",
					"child": []
				}, {
					"name": "金城江区",
					"id": "451202",
					"child": []
				}, {
					"name": "东兰县",
					"id": "451224",
					"child": []
				}, {
					"name": "巴马瑶族自治县",
					"id": "451227",
					"child": []
				}, {
					"name": "环江毛南族自治县",
					"id": "451226",
					"child": []
				}, {
					"name": "南丹县",
					"id": "451221",
					"child": []
				}, {
					"name": "市辖区",
					"id": "451201",
					"child": []
				}, {
					"name": "凤山县",
					"id": "451223",
					"child": []
				}, {
					"name": "天峨县",
					"id": "451222",
					"child": []
				}]
			}]
		}
	]

}

module.exports = provinces



// WEBPACK FOOTER //
// ./src/api/provinces.js